{
  "qca": [
    {
      "qca_id": 1,
      "code": "QCA-001",
      "name": "MH_MANIKARAN",
      "address": "Jalgaon, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 1",
      "mobile": "9832685825",
      "email": "qca1@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 2,
      "code": "QCA-002",
      "name": "MH_RECONNECT",
      "address": "Nashik, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 2",
      "mobile": "9878594899",
      "email": "qca2@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 3,
      "code": "QCA-003",
      "name": "MH_STATKRAFT",
      "address": "Kolhapur, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 3",
      "mobile": "9819257142",
      "email": "qca3@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 4,
      "code": "QCA-004",
      "name": "MH_VEDANJAY",
      "address": "Kolhapur, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 4",
      "mobile": "9884241246",
      "email": "qca4@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 5,
      "code": "QCA-005",
      "name": "MH_KREATE",
      "address": "Satara, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 5",
      "mobile": "9882338658",
      "email": "qca5@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 6,
      "code": "QCA-006",
      "name": "MH_TPREL",
      "address": "Mumbai, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 6",
      "mobile": "9865231132",
      "email": "qca6@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 7,
      "code": "QCA-007",
      "name": "MH_CLEAN",
      "address": "Mumbai, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 7",
      "mobile": "9879031263",
      "email": "qca7@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 8,
      "code": "QCA-008",
      "name": "MH_WALWHAN",
      "address": "Nashik, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 8",
      "mobile": "9867854782",
      "email": "qca8@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 9,
      "code": "QCA-009",
      "name": "MH_MSEDCL",
      "address": "Jalgaon, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 9",
      "mobile": "9877187263",
      "email": "qca9@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 10,
      "code": "QCA-010",
      "name": "MH_SHARDA",
      "address": "Aurangabad, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 10",
      "mobile": "9883362339",
      "email": "qca10@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 11,
      "code": "QCA-011",
      "name": "Solar Energy QCA 11",
      "address": "Satara, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 11",
      "mobile": "9816976485",
      "email": "qca11@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 12,
      "code": "QCA-012",
      "name": "Hybrid Energy QCA 12",
      "address": "Aurangabad, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 12",
      "mobile": "9860491041",
      "email": "qca12@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 13,
      "code": "QCA-013",
      "name": "Wind Energy QCA 13",
      "address": "Solapur, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 13",
      "mobile": "9837182009",
      "email": "qca13@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 14,
      "code": "QCA-014",
      "name": "Solar Energy QCA 14",
      "address": "Jalgaon, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 14",
      "mobile": "9878988835",
      "email": "qca14@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 15,
      "code": "QCA-015",
      "name": "Hybrid Energy QCA 15",
      "address": "Aurangabad, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 15",
      "mobile": "9821618298",
      "email": "qca15@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 16,
      "code": "QCA-016",
      "name": "Solar Energy QCA 16",
      "address": "Nashik, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 16",
      "mobile": "9883802109",
      "email": "qca16@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 17,
      "code": "QCA-017",
      "name": "Solar Energy QCA 17",
      "address": "Kolhapur, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 17",
      "mobile": "9876166061",
      "email": "qca17@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 18,
      "code": "QCA-018",
      "name": "Wind Energy QCA 18",
      "address": "Aurangabad, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 18",
      "mobile": "9813277890",
      "email": "qca18@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 19,
      "code": "QCA-019",
      "name": "Solar Energy QCA 19",
      "address": "Aurangabad, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 19",
      "mobile": "9866914956",
      "email": "qca19@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 20,
      "code": "QCA-020",
      "name": "Hybrid Energy QCA 20",
      "address": "Jalgaon, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 20",
      "mobile": "9857600573",
      "email": "qca20@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 21,
      "code": "QCA-021",
      "name": "Wind Energy QCA 21",
      "address": "Ahmednagar, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 21",
      "mobile": "9814061899",
      "email": "qca21@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 22,
      "code": "QCA-022",
      "name": "Hybrid Energy QCA 22",
      "address": "Nagpur, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 22",
      "mobile": "9856950650",
      "email": "qca22@msldc.in",
      "status": "Active"
    },
    {
      "qca_id": 23,
      "code": "QCA-023",
      "name": "Solar Energy QCA 23",
      "address": "Aurangabad, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 23",
      "mobile": "9849697701",
      "email": "qca23@msldc.in",
      "status": "Inactive"
    },
    {
      "qca_id": 24,
      "code": "QCA-024",
      "name": "Solar Energy QCA 24",
      "address": "Pune, Maharashtra",
      "state": "Maharashtra",
      "contact_person": "Person 24",
      "mobile": "9871484056",
      "email": "qca24@msldc.in",
      "status": "Inactive"
    }
  ],
  "pss": [
    {
      "pss_id": 1,
      "code": "PSS-001",
      "name": "Ahmednagar PSS 1",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 1,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 2,
      "code": "PSS-002",
      "name": "Solapur PSS 2",
      "district": "Kolhapur",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 2,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 3,
      "code": "PSS-003",
      "name": "Jalgaon PSS 3",
      "district": "Nashik",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 3,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 4,
      "code": "PSS-004",
      "name": "Kolhapur PSS 4",
      "district": "Mumbai",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 4,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 5,
      "code": "PSS-005",
      "name": "Jalgaon PSS 5",
      "district": "Amravati",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 5,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 6,
      "code": "PSS-006",
      "name": "Solapur PSS 6",
      "district": "Ahmednagar",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 6,
      "installed_capacity_mw": 600,
      "status": "Active"
    },
    {
      "pss_id": 7,
      "code": "PSS-007",
      "name": "Nashik PSS 7",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 7,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 8,
      "code": "PSS-008",
      "name": "Amravati PSS 8",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 8,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 9,
      "code": "PSS-009",
      "name": "Kolhapur PSS 9",
      "district": "Latur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 9,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 10,
      "code": "PSS-010",
      "name": "Amravati PSS 10",
      "district": "Latur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 10,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 11,
      "code": "PSS-011",
      "name": "Nagpur PSS 11",
      "district": "Mumbai",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 11,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 12,
      "code": "PSS-012",
      "name": "Kolhapur PSS 12",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 12,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 13,
      "code": "PSS-013",
      "name": "Jalgaon PSS 13",
      "district": "Latur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 13,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 14,
      "code": "PSS-014",
      "name": "Aurangabad PSS 14",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 14,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 15,
      "code": "PSS-015",
      "name": "Mumbai PSS 15",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 15,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 16,
      "code": "PSS-016",
      "name": "Latur PSS 16",
      "district": "Latur",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 16,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 17,
      "code": "PSS-017",
      "name": "Latur PSS 17",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 17,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 18,
      "code": "PSS-018",
      "name": "Satara PSS 18",
      "district": "Ahmednagar",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 18,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 19,
      "code": "PSS-019",
      "name": "Ahmednagar PSS 19",
      "district": "Latur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 19,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 20,
      "code": "PSS-020",
      "name": "Kolhapur PSS 20",
      "district": "Satara",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 20,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 21,
      "code": "PSS-021",
      "name": "Nashik PSS 21",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 21,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 22,
      "code": "PSS-022",
      "name": "Pune PSS 22",
      "district": "Amravati",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 22,
      "installed_capacity_mw": 600,
      "status": "Active"
    },
    {
      "pss_id": 23,
      "code": "PSS-023",
      "name": "Solapur PSS 23",
      "district": "Kolhapur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 23,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 24,
      "code": "PSS-024",
      "name": "Solapur PSS 24",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 24,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 25,
      "code": "PSS-025",
      "name": "Ahmednagar PSS 25",
      "district": "Kolhapur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 1,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 26,
      "code": "PSS-026",
      "name": "Amravati PSS 26",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 2,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 27,
      "code": "PSS-027",
      "name": "Nagpur PSS 27",
      "district": "Ahmednagar",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 3,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 28,
      "code": "PSS-028",
      "name": "Kolhapur PSS 28",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 4,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 29,
      "code": "PSS-029",
      "name": "Amravati PSS 29",
      "district": "Nagpur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 5,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 30,
      "code": "PSS-030",
      "name": "Satara PSS 30",
      "district": "Mumbai",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 6,
      "installed_capacity_mw": 600,
      "status": "Active"
    },
    {
      "pss_id": 31,
      "code": "PSS-031",
      "name": "Nashik PSS 31",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 7,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 32,
      "code": "PSS-032",
      "name": "Aurangabad PSS 32",
      "district": "Satara",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 8,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 33,
      "code": "PSS-033",
      "name": "Kolhapur PSS 33",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 9,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 34,
      "code": "PSS-034",
      "name": "Nagpur PSS 34",
      "district": "Kolhapur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 10,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 35,
      "code": "PSS-035",
      "name": "Aurangabad PSS 35",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 11,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 36,
      "code": "PSS-036",
      "name": "Solapur PSS 36",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 12,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 37,
      "code": "PSS-037",
      "name": "Latur PSS 37",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 13,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 38,
      "code": "PSS-038",
      "name": "Jalgaon PSS 38",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 14,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 39,
      "code": "PSS-039",
      "name": "Aurangabad PSS 39",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 15,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 40,
      "code": "PSS-040",
      "name": "Nashik PSS 40",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 16,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 41,
      "code": "PSS-041",
      "name": "Jalgaon PSS 41",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 17,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 42,
      "code": "PSS-042",
      "name": "Jalgaon PSS 42",
      "district": "Satara",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 18,
      "installed_capacity_mw": 600,
      "status": "Active"
    },
    {
      "pss_id": 43,
      "code": "PSS-043",
      "name": "Kolhapur PSS 43",
      "district": "Nashik",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 19,
      "installed_capacity_mw": 600,
      "status": "Active"
    },
    {
      "pss_id": 44,
      "code": "PSS-044",
      "name": "Nashik PSS 44",
      "district": "Kolhapur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 20,
      "installed_capacity_mw": 600,
      "status": "Active"
    },
    {
      "pss_id": 45,
      "code": "PSS-045",
      "name": "Pune PSS 45",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 21,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 46,
      "code": "PSS-046",
      "name": "Nagpur PSS 46",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 22,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 47,
      "code": "PSS-047",
      "name": "Satara PSS 47",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 23,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 48,
      "code": "PSS-048",
      "name": "Pune PSS 48",
      "district": "Nagpur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 24,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 49,
      "code": "PSS-049",
      "name": "Ahmednagar PSS 49",
      "district": "Nagpur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 1,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 50,
      "code": "PSS-050",
      "name": "Kolhapur PSS 50",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 2,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 51,
      "code": "PSS-051",
      "name": "Satara PSS 51",
      "district": "Kolhapur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 3,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 52,
      "code": "PSS-052",
      "name": "Amravati PSS 52",
      "district": "Kolhapur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 4,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 53,
      "code": "PSS-053",
      "name": "Mumbai PSS 53",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 5,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 54,
      "code": "PSS-054",
      "name": "Nagpur PSS 54",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 6,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 55,
      "code": "PSS-055",
      "name": "Jalgaon PSS 55",
      "district": "Satara",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 7,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 56,
      "code": "PSS-056",
      "name": "Satara PSS 56",
      "district": "Nashik",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 8,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 57,
      "code": "PSS-057",
      "name": "Amravati PSS 57",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 9,
      "installed_capacity_mw": 600,
      "status": "Active"
    },
    {
      "pss_id": 58,
      "code": "PSS-058",
      "name": "Jalgaon PSS 58",
      "district": "Latur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 10,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 59,
      "code": "PSS-059",
      "name": "Ahmednagar PSS 59",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 11,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 60,
      "code": "PSS-060",
      "name": "Jalgaon PSS 60",
      "district": "Nagpur",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 12,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 61,
      "code": "PSS-061",
      "name": "Nagpur PSS 61",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 13,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 62,
      "code": "PSS-062",
      "name": "Solapur PSS 62",
      "district": "Amravati",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 14,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 63,
      "code": "PSS-063",
      "name": "Latur PSS 63",
      "district": "Mumbai",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 15,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 64,
      "code": "PSS-064",
      "name": "Latur PSS 64",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 16,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 65,
      "code": "PSS-065",
      "name": "Ahmednagar PSS 65",
      "district": "Nagpur",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 17,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 66,
      "code": "PSS-066",
      "name": "Ahmednagar PSS 66",
      "district": "Satara",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 18,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 67,
      "code": "PSS-067",
      "name": "Nashik PSS 67",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 19,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 68,
      "code": "PSS-068",
      "name": "Mumbai PSS 68",
      "district": "Nashik",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 20,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 69,
      "code": "PSS-069",
      "name": "Nashik PSS 69",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 21,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 70,
      "code": "PSS-070",
      "name": "Amravati PSS 70",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 22,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 71,
      "code": "PSS-071",
      "name": "Nashik PSS 71",
      "district": "Satara",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 23,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 72,
      "code": "PSS-072",
      "name": "Satara PSS 72",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 24,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 73,
      "code": "PSS-073",
      "name": "Solapur PSS 73",
      "district": "Mumbai",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 1,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 74,
      "code": "PSS-074",
      "name": "Ahmednagar PSS 74",
      "district": "Satara",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 2,
      "installed_capacity_mw": 600,
      "status": "Active"
    },
    {
      "pss_id": 75,
      "code": "PSS-075",
      "name": "Latur PSS 75",
      "district": "Kolhapur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 3,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 76,
      "code": "PSS-076",
      "name": "Solapur PSS 76",
      "district": "Amravati",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 4,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 77,
      "code": "PSS-077",
      "name": "Satara PSS 77",
      "district": "Nashik",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 5,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 78,
      "code": "PSS-078",
      "name": "Nashik PSS 78",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 6,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 79,
      "code": "PSS-079",
      "name": "Pune PSS 79",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 7,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 80,
      "code": "PSS-080",
      "name": "Latur PSS 80",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 8,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 81,
      "code": "PSS-081",
      "name": "Amravati PSS 81",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 9,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 82,
      "code": "PSS-082",
      "name": "Kolhapur PSS 82",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 10,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 83,
      "code": "PSS-083",
      "name": "Satara PSS 83",
      "district": "Kolhapur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 11,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 84,
      "code": "PSS-084",
      "name": "Latur PSS 84",
      "district": "Nagpur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 12,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 85,
      "code": "PSS-085",
      "name": "Pune PSS 85",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 13,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 86,
      "code": "PSS-086",
      "name": "Ahmednagar PSS 86",
      "district": "Nashik",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 14,
      "installed_capacity_mw": 600,
      "status": "Active"
    },
    {
      "pss_id": 87,
      "code": "PSS-087",
      "name": "Pune PSS 87",
      "district": "Satara",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 15,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 88,
      "code": "PSS-088",
      "name": "Ahmednagar PSS 88",
      "district": "Latur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 16,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 89,
      "code": "PSS-089",
      "name": "Nagpur PSS 89",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 17,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 90,
      "code": "PSS-090",
      "name": "Satara PSS 90",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 18,
      "installed_capacity_mw": 400,
      "status": "Active"
    },
    {
      "pss_id": 91,
      "code": "PSS-091",
      "name": "Aurangabad PSS 91",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 19,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 92,
      "code": "PSS-092",
      "name": "Satara PSS 92",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 20,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 93,
      "code": "PSS-093",
      "name": "Nagpur PSS 93",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 21,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 94,
      "code": "PSS-094",
      "name": "Satara PSS 94",
      "district": "Amravati",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 22,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 95,
      "code": "PSS-095",
      "name": "Amravati PSS 95",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 23,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 96,
      "code": "PSS-096",
      "name": "Ahmednagar PSS 96",
      "district": "Ahmednagar",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 24,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 97,
      "code": "PSS-097",
      "name": "Kolhapur PSS 97",
      "district": "Ahmednagar",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 1,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 98,
      "code": "PSS-098",
      "name": "Jalgaon PSS 98",
      "district": "Ahmednagar",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 2,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 99,
      "code": "PSS-099",
      "name": "Kolhapur PSS 99",
      "district": "Satara",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 3,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 100,
      "code": "PSS-100",
      "name": "Solapur PSS 100",
      "district": "Nagpur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 4,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 101,
      "code": "PSS-101",
      "name": "Nagpur PSS 101",
      "district": "Mumbai",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 5,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 102,
      "code": "PSS-102",
      "name": "Pune PSS 102",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 6,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 103,
      "code": "PSS-103",
      "name": "Satara PSS 103",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 7,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 104,
      "code": "PSS-104",
      "name": "Aurangabad PSS 104",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 8,
      "installed_capacity_mw": 150,
      "status": "Active"
    },
    {
      "pss_id": 105,
      "code": "PSS-105",
      "name": "Nashik PSS 105",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 9,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 106,
      "code": "PSS-106",
      "name": "Jalgaon PSS 106",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 10,
      "installed_capacity_mw": 250,
      "status": "Active"
    },
    {
      "pss_id": 107,
      "code": "PSS-107",
      "name": "Satara PSS 107",
      "district": "Nashik",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 11,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 108,
      "code": "PSS-108",
      "name": "Solapur PSS 108",
      "district": "Amravati",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 12,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 109,
      "code": "PSS-109",
      "name": "Jalgaon PSS 109",
      "district": "Aurangabad",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 13,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 110,
      "code": "PSS-110",
      "name": "Nashik PSS 110",
      "district": "Nashik",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 14,
      "installed_capacity_mw": 100,
      "status": "Active"
    },
    {
      "pss_id": 111,
      "code": "PSS-111",
      "name": "Amravati PSS 111",
      "district": "Nagpur",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 15,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 112,
      "code": "PSS-112",
      "name": "Nashik PSS 112",
      "district": "Latur",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 16,
      "installed_capacity_mw": 600,
      "status": "Active"
    },
    {
      "pss_id": 113,
      "code": "PSS-113",
      "name": "Ahmednagar PSS 113",
      "district": "Pune",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 17,
      "installed_capacity_mw": 500,
      "status": "Active"
    },
    {
      "pss_id": 114,
      "code": "PSS-114",
      "name": "Nashik PSS 114",
      "district": "Jalgaon",
      "state": "Maharashtra",
      "voltage_kv": 220,
      "qca_id": 18,
      "installed_capacity_mw": 300,
      "status": "Active"
    },
    {
      "pss_id": 115,
      "code": "PSS-115",
      "name": "Nagpur PSS 115",
      "district": "Solapur",
      "state": "Maharashtra",
      "voltage_kv": 132,
      "qca_id": 19,
      "installed_capacity_mw": 200,
      "status": "Active"
    },
    {
      "pss_id": 116,
      "code": "PSS-116",
      "name": "Satara PSS 116",
      "district": "Mumbai",
      "state": "Maharashtra",
      "voltage_kv": 400,
      "qca_id": 20,
      "installed_capacity_mw": 150,
      "status": "Active"
    }
  ],
  "generators": [
    {
      "generator_id": 1,
      "name": "SolarOne Plant 1",
      "type": "Solar",
      "qca_id": 1,
      "pss_id": 1,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 2,
      "name": "WindStar Plant 2",
      "type": "Solar",
      "qca_id": 2,
      "pss_id": 2,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 3,
      "name": "SunPower Plant 3",
      "type": "Solar",
      "qca_id": 3,
      "pss_id": 3,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 4,
      "name": "SolarOne Plant 4",
      "type": "Wind",
      "qca_id": 4,
      "pss_id": 4,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 5,
      "name": "WindStar Plant 5",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 5,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 6,
      "name": "SolarOne Plant 6",
      "type": "Wind",
      "qca_id": 6,
      "pss_id": 6,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 7,
      "name": "GreenWind Plant 7",
      "type": "Solar",
      "qca_id": 7,
      "pss_id": 7,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 8,
      "name": "SunPower Plant 8",
      "type": "Wind",
      "qca_id": 8,
      "pss_id": 8,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 9,
      "name": "EcoHybrid Plant 9",
      "type": "Hybrid",
      "qca_id": 9,
      "pss_id": 9,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 10,
      "name": "SolarOne Plant 10",
      "type": "Wind",
      "qca_id": 10,
      "pss_id": 10,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 11,
      "name": "SunPower Plant 11",
      "type": "Hybrid",
      "qca_id": 11,
      "pss_id": 11,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 12,
      "name": "SunPower Plant 12",
      "type": "Hybrid",
      "qca_id": 12,
      "pss_id": 12,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 13,
      "name": "EcoHybrid Plant 13",
      "type": "Hybrid",
      "qca_id": 13,
      "pss_id": 13,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 14,
      "name": "EcoHybrid Plant 14",
      "type": "Wind",
      "qca_id": 14,
      "pss_id": 14,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 15,
      "name": "SolarOne Plant 15",
      "type": "Hybrid",
      "qca_id": 15,
      "pss_id": 15,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 16,
      "name": "GreenWind Plant 16",
      "type": "Solar",
      "qca_id": 16,
      "pss_id": 16,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 17,
      "name": "SolarOne Plant 17",
      "type": "Solar",
      "qca_id": 17,
      "pss_id": 17,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 18,
      "name": "SunPower Plant 18",
      "type": "Solar",
      "qca_id": 18,
      "pss_id": 18,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 19,
      "name": "SunPower Plant 19",
      "type": "Wind",
      "qca_id": 19,
      "pss_id": 19,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 20,
      "name": "SolarOne Plant 20",
      "type": "Solar",
      "qca_id": 20,
      "pss_id": 20,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 21,
      "name": "SunPower Plant 21",
      "type": "Hybrid",
      "qca_id": 21,
      "pss_id": 21,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 22,
      "name": "GreenWind Plant 22",
      "type": "Solar",
      "qca_id": 22,
      "pss_id": 22,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 23,
      "name": "EcoHybrid Plant 23",
      "type": "Wind",
      "qca_id": 23,
      "pss_id": 23,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 24,
      "name": "SolarOne Plant 24",
      "type": "Hybrid",
      "qca_id": 24,
      "pss_id": 24,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 25,
      "name": "SunPower Plant 25",
      "type": "Wind",
      "qca_id": 1,
      "pss_id": 25,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 26,
      "name": "SunPower Plant 26",
      "type": "Wind",
      "qca_id": 2,
      "pss_id": 26,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 27,
      "name": "GreenWind Plant 27",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 27,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 28,
      "name": "EcoHybrid Plant 28",
      "type": "Wind",
      "qca_id": 4,
      "pss_id": 28,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 29,
      "name": "GreenWind Plant 29",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 29,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 30,
      "name": "WindStar Plant 30",
      "type": "Wind",
      "qca_id": 6,
      "pss_id": 30,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 31,
      "name": "WindStar Plant 31",
      "type": "Wind",
      "qca_id": 7,
      "pss_id": 31,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 32,
      "name": "SunPower Plant 32",
      "type": "Solar",
      "qca_id": 8,
      "pss_id": 32,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 33,
      "name": "WindStar Plant 33",
      "type": "Solar",
      "qca_id": 9,
      "pss_id": 33,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 34,
      "name": "EcoHybrid Plant 34",
      "type": "Hybrid",
      "qca_id": 10,
      "pss_id": 34,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 35,
      "name": "SunPower Plant 35",
      "type": "Hybrid",
      "qca_id": 11,
      "pss_id": 35,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 36,
      "name": "SolarOne Plant 36",
      "type": "Wind",
      "qca_id": 12,
      "pss_id": 36,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 37,
      "name": "EcoHybrid Plant 37",
      "type": "Hybrid",
      "qca_id": 13,
      "pss_id": 37,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 38,
      "name": "GreenWind Plant 38",
      "type": "Wind",
      "qca_id": 14,
      "pss_id": 38,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 39,
      "name": "EcoHybrid Plant 39",
      "type": "Solar",
      "qca_id": 15,
      "pss_id": 39,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 40,
      "name": "EcoHybrid Plant 40",
      "type": "Hybrid",
      "qca_id": 16,
      "pss_id": 40,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 41,
      "name": "SunPower Plant 41",
      "type": "Solar",
      "qca_id": 17,
      "pss_id": 41,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 42,
      "name": "SunPower Plant 42",
      "type": "Hybrid",
      "qca_id": 18,
      "pss_id": 42,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 43,
      "name": "GreenWind Plant 43",
      "type": "Solar",
      "qca_id": 19,
      "pss_id": 43,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 44,
      "name": "SolarOne Plant 44",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 44,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 45,
      "name": "EcoHybrid Plant 45",
      "type": "Wind",
      "qca_id": 21,
      "pss_id": 45,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 46,
      "name": "EcoHybrid Plant 46",
      "type": "Wind",
      "qca_id": 22,
      "pss_id": 46,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 47,
      "name": "EcoHybrid Plant 47",
      "type": "Wind",
      "qca_id": 23,
      "pss_id": 47,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 48,
      "name": "GreenWind Plant 48",
      "type": "Hybrid",
      "qca_id": 24,
      "pss_id": 48,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 49,
      "name": "EcoHybrid Plant 49",
      "type": "Hybrid",
      "qca_id": 1,
      "pss_id": 49,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 50,
      "name": "EcoHybrid Plant 50",
      "type": "Wind",
      "qca_id": 2,
      "pss_id": 50,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 51,
      "name": "SolarOne Plant 51",
      "type": "Solar",
      "qca_id": 3,
      "pss_id": 51,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 52,
      "name": "WindStar Plant 52",
      "type": "Hybrid",
      "qca_id": 4,
      "pss_id": 52,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 53,
      "name": "SolarOne Plant 53",
      "type": "Hybrid",
      "qca_id": 5,
      "pss_id": 53,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 54,
      "name": "EcoHybrid Plant 54",
      "type": "Hybrid",
      "qca_id": 6,
      "pss_id": 54,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 55,
      "name": "SolarOne Plant 55",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 55,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 56,
      "name": "WindStar Plant 56",
      "type": "Hybrid",
      "qca_id": 8,
      "pss_id": 56,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 57,
      "name": "SolarOne Plant 57",
      "type": "Hybrid",
      "qca_id": 9,
      "pss_id": 57,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 58,
      "name": "GreenWind Plant 58",
      "type": "Solar",
      "qca_id": 10,
      "pss_id": 58,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 59,
      "name": "EcoHybrid Plant 59",
      "type": "Hybrid",
      "qca_id": 11,
      "pss_id": 59,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 60,
      "name": "EcoHybrid Plant 60",
      "type": "Solar",
      "qca_id": 12,
      "pss_id": 60,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 61,
      "name": "SolarOne Plant 61",
      "type": "Solar",
      "qca_id": 13,
      "pss_id": 61,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 62,
      "name": "GreenWind Plant 62",
      "type": "Wind",
      "qca_id": 14,
      "pss_id": 62,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 63,
      "name": "EcoHybrid Plant 63",
      "type": "Hybrid",
      "qca_id": 15,
      "pss_id": 63,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 64,
      "name": "WindStar Plant 64",
      "type": "Hybrid",
      "qca_id": 16,
      "pss_id": 64,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 65,
      "name": "SunPower Plant 65",
      "type": "Solar",
      "qca_id": 17,
      "pss_id": 65,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 66,
      "name": "SunPower Plant 66",
      "type": "Wind",
      "qca_id": 18,
      "pss_id": 66,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 67,
      "name": "SunPower Plant 67",
      "type": "Wind",
      "qca_id": 19,
      "pss_id": 67,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 68,
      "name": "GreenWind Plant 68",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 68,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 69,
      "name": "EcoHybrid Plant 69",
      "type": "Hybrid",
      "qca_id": 21,
      "pss_id": 69,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 70,
      "name": "SunPower Plant 70",
      "type": "Solar",
      "qca_id": 22,
      "pss_id": 70,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 71,
      "name": "WindStar Plant 71",
      "type": "Hybrid",
      "qca_id": 23,
      "pss_id": 71,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 72,
      "name": "EcoHybrid Plant 72",
      "type": "Hybrid",
      "qca_id": 24,
      "pss_id": 72,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 73,
      "name": "GreenWind Plant 73",
      "type": "Solar",
      "qca_id": 1,
      "pss_id": 73,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 74,
      "name": "GreenWind Plant 74",
      "type": "Hybrid",
      "qca_id": 2,
      "pss_id": 74,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 75,
      "name": "WindStar Plant 75",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 75,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 76,
      "name": "SunPower Plant 76",
      "type": "Solar",
      "qca_id": 4,
      "pss_id": 76,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 77,
      "name": "SolarOne Plant 77",
      "type": "Hybrid",
      "qca_id": 5,
      "pss_id": 77,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 78,
      "name": "SolarOne Plant 78",
      "type": "Hybrid",
      "qca_id": 6,
      "pss_id": 78,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 79,
      "name": "SunPower Plant 79",
      "type": "Wind",
      "qca_id": 7,
      "pss_id": 79,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 80,
      "name": "GreenWind Plant 80",
      "type": "Wind",
      "qca_id": 8,
      "pss_id": 80,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 81,
      "name": "EcoHybrid Plant 81",
      "type": "Solar",
      "qca_id": 9,
      "pss_id": 81,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 82,
      "name": "SolarOne Plant 82",
      "type": "Hybrid",
      "qca_id": 10,
      "pss_id": 82,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 83,
      "name": "GreenWind Plant 83",
      "type": "Solar",
      "qca_id": 11,
      "pss_id": 83,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 84,
      "name": "EcoHybrid Plant 84",
      "type": "Solar",
      "qca_id": 12,
      "pss_id": 84,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 85,
      "name": "SunPower Plant 85",
      "type": "Wind",
      "qca_id": 13,
      "pss_id": 85,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 86,
      "name": "GreenWind Plant 86",
      "type": "Hybrid",
      "qca_id": 14,
      "pss_id": 86,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 87,
      "name": "SunPower Plant 87",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 87,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 88,
      "name": "SolarOne Plant 88",
      "type": "Wind",
      "qca_id": 16,
      "pss_id": 88,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 89,
      "name": "GreenWind Plant 89",
      "type": "Solar",
      "qca_id": 17,
      "pss_id": 89,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 90,
      "name": "GreenWind Plant 90",
      "type": "Wind",
      "qca_id": 18,
      "pss_id": 90,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 91,
      "name": "GreenWind Plant 91",
      "type": "Hybrid",
      "qca_id": 19,
      "pss_id": 91,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 92,
      "name": "SunPower Plant 92",
      "type": "Hybrid",
      "qca_id": 20,
      "pss_id": 92,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 93,
      "name": "SolarOne Plant 93",
      "type": "Wind",
      "qca_id": 21,
      "pss_id": 93,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 94,
      "name": "EcoHybrid Plant 94",
      "type": "Wind",
      "qca_id": 22,
      "pss_id": 94,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 95,
      "name": "GreenWind Plant 95",
      "type": "Wind",
      "qca_id": 23,
      "pss_id": 95,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 96,
      "name": "GreenWind Plant 96",
      "type": "Hybrid",
      "qca_id": 24,
      "pss_id": 96,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 97,
      "name": "GreenWind Plant 97",
      "type": "Solar",
      "qca_id": 1,
      "pss_id": 97,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 98,
      "name": "GreenWind Plant 98",
      "type": "Wind",
      "qca_id": 2,
      "pss_id": 98,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 99,
      "name": "EcoHybrid Plant 99",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 99,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 100,
      "name": "SolarOne Plant 100",
      "type": "Solar",
      "qca_id": 4,
      "pss_id": 100,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 101,
      "name": "WindStar Plant 101",
      "type": "Hybrid",
      "qca_id": 5,
      "pss_id": 101,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 102,
      "name": "SolarOne Plant 102",
      "type": "Hybrid",
      "qca_id": 6,
      "pss_id": 102,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 103,
      "name": "SolarOne Plant 103",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 103,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 104,
      "name": "GreenWind Plant 104",
      "type": "Solar",
      "qca_id": 8,
      "pss_id": 104,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 105,
      "name": "WindStar Plant 105",
      "type": "Hybrid",
      "qca_id": 9,
      "pss_id": 105,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 106,
      "name": "WindStar Plant 106",
      "type": "Wind",
      "qca_id": 10,
      "pss_id": 106,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 107,
      "name": "SunPower Plant 107",
      "type": "Hybrid",
      "qca_id": 11,
      "pss_id": 107,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 108,
      "name": "WindStar Plant 108",
      "type": "Wind",
      "qca_id": 12,
      "pss_id": 108,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 109,
      "name": "EcoHybrid Plant 109",
      "type": "Solar",
      "qca_id": 13,
      "pss_id": 109,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 110,
      "name": "GreenWind Plant 110",
      "type": "Solar",
      "qca_id": 14,
      "pss_id": 110,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 111,
      "name": "WindStar Plant 111",
      "type": "Hybrid",
      "qca_id": 15,
      "pss_id": 111,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 112,
      "name": "WindStar Plant 112",
      "type": "Solar",
      "qca_id": 16,
      "pss_id": 112,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 113,
      "name": "WindStar Plant 113",
      "type": "Solar",
      "qca_id": 17,
      "pss_id": 113,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 114,
      "name": "WindStar Plant 114",
      "type": "Solar",
      "qca_id": 18,
      "pss_id": 114,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 115,
      "name": "WindStar Plant 115",
      "type": "Solar",
      "qca_id": 19,
      "pss_id": 115,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 116,
      "name": "SolarOne Plant 116",
      "type": "Solar",
      "qca_id": 20,
      "pss_id": 116,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 117,
      "name": "EcoHybrid Plant 117",
      "type": "Wind",
      "qca_id": 21,
      "pss_id": 1,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 118,
      "name": "SolarOne Plant 118",
      "type": "Wind",
      "qca_id": 22,
      "pss_id": 2,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 119,
      "name": "SolarOne Plant 119",
      "type": "Solar",
      "qca_id": 23,
      "pss_id": 3,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 120,
      "name": "EcoHybrid Plant 120",
      "type": "Wind",
      "qca_id": 24,
      "pss_id": 4,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 121,
      "name": "WindStar Plant 121",
      "type": "Solar",
      "qca_id": 1,
      "pss_id": 5,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 122,
      "name": "EcoHybrid Plant 122",
      "type": "Wind",
      "qca_id": 2,
      "pss_id": 6,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 123,
      "name": "WindStar Plant 123",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 7,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 124,
      "name": "EcoHybrid Plant 124",
      "type": "Wind",
      "qca_id": 4,
      "pss_id": 8,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 125,
      "name": "EcoHybrid Plant 125",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 9,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 126,
      "name": "SunPower Plant 126",
      "type": "Wind",
      "qca_id": 6,
      "pss_id": 10,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 127,
      "name": "SolarOne Plant 127",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 11,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 128,
      "name": "WindStar Plant 128",
      "type": "Hybrid",
      "qca_id": 8,
      "pss_id": 12,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 129,
      "name": "SunPower Plant 129",
      "type": "Hybrid",
      "qca_id": 9,
      "pss_id": 13,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 130,
      "name": "SolarOne Plant 130",
      "type": "Hybrid",
      "qca_id": 10,
      "pss_id": 14,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 131,
      "name": "WindStar Plant 131",
      "type": "Solar",
      "qca_id": 11,
      "pss_id": 15,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 132,
      "name": "SolarOne Plant 132",
      "type": "Hybrid",
      "qca_id": 12,
      "pss_id": 16,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 133,
      "name": "GreenWind Plant 133",
      "type": "Wind",
      "qca_id": 13,
      "pss_id": 17,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 134,
      "name": "WindStar Plant 134",
      "type": "Hybrid",
      "qca_id": 14,
      "pss_id": 18,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 135,
      "name": "GreenWind Plant 135",
      "type": "Solar",
      "qca_id": 15,
      "pss_id": 19,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 136,
      "name": "GreenWind Plant 136",
      "type": "Solar",
      "qca_id": 16,
      "pss_id": 20,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 137,
      "name": "WindStar Plant 137",
      "type": "Solar",
      "qca_id": 17,
      "pss_id": 21,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 138,
      "name": "GreenWind Plant 138",
      "type": "Hybrid",
      "qca_id": 18,
      "pss_id": 22,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 139,
      "name": "GreenWind Plant 139",
      "type": "Wind",
      "qca_id": 19,
      "pss_id": 23,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 140,
      "name": "SunPower Plant 140",
      "type": "Solar",
      "qca_id": 20,
      "pss_id": 24,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 141,
      "name": "SolarOne Plant 141",
      "type": "Hybrid",
      "qca_id": 21,
      "pss_id": 25,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 142,
      "name": "SunPower Plant 142",
      "type": "Wind",
      "qca_id": 22,
      "pss_id": 26,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 143,
      "name": "GreenWind Plant 143",
      "type": "Wind",
      "qca_id": 23,
      "pss_id": 27,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 144,
      "name": "SolarOne Plant 144",
      "type": "Wind",
      "qca_id": 24,
      "pss_id": 28,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 145,
      "name": "WindStar Plant 145",
      "type": "Wind",
      "qca_id": 1,
      "pss_id": 29,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 146,
      "name": "EcoHybrid Plant 146",
      "type": "Solar",
      "qca_id": 2,
      "pss_id": 30,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 147,
      "name": "WindStar Plant 147",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 31,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 148,
      "name": "EcoHybrid Plant 148",
      "type": "Wind",
      "qca_id": 4,
      "pss_id": 32,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 149,
      "name": "SunPower Plant 149",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 33,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 150,
      "name": "WindStar Plant 150",
      "type": "Hybrid",
      "qca_id": 6,
      "pss_id": 34,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 151,
      "name": "SunPower Plant 151",
      "type": "Solar",
      "qca_id": 7,
      "pss_id": 35,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 152,
      "name": "SolarOne Plant 152",
      "type": "Hybrid",
      "qca_id": 8,
      "pss_id": 36,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 153,
      "name": "SolarOne Plant 153",
      "type": "Wind",
      "qca_id": 9,
      "pss_id": 37,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 154,
      "name": "EcoHybrid Plant 154",
      "type": "Hybrid",
      "qca_id": 10,
      "pss_id": 38,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 155,
      "name": "EcoHybrid Plant 155",
      "type": "Wind",
      "qca_id": 11,
      "pss_id": 39,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 156,
      "name": "EcoHybrid Plant 156",
      "type": "Hybrid",
      "qca_id": 12,
      "pss_id": 40,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 157,
      "name": "GreenWind Plant 157",
      "type": "Wind",
      "qca_id": 13,
      "pss_id": 41,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 158,
      "name": "WindStar Plant 158",
      "type": "Hybrid",
      "qca_id": 14,
      "pss_id": 42,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 159,
      "name": "WindStar Plant 159",
      "type": "Solar",
      "qca_id": 15,
      "pss_id": 43,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 160,
      "name": "SolarOne Plant 160",
      "type": "Solar",
      "qca_id": 16,
      "pss_id": 44,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 161,
      "name": "WindStar Plant 161",
      "type": "Hybrid",
      "qca_id": 17,
      "pss_id": 45,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 162,
      "name": "GreenWind Plant 162",
      "type": "Hybrid",
      "qca_id": 18,
      "pss_id": 46,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 163,
      "name": "WindStar Plant 163",
      "type": "Solar",
      "qca_id": 19,
      "pss_id": 47,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 164,
      "name": "GreenWind Plant 164",
      "type": "Solar",
      "qca_id": 20,
      "pss_id": 48,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 165,
      "name": "WindStar Plant 165",
      "type": "Hybrid",
      "qca_id": 21,
      "pss_id": 49,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 166,
      "name": "EcoHybrid Plant 166",
      "type": "Hybrid",
      "qca_id": 22,
      "pss_id": 50,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 167,
      "name": "WindStar Plant 167",
      "type": "Hybrid",
      "qca_id": 23,
      "pss_id": 51,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 168,
      "name": "WindStar Plant 168",
      "type": "Wind",
      "qca_id": 24,
      "pss_id": 52,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 169,
      "name": "SolarOne Plant 169",
      "type": "Hybrid",
      "qca_id": 1,
      "pss_id": 53,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 170,
      "name": "GreenWind Plant 170",
      "type": "Hybrid",
      "qca_id": 2,
      "pss_id": 54,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 171,
      "name": "SolarOne Plant 171",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 55,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 172,
      "name": "SunPower Plant 172",
      "type": "Wind",
      "qca_id": 4,
      "pss_id": 56,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 173,
      "name": "SolarOne Plant 173",
      "type": "Hybrid",
      "qca_id": 5,
      "pss_id": 57,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 174,
      "name": "GreenWind Plant 174",
      "type": "Solar",
      "qca_id": 6,
      "pss_id": 58,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 175,
      "name": "SolarOne Plant 175",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 59,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 176,
      "name": "SolarOne Plant 176",
      "type": "Wind",
      "qca_id": 8,
      "pss_id": 60,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 177,
      "name": "GreenWind Plant 177",
      "type": "Solar",
      "qca_id": 9,
      "pss_id": 61,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 178,
      "name": "SolarOne Plant 178",
      "type": "Wind",
      "qca_id": 10,
      "pss_id": 62,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 179,
      "name": "GreenWind Plant 179",
      "type": "Solar",
      "qca_id": 11,
      "pss_id": 63,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 180,
      "name": "GreenWind Plant 180",
      "type": "Hybrid",
      "qca_id": 12,
      "pss_id": 64,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 181,
      "name": "GreenWind Plant 181",
      "type": "Wind",
      "qca_id": 13,
      "pss_id": 65,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 182,
      "name": "GreenWind Plant 182",
      "type": "Hybrid",
      "qca_id": 14,
      "pss_id": 66,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 183,
      "name": "GreenWind Plant 183",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 67,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 184,
      "name": "SolarOne Plant 184",
      "type": "Wind",
      "qca_id": 16,
      "pss_id": 68,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 185,
      "name": "SunPower Plant 185",
      "type": "Hybrid",
      "qca_id": 17,
      "pss_id": 69,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 186,
      "name": "GreenWind Plant 186",
      "type": "Solar",
      "qca_id": 18,
      "pss_id": 70,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 187,
      "name": "WindStar Plant 187",
      "type": "Solar",
      "qca_id": 19,
      "pss_id": 71,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 188,
      "name": "WindStar Plant 188",
      "type": "Solar",
      "qca_id": 20,
      "pss_id": 72,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 189,
      "name": "EcoHybrid Plant 189",
      "type": "Hybrid",
      "qca_id": 21,
      "pss_id": 73,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 190,
      "name": "SolarOne Plant 190",
      "type": "Hybrid",
      "qca_id": 22,
      "pss_id": 74,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 191,
      "name": "EcoHybrid Plant 191",
      "type": "Solar",
      "qca_id": 23,
      "pss_id": 75,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 192,
      "name": "WindStar Plant 192",
      "type": "Solar",
      "qca_id": 24,
      "pss_id": 76,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 193,
      "name": "EcoHybrid Plant 193",
      "type": "Hybrid",
      "qca_id": 1,
      "pss_id": 77,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 194,
      "name": "GreenWind Plant 194",
      "type": "Wind",
      "qca_id": 2,
      "pss_id": 78,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 195,
      "name": "SolarOne Plant 195",
      "type": "Wind",
      "qca_id": 3,
      "pss_id": 79,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 196,
      "name": "SolarOne Plant 196",
      "type": "Hybrid",
      "qca_id": 4,
      "pss_id": 80,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 197,
      "name": "SolarOne Plant 197",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 81,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 198,
      "name": "SolarOne Plant 198",
      "type": "Solar",
      "qca_id": 6,
      "pss_id": 82,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 199,
      "name": "SunPower Plant 199",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 83,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 200,
      "name": "SunPower Plant 200",
      "type": "Hybrid",
      "qca_id": 8,
      "pss_id": 84,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 201,
      "name": "SunPower Plant 201",
      "type": "Solar",
      "qca_id": 9,
      "pss_id": 85,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 202,
      "name": "SunPower Plant 202",
      "type": "Hybrid",
      "qca_id": 10,
      "pss_id": 86,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 203,
      "name": "SolarOne Plant 203",
      "type": "Solar",
      "qca_id": 11,
      "pss_id": 87,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 204,
      "name": "WindStar Plant 204",
      "type": "Wind",
      "qca_id": 12,
      "pss_id": 88,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 205,
      "name": "SunPower Plant 205",
      "type": "Wind",
      "qca_id": 13,
      "pss_id": 89,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 206,
      "name": "WindStar Plant 206",
      "type": "Solar",
      "qca_id": 14,
      "pss_id": 90,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 207,
      "name": "EcoHybrid Plant 207",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 91,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 208,
      "name": "SunPower Plant 208",
      "type": "Solar",
      "qca_id": 16,
      "pss_id": 92,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 209,
      "name": "SunPower Plant 209",
      "type": "Hybrid",
      "qca_id": 17,
      "pss_id": 93,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 210,
      "name": "GreenWind Plant 210",
      "type": "Solar",
      "qca_id": 18,
      "pss_id": 94,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 211,
      "name": "SolarOne Plant 211",
      "type": "Solar",
      "qca_id": 19,
      "pss_id": 95,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 212,
      "name": "SolarOne Plant 212",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 96,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 213,
      "name": "SolarOne Plant 213",
      "type": "Solar",
      "qca_id": 21,
      "pss_id": 97,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 214,
      "name": "SunPower Plant 214",
      "type": "Wind",
      "qca_id": 22,
      "pss_id": 98,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 215,
      "name": "EcoHybrid Plant 215",
      "type": "Hybrid",
      "qca_id": 23,
      "pss_id": 99,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 216,
      "name": "SolarOne Plant 216",
      "type": "Solar",
      "qca_id": 24,
      "pss_id": 100,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 217,
      "name": "EcoHybrid Plant 217",
      "type": "Hybrid",
      "qca_id": 1,
      "pss_id": 101,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 218,
      "name": "SunPower Plant 218",
      "type": "Hybrid",
      "qca_id": 2,
      "pss_id": 102,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 219,
      "name": "GreenWind Plant 219",
      "type": "Solar",
      "qca_id": 3,
      "pss_id": 103,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 220,
      "name": "SunPower Plant 220",
      "type": "Wind",
      "qca_id": 4,
      "pss_id": 104,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 221,
      "name": "EcoHybrid Plant 221",
      "type": "Solar",
      "qca_id": 5,
      "pss_id": 105,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 222,
      "name": "SunPower Plant 222",
      "type": "Wind",
      "qca_id": 6,
      "pss_id": 106,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 223,
      "name": "SunPower Plant 223",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 107,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 224,
      "name": "GreenWind Plant 224",
      "type": "Solar",
      "qca_id": 8,
      "pss_id": 108,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 225,
      "name": "WindStar Plant 225",
      "type": "Wind",
      "qca_id": 9,
      "pss_id": 109,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 226,
      "name": "SunPower Plant 226",
      "type": "Wind",
      "qca_id": 10,
      "pss_id": 110,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 227,
      "name": "WindStar Plant 227",
      "type": "Solar",
      "qca_id": 11,
      "pss_id": 111,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 228,
      "name": "SunPower Plant 228",
      "type": "Solar",
      "qca_id": 12,
      "pss_id": 112,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 229,
      "name": "WindStar Plant 229",
      "type": "Wind",
      "qca_id": 13,
      "pss_id": 113,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 230,
      "name": "SunPower Plant 230",
      "type": "Hybrid",
      "qca_id": 14,
      "pss_id": 114,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 231,
      "name": "EcoHybrid Plant 231",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 115,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 232,
      "name": "SunPower Plant 232",
      "type": "Hybrid",
      "qca_id": 16,
      "pss_id": 116,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 233,
      "name": "SunPower Plant 233",
      "type": "Wind",
      "qca_id": 17,
      "pss_id": 1,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 234,
      "name": "WindStar Plant 234",
      "type": "Hybrid",
      "qca_id": 18,
      "pss_id": 2,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 235,
      "name": "WindStar Plant 235",
      "type": "Wind",
      "qca_id": 19,
      "pss_id": 3,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 236,
      "name": "SolarOne Plant 236",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 4,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 237,
      "name": "EcoHybrid Plant 237",
      "type": "Hybrid",
      "qca_id": 21,
      "pss_id": 5,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 238,
      "name": "GreenWind Plant 238",
      "type": "Hybrid",
      "qca_id": 22,
      "pss_id": 6,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 239,
      "name": "GreenWind Plant 239",
      "type": "Solar",
      "qca_id": 23,
      "pss_id": 7,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 240,
      "name": "EcoHybrid Plant 240",
      "type": "Wind",
      "qca_id": 24,
      "pss_id": 8,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 241,
      "name": "EcoHybrid Plant 241",
      "type": "Solar",
      "qca_id": 1,
      "pss_id": 9,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 242,
      "name": "SolarOne Plant 242",
      "type": "Solar",
      "qca_id": 2,
      "pss_id": 10,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 243,
      "name": "SunPower Plant 243",
      "type": "Wind",
      "qca_id": 3,
      "pss_id": 11,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 244,
      "name": "SolarOne Plant 244",
      "type": "Wind",
      "qca_id": 4,
      "pss_id": 12,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 245,
      "name": "GreenWind Plant 245",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 13,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 246,
      "name": "SolarOne Plant 246",
      "type": "Solar",
      "qca_id": 6,
      "pss_id": 14,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 247,
      "name": "GreenWind Plant 247",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 15,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 248,
      "name": "SolarOne Plant 248",
      "type": "Wind",
      "qca_id": 8,
      "pss_id": 16,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 249,
      "name": "SolarOne Plant 249",
      "type": "Wind",
      "qca_id": 9,
      "pss_id": 17,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 250,
      "name": "SolarOne Plant 250",
      "type": "Solar",
      "qca_id": 10,
      "pss_id": 18,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 251,
      "name": "WindStar Plant 251",
      "type": "Wind",
      "qca_id": 11,
      "pss_id": 19,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 252,
      "name": "GreenWind Plant 252",
      "type": "Wind",
      "qca_id": 12,
      "pss_id": 20,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 253,
      "name": "EcoHybrid Plant 253",
      "type": "Solar",
      "qca_id": 13,
      "pss_id": 21,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 254,
      "name": "SunPower Plant 254",
      "type": "Solar",
      "qca_id": 14,
      "pss_id": 22,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 255,
      "name": "EcoHybrid Plant 255",
      "type": "Solar",
      "qca_id": 15,
      "pss_id": 23,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 256,
      "name": "GreenWind Plant 256",
      "type": "Wind",
      "qca_id": 16,
      "pss_id": 24,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 257,
      "name": "WindStar Plant 257",
      "type": "Solar",
      "qca_id": 17,
      "pss_id": 25,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 258,
      "name": "SolarOne Plant 258",
      "type": "Wind",
      "qca_id": 18,
      "pss_id": 26,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 259,
      "name": "EcoHybrid Plant 259",
      "type": "Wind",
      "qca_id": 19,
      "pss_id": 27,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 260,
      "name": "SolarOne Plant 260",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 28,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 261,
      "name": "WindStar Plant 261",
      "type": "Hybrid",
      "qca_id": 21,
      "pss_id": 29,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 262,
      "name": "SolarOne Plant 262",
      "type": "Hybrid",
      "qca_id": 22,
      "pss_id": 30,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 263,
      "name": "WindStar Plant 263",
      "type": "Wind",
      "qca_id": 23,
      "pss_id": 31,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 264,
      "name": "GreenWind Plant 264",
      "type": "Solar",
      "qca_id": 24,
      "pss_id": 32,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 265,
      "name": "SolarOne Plant 265",
      "type": "Wind",
      "qca_id": 1,
      "pss_id": 33,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 266,
      "name": "WindStar Plant 266",
      "type": "Solar",
      "qca_id": 2,
      "pss_id": 34,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 267,
      "name": "GreenWind Plant 267",
      "type": "Wind",
      "qca_id": 3,
      "pss_id": 35,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 268,
      "name": "SunPower Plant 268",
      "type": "Wind",
      "qca_id": 4,
      "pss_id": 36,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 269,
      "name": "SolarOne Plant 269",
      "type": "Solar",
      "qca_id": 5,
      "pss_id": 37,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 270,
      "name": "EcoHybrid Plant 270",
      "type": "Wind",
      "qca_id": 6,
      "pss_id": 38,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 271,
      "name": "SunPower Plant 271",
      "type": "Wind",
      "qca_id": 7,
      "pss_id": 39,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 272,
      "name": "EcoHybrid Plant 272",
      "type": "Hybrid",
      "qca_id": 8,
      "pss_id": 40,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 273,
      "name": "EcoHybrid Plant 273",
      "type": "Solar",
      "qca_id": 9,
      "pss_id": 41,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 274,
      "name": "SunPower Plant 274",
      "type": "Wind",
      "qca_id": 10,
      "pss_id": 42,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 275,
      "name": "WindStar Plant 275",
      "type": "Solar",
      "qca_id": 11,
      "pss_id": 43,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 276,
      "name": "SolarOne Plant 276",
      "type": "Solar",
      "qca_id": 12,
      "pss_id": 44,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 277,
      "name": "SunPower Plant 277",
      "type": "Solar",
      "qca_id": 13,
      "pss_id": 45,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 278,
      "name": "EcoHybrid Plant 278",
      "type": "Hybrid",
      "qca_id": 14,
      "pss_id": 46,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 279,
      "name": "GreenWind Plant 279",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 47,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 280,
      "name": "EcoHybrid Plant 280",
      "type": "Solar",
      "qca_id": 16,
      "pss_id": 48,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 281,
      "name": "WindStar Plant 281",
      "type": "Wind",
      "qca_id": 17,
      "pss_id": 49,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 282,
      "name": "SolarOne Plant 282",
      "type": "Wind",
      "qca_id": 18,
      "pss_id": 50,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 283,
      "name": "SolarOne Plant 283",
      "type": "Solar",
      "qca_id": 19,
      "pss_id": 51,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 284,
      "name": "WindStar Plant 284",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 52,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 285,
      "name": "WindStar Plant 285",
      "type": "Solar",
      "qca_id": 21,
      "pss_id": 53,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 286,
      "name": "WindStar Plant 286",
      "type": "Wind",
      "qca_id": 22,
      "pss_id": 54,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 287,
      "name": "SolarOne Plant 287",
      "type": "Solar",
      "qca_id": 23,
      "pss_id": 55,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 288,
      "name": "EcoHybrid Plant 288",
      "type": "Wind",
      "qca_id": 24,
      "pss_id": 56,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 289,
      "name": "WindStar Plant 289",
      "type": "Wind",
      "qca_id": 1,
      "pss_id": 57,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 290,
      "name": "WindStar Plant 290",
      "type": "Hybrid",
      "qca_id": 2,
      "pss_id": 58,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 291,
      "name": "GreenWind Plant 291",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 59,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 292,
      "name": "SolarOne Plant 292",
      "type": "Wind",
      "qca_id": 4,
      "pss_id": 60,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 293,
      "name": "GreenWind Plant 293",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 61,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 294,
      "name": "SunPower Plant 294",
      "type": "Hybrid",
      "qca_id": 6,
      "pss_id": 62,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 295,
      "name": "SolarOne Plant 295",
      "type": "Wind",
      "qca_id": 7,
      "pss_id": 63,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 296,
      "name": "WindStar Plant 296",
      "type": "Hybrid",
      "qca_id": 8,
      "pss_id": 64,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 297,
      "name": "SunPower Plant 297",
      "type": "Wind",
      "qca_id": 9,
      "pss_id": 65,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 298,
      "name": "EcoHybrid Plant 298",
      "type": "Hybrid",
      "qca_id": 10,
      "pss_id": 66,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 299,
      "name": "EcoHybrid Plant 299",
      "type": "Hybrid",
      "qca_id": 11,
      "pss_id": 67,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 300,
      "name": "GreenWind Plant 300",
      "type": "Hybrid",
      "qca_id": 12,
      "pss_id": 68,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 301,
      "name": "WindStar Plant 301",
      "type": "Solar",
      "qca_id": 13,
      "pss_id": 69,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 302,
      "name": "EcoHybrid Plant 302",
      "type": "Solar",
      "qca_id": 14,
      "pss_id": 70,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 303,
      "name": "SolarOne Plant 303",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 71,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 304,
      "name": "EcoHybrid Plant 304",
      "type": "Solar",
      "qca_id": 16,
      "pss_id": 72,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 305,
      "name": "GreenWind Plant 305",
      "type": "Wind",
      "qca_id": 17,
      "pss_id": 73,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 306,
      "name": "GreenWind Plant 306",
      "type": "Wind",
      "qca_id": 18,
      "pss_id": 74,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 307,
      "name": "WindStar Plant 307",
      "type": "Solar",
      "qca_id": 19,
      "pss_id": 75,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 308,
      "name": "EcoHybrid Plant 308",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 76,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 309,
      "name": "GreenWind Plant 309",
      "type": "Solar",
      "qca_id": 21,
      "pss_id": 77,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 310,
      "name": "GreenWind Plant 310",
      "type": "Solar",
      "qca_id": 22,
      "pss_id": 78,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 311,
      "name": "EcoHybrid Plant 311",
      "type": "Wind",
      "qca_id": 23,
      "pss_id": 79,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 312,
      "name": "WindStar Plant 312",
      "type": "Solar",
      "qca_id": 24,
      "pss_id": 80,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 313,
      "name": "GreenWind Plant 313",
      "type": "Wind",
      "qca_id": 1,
      "pss_id": 81,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 314,
      "name": "EcoHybrid Plant 314",
      "type": "Wind",
      "qca_id": 2,
      "pss_id": 82,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 315,
      "name": "SolarOne Plant 315",
      "type": "Solar",
      "qca_id": 3,
      "pss_id": 83,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 316,
      "name": "EcoHybrid Plant 316",
      "type": "Hybrid",
      "qca_id": 4,
      "pss_id": 84,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 317,
      "name": "WindStar Plant 317",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 85,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 318,
      "name": "SolarOne Plant 318",
      "type": "Hybrid",
      "qca_id": 6,
      "pss_id": 86,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 319,
      "name": "WindStar Plant 319",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 87,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 320,
      "name": "EcoHybrid Plant 320",
      "type": "Wind",
      "qca_id": 8,
      "pss_id": 88,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 321,
      "name": "WindStar Plant 321",
      "type": "Hybrid",
      "qca_id": 9,
      "pss_id": 89,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 322,
      "name": "WindStar Plant 322",
      "type": "Solar",
      "qca_id": 10,
      "pss_id": 90,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 323,
      "name": "GreenWind Plant 323",
      "type": "Solar",
      "qca_id": 11,
      "pss_id": 91,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 324,
      "name": "WindStar Plant 324",
      "type": "Wind",
      "qca_id": 12,
      "pss_id": 92,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 325,
      "name": "SolarOne Plant 325",
      "type": "Hybrid",
      "qca_id": 13,
      "pss_id": 93,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 326,
      "name": "GreenWind Plant 326",
      "type": "Wind",
      "qca_id": 14,
      "pss_id": 94,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 327,
      "name": "GreenWind Plant 327",
      "type": "Solar",
      "qca_id": 15,
      "pss_id": 95,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 328,
      "name": "SunPower Plant 328",
      "type": "Solar",
      "qca_id": 16,
      "pss_id": 96,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 329,
      "name": "GreenWind Plant 329",
      "type": "Wind",
      "qca_id": 17,
      "pss_id": 97,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 330,
      "name": "EcoHybrid Plant 330",
      "type": "Hybrid",
      "qca_id": 18,
      "pss_id": 98,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 331,
      "name": "GreenWind Plant 331",
      "type": "Solar",
      "qca_id": 19,
      "pss_id": 99,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 332,
      "name": "WindStar Plant 332",
      "type": "Hybrid",
      "qca_id": 20,
      "pss_id": 100,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 333,
      "name": "WindStar Plant 333",
      "type": "Wind",
      "qca_id": 21,
      "pss_id": 101,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 334,
      "name": "GreenWind Plant 334",
      "type": "Hybrid",
      "qca_id": 22,
      "pss_id": 102,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 335,
      "name": "SunPower Plant 335",
      "type": "Wind",
      "qca_id": 23,
      "pss_id": 103,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 336,
      "name": "SolarOne Plant 336",
      "type": "Hybrid",
      "qca_id": 24,
      "pss_id": 104,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 337,
      "name": "GreenWind Plant 337",
      "type": "Wind",
      "qca_id": 1,
      "pss_id": 105,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 338,
      "name": "SunPower Plant 338",
      "type": "Wind",
      "qca_id": 2,
      "pss_id": 106,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 339,
      "name": "SolarOne Plant 339",
      "type": "Wind",
      "qca_id": 3,
      "pss_id": 107,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 340,
      "name": "SolarOne Plant 340",
      "type": "Hybrid",
      "qca_id": 4,
      "pss_id": 108,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 341,
      "name": "GreenWind Plant 341",
      "type": "Hybrid",
      "qca_id": 5,
      "pss_id": 109,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 342,
      "name": "SolarOne Plant 342",
      "type": "Solar",
      "qca_id": 6,
      "pss_id": 110,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 343,
      "name": "EcoHybrid Plant 343",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 111,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 344,
      "name": "GreenWind Plant 344",
      "type": "Wind",
      "qca_id": 8,
      "pss_id": 112,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 345,
      "name": "SolarOne Plant 345",
      "type": "Solar",
      "qca_id": 9,
      "pss_id": 113,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 346,
      "name": "SolarOne Plant 346",
      "type": "Hybrid",
      "qca_id": 10,
      "pss_id": 114,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 347,
      "name": "WindStar Plant 347",
      "type": "Solar",
      "qca_id": 11,
      "pss_id": 115,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 348,
      "name": "WindStar Plant 348",
      "type": "Solar",
      "qca_id": 12,
      "pss_id": 116,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 349,
      "name": "WindStar Plant 349",
      "type": "Hybrid",
      "qca_id": 13,
      "pss_id": 1,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 350,
      "name": "SolarOne Plant 350",
      "type": "Solar",
      "qca_id": 14,
      "pss_id": 2,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 351,
      "name": "SolarOne Plant 351",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 3,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 352,
      "name": "EcoHybrid Plant 352",
      "type": "Hybrid",
      "qca_id": 16,
      "pss_id": 4,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 353,
      "name": "EcoHybrid Plant 353",
      "type": "Solar",
      "qca_id": 17,
      "pss_id": 5,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 354,
      "name": "EcoHybrid Plant 354",
      "type": "Hybrid",
      "qca_id": 18,
      "pss_id": 6,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 355,
      "name": "SunPower Plant 355",
      "type": "Hybrid",
      "qca_id": 19,
      "pss_id": 7,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 356,
      "name": "GreenWind Plant 356",
      "type": "Hybrid",
      "qca_id": 20,
      "pss_id": 8,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 357,
      "name": "SolarOne Plant 357",
      "type": "Wind",
      "qca_id": 21,
      "pss_id": 9,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 358,
      "name": "GreenWind Plant 358",
      "type": "Hybrid",
      "qca_id": 22,
      "pss_id": 10,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 359,
      "name": "SolarOne Plant 359",
      "type": "Hybrid",
      "qca_id": 23,
      "pss_id": 11,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 360,
      "name": "WindStar Plant 360",
      "type": "Hybrid",
      "qca_id": 24,
      "pss_id": 12,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 361,
      "name": "SunPower Plant 361",
      "type": "Wind",
      "qca_id": 1,
      "pss_id": 13,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 362,
      "name": "EcoHybrid Plant 362",
      "type": "Solar",
      "qca_id": 2,
      "pss_id": 14,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 363,
      "name": "GreenWind Plant 363",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 15,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 364,
      "name": "EcoHybrid Plant 364",
      "type": "Hybrid",
      "qca_id": 4,
      "pss_id": 16,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 365,
      "name": "GreenWind Plant 365",
      "type": "Solar",
      "qca_id": 5,
      "pss_id": 17,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 366,
      "name": "EcoHybrid Plant 366",
      "type": "Wind",
      "qca_id": 6,
      "pss_id": 18,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 367,
      "name": "WindStar Plant 367",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 19,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 368,
      "name": "SunPower Plant 368",
      "type": "Solar",
      "qca_id": 8,
      "pss_id": 20,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 369,
      "name": "GreenWind Plant 369",
      "type": "Wind",
      "qca_id": 9,
      "pss_id": 21,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 370,
      "name": "EcoHybrid Plant 370",
      "type": "Wind",
      "qca_id": 10,
      "pss_id": 22,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 371,
      "name": "GreenWind Plant 371",
      "type": "Wind",
      "qca_id": 11,
      "pss_id": 23,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 372,
      "name": "SunPower Plant 372",
      "type": "Hybrid",
      "qca_id": 12,
      "pss_id": 24,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 373,
      "name": "EcoHybrid Plant 373",
      "type": "Solar",
      "qca_id": 13,
      "pss_id": 25,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 374,
      "name": "SolarOne Plant 374",
      "type": "Hybrid",
      "qca_id": 14,
      "pss_id": 26,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 375,
      "name": "EcoHybrid Plant 375",
      "type": "Solar",
      "qca_id": 15,
      "pss_id": 27,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 376,
      "name": "GreenWind Plant 376",
      "type": "Wind",
      "qca_id": 16,
      "pss_id": 28,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 377,
      "name": "EcoHybrid Plant 377",
      "type": "Hybrid",
      "qca_id": 17,
      "pss_id": 29,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 378,
      "name": "EcoHybrid Plant 378",
      "type": "Hybrid",
      "qca_id": 18,
      "pss_id": 30,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 379,
      "name": "SolarOne Plant 379",
      "type": "Wind",
      "qca_id": 19,
      "pss_id": 31,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 380,
      "name": "SunPower Plant 380",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 32,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 381,
      "name": "GreenWind Plant 381",
      "type": "Wind",
      "qca_id": 21,
      "pss_id": 33,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 382,
      "name": "SunPower Plant 382",
      "type": "Wind",
      "qca_id": 22,
      "pss_id": 34,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 383,
      "name": "SolarOne Plant 383",
      "type": "Solar",
      "qca_id": 23,
      "pss_id": 35,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 384,
      "name": "SolarOne Plant 384",
      "type": "Solar",
      "qca_id": 24,
      "pss_id": 36,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 385,
      "name": "SunPower Plant 385",
      "type": "Wind",
      "qca_id": 1,
      "pss_id": 37,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 386,
      "name": "GreenWind Plant 386",
      "type": "Solar",
      "qca_id": 2,
      "pss_id": 38,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 387,
      "name": "GreenWind Plant 387",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 39,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 388,
      "name": "WindStar Plant 388",
      "type": "Solar",
      "qca_id": 4,
      "pss_id": 40,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 389,
      "name": "SolarOne Plant 389",
      "type": "Solar",
      "qca_id": 5,
      "pss_id": 41,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 390,
      "name": "WindStar Plant 390",
      "type": "Wind",
      "qca_id": 6,
      "pss_id": 42,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 391,
      "name": "EcoHybrid Plant 391",
      "type": "Solar",
      "qca_id": 7,
      "pss_id": 43,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 392,
      "name": "GreenWind Plant 392",
      "type": "Hybrid",
      "qca_id": 8,
      "pss_id": 44,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 393,
      "name": "SunPower Plant 393",
      "type": "Solar",
      "qca_id": 9,
      "pss_id": 45,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 394,
      "name": "SunPower Plant 394",
      "type": "Solar",
      "qca_id": 10,
      "pss_id": 46,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 395,
      "name": "GreenWind Plant 395",
      "type": "Wind",
      "qca_id": 11,
      "pss_id": 47,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 396,
      "name": "GreenWind Plant 396",
      "type": "Hybrid",
      "qca_id": 12,
      "pss_id": 48,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 397,
      "name": "WindStar Plant 397",
      "type": "Hybrid",
      "qca_id": 13,
      "pss_id": 49,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 398,
      "name": "WindStar Plant 398",
      "type": "Solar",
      "qca_id": 14,
      "pss_id": 50,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 399,
      "name": "SolarOne Plant 399",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 51,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 400,
      "name": "GreenWind Plant 400",
      "type": "Hybrid",
      "qca_id": 16,
      "pss_id": 52,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 401,
      "name": "EcoHybrid Plant 401",
      "type": "Solar",
      "qca_id": 17,
      "pss_id": 53,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 402,
      "name": "EcoHybrid Plant 402",
      "type": "Solar",
      "qca_id": 18,
      "pss_id": 54,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 403,
      "name": "EcoHybrid Plant 403",
      "type": "Wind",
      "qca_id": 19,
      "pss_id": 55,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 404,
      "name": "WindStar Plant 404",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 56,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 405,
      "name": "SolarOne Plant 405",
      "type": "Hybrid",
      "qca_id": 21,
      "pss_id": 57,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 406,
      "name": "SunPower Plant 406",
      "type": "Solar",
      "qca_id": 22,
      "pss_id": 58,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 407,
      "name": "WindStar Plant 407",
      "type": "Hybrid",
      "qca_id": 23,
      "pss_id": 59,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 408,
      "name": "SolarOne Plant 408",
      "type": "Wind",
      "qca_id": 24,
      "pss_id": 60,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 409,
      "name": "WindStar Plant 409",
      "type": "Solar",
      "qca_id": 1,
      "pss_id": 61,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 410,
      "name": "EcoHybrid Plant 410",
      "type": "Wind",
      "qca_id": 2,
      "pss_id": 62,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 411,
      "name": "GreenWind Plant 411",
      "type": "Wind",
      "qca_id": 3,
      "pss_id": 63,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 412,
      "name": "WindStar Plant 412",
      "type": "Hybrid",
      "qca_id": 4,
      "pss_id": 64,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 413,
      "name": "WindStar Plant 413",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 65,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 414,
      "name": "EcoHybrid Plant 414",
      "type": "Hybrid",
      "qca_id": 6,
      "pss_id": 66,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 415,
      "name": "GreenWind Plant 415",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 67,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 416,
      "name": "SolarOne Plant 416",
      "type": "Hybrid",
      "qca_id": 8,
      "pss_id": 68,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 417,
      "name": "SunPower Plant 417",
      "type": "Wind",
      "qca_id": 9,
      "pss_id": 69,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 418,
      "name": "SolarOne Plant 418",
      "type": "Solar",
      "qca_id": 10,
      "pss_id": 70,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 419,
      "name": "EcoHybrid Plant 419",
      "type": "Solar",
      "qca_id": 11,
      "pss_id": 71,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 420,
      "name": "EcoHybrid Plant 420",
      "type": "Solar",
      "qca_id": 12,
      "pss_id": 72,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 421,
      "name": "EcoHybrid Plant 421",
      "type": "Solar",
      "qca_id": 13,
      "pss_id": 73,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 422,
      "name": "SunPower Plant 422",
      "type": "Hybrid",
      "qca_id": 14,
      "pss_id": 74,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 423,
      "name": "SunPower Plant 423",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 75,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 424,
      "name": "GreenWind Plant 424",
      "type": "Wind",
      "qca_id": 16,
      "pss_id": 76,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 425,
      "name": "SunPower Plant 425",
      "type": "Solar",
      "qca_id": 17,
      "pss_id": 77,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 426,
      "name": "WindStar Plant 426",
      "type": "Wind",
      "qca_id": 18,
      "pss_id": 78,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 427,
      "name": "WindStar Plant 427",
      "type": "Hybrid",
      "qca_id": 19,
      "pss_id": 79,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 428,
      "name": "SolarOne Plant 428",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 80,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 429,
      "name": "SunPower Plant 429",
      "type": "Wind",
      "qca_id": 21,
      "pss_id": 81,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 430,
      "name": "SunPower Plant 430",
      "type": "Hybrid",
      "qca_id": 22,
      "pss_id": 82,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 431,
      "name": "GreenWind Plant 431",
      "type": "Hybrid",
      "qca_id": 23,
      "pss_id": 83,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 432,
      "name": "EcoHybrid Plant 432",
      "type": "Wind",
      "qca_id": 24,
      "pss_id": 84,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 433,
      "name": "EcoHybrid Plant 433",
      "type": "Solar",
      "qca_id": 1,
      "pss_id": 85,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 434,
      "name": "SunPower Plant 434",
      "type": "Solar",
      "qca_id": 2,
      "pss_id": 86,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 435,
      "name": "GreenWind Plant 435",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 87,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 436,
      "name": "GreenWind Plant 436",
      "type": "Hybrid",
      "qca_id": 4,
      "pss_id": 88,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 437,
      "name": "SolarOne Plant 437",
      "type": "Hybrid",
      "qca_id": 5,
      "pss_id": 89,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 438,
      "name": "EcoHybrid Plant 438",
      "type": "Hybrid",
      "qca_id": 6,
      "pss_id": 90,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 439,
      "name": "WindStar Plant 439",
      "type": "Wind",
      "qca_id": 7,
      "pss_id": 91,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 440,
      "name": "SunPower Plant 440",
      "type": "Wind",
      "qca_id": 8,
      "pss_id": 92,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 441,
      "name": "SolarOne Plant 441",
      "type": "Wind",
      "qca_id": 9,
      "pss_id": 93,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 442,
      "name": "SunPower Plant 442",
      "type": "Hybrid",
      "qca_id": 10,
      "pss_id": 94,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 443,
      "name": "WindStar Plant 443",
      "type": "Solar",
      "qca_id": 11,
      "pss_id": 95,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 444,
      "name": "EcoHybrid Plant 444",
      "type": "Wind",
      "qca_id": 12,
      "pss_id": 96,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 445,
      "name": "GreenWind Plant 445",
      "type": "Solar",
      "qca_id": 13,
      "pss_id": 97,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 446,
      "name": "SolarOne Plant 446",
      "type": "Hybrid",
      "qca_id": 14,
      "pss_id": 98,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 447,
      "name": "GreenWind Plant 447",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 99,
      "installed_capacity_mw": 50,
      "status": "Operational"
    },
    {
      "generator_id": 448,
      "name": "SolarOne Plant 448",
      "type": "Wind",
      "qca_id": 16,
      "pss_id": 100,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 449,
      "name": "EcoHybrid Plant 449",
      "type": "Wind",
      "qca_id": 17,
      "pss_id": 101,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 450,
      "name": "GreenWind Plant 450",
      "type": "Wind",
      "qca_id": 18,
      "pss_id": 102,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 451,
      "name": "GreenWind Plant 451",
      "type": "Solar",
      "qca_id": 19,
      "pss_id": 103,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 452,
      "name": "SolarOne Plant 452",
      "type": "Wind",
      "qca_id": 20,
      "pss_id": 104,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 453,
      "name": "SunPower Plant 453",
      "type": "Wind",
      "qca_id": 21,
      "pss_id": 105,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 454,
      "name": "SunPower Plant 454",
      "type": "Solar",
      "qca_id": 22,
      "pss_id": 106,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 455,
      "name": "WindStar Plant 455",
      "type": "Hybrid",
      "qca_id": 23,
      "pss_id": 107,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 456,
      "name": "SunPower Plant 456",
      "type": "Wind",
      "qca_id": 24,
      "pss_id": 108,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 457,
      "name": "SunPower Plant 457",
      "type": "Solar",
      "qca_id": 1,
      "pss_id": 109,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 458,
      "name": "SolarOne Plant 458",
      "type": "Hybrid",
      "qca_id": 2,
      "pss_id": 110,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 459,
      "name": "SolarOne Plant 459",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 111,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 460,
      "name": "SolarOne Plant 460",
      "type": "Solar",
      "qca_id": 4,
      "pss_id": 112,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 461,
      "name": "SunPower Plant 461",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 113,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 462,
      "name": "SunPower Plant 462",
      "type": "Hybrid",
      "qca_id": 6,
      "pss_id": 114,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 463,
      "name": "SolarOne Plant 463",
      "type": "Hybrid",
      "qca_id": 7,
      "pss_id": 115,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 464,
      "name": "SolarOne Plant 464",
      "type": "Hybrid",
      "qca_id": 8,
      "pss_id": 116,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 465,
      "name": "WindStar Plant 465",
      "type": "Solar",
      "qca_id": 9,
      "pss_id": 1,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 466,
      "name": "SunPower Plant 466",
      "type": "Hybrid",
      "qca_id": 10,
      "pss_id": 2,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 467,
      "name": "SolarOne Plant 467",
      "type": "Wind",
      "qca_id": 11,
      "pss_id": 3,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 468,
      "name": "EcoHybrid Plant 468",
      "type": "Hybrid",
      "qca_id": 12,
      "pss_id": 4,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 469,
      "name": "SunPower Plant 469",
      "type": "Hybrid",
      "qca_id": 13,
      "pss_id": 5,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 470,
      "name": "SunPower Plant 470",
      "type": "Solar",
      "qca_id": 14,
      "pss_id": 6,
      "installed_capacity_mw": 30,
      "status": "Operational"
    },
    {
      "generator_id": 471,
      "name": "SunPower Plant 471",
      "type": "Wind",
      "qca_id": 15,
      "pss_id": 7,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 472,
      "name": "GreenWind Plant 472",
      "type": "Hybrid",
      "qca_id": 16,
      "pss_id": 8,
      "installed_capacity_mw": 100,
      "status": "Operational"
    },
    {
      "generator_id": 473,
      "name": "EcoHybrid Plant 473",
      "type": "Hybrid",
      "qca_id": 17,
      "pss_id": 9,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 474,
      "name": "WindStar Plant 474",
      "type": "Wind",
      "qca_id": 18,
      "pss_id": 10,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 475,
      "name": "WindStar Plant 475",
      "type": "Hybrid",
      "qca_id": 19,
      "pss_id": 11,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 476,
      "name": "EcoHybrid Plant 476",
      "type": "Solar",
      "qca_id": 20,
      "pss_id": 12,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 477,
      "name": "SunPower Plant 477",
      "type": "Hybrid",
      "qca_id": 21,
      "pss_id": 13,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 478,
      "name": "EcoHybrid Plant 478",
      "type": "Wind",
      "qca_id": 22,
      "pss_id": 14,
      "installed_capacity_mw": 75,
      "status": "Operational"
    },
    {
      "generator_id": 479,
      "name": "WindStar Plant 479",
      "type": "Solar",
      "qca_id": 23,
      "pss_id": 15,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 480,
      "name": "WindStar Plant 480",
      "type": "Hybrid",
      "qca_id": 24,
      "pss_id": 16,
      "installed_capacity_mw": 40,
      "status": "Operational"
    },
    {
      "generator_id": 481,
      "name": "SunPower Plant 481",
      "type": "Wind",
      "qca_id": 1,
      "pss_id": 17,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 482,
      "name": "SolarOne Plant 482",
      "type": "Hybrid",
      "qca_id": 2,
      "pss_id": 18,
      "installed_capacity_mw": 20,
      "status": "Operational"
    },
    {
      "generator_id": 483,
      "name": "EcoHybrid Plant 483",
      "type": "Hybrid",
      "qca_id": 3,
      "pss_id": 19,
      "installed_capacity_mw": 25,
      "status": "Operational"
    },
    {
      "generator_id": 484,
      "name": "WindStar Plant 484",
      "type": "Solar",
      "qca_id": 4,
      "pss_id": 20,
      "installed_capacity_mw": 120,
      "status": "Operational"
    },
    {
      "generator_id": 485,
      "name": "WindStar Plant 485",
      "type": "Wind",
      "qca_id": 5,
      "pss_id": 21,
      "installed_capacity_mw": 75,
      "status": "Operational"
    }
  ],
  "generator_units": [
    {
      "unit_id": 1,
      "generator_id": 1,
      "unit_code": "UNIT-0001",
      "unit_name": "GU-0001",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.71,
      "status": "Operational"
    },
    {
      "unit_id": 2,
      "generator_id": 1,
      "unit_code": "UNIT-0002",
      "unit_name": "GU-0002",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.18,
      "status": "Operational"
    },
    {
      "unit_id": 3,
      "generator_id": 2,
      "unit_code": "UNIT-0003",
      "unit_name": "GU-0003",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.01,
      "status": "Operational"
    },
    {
      "unit_id": 4,
      "generator_id": 2,
      "unit_code": "UNIT-0004",
      "unit_name": "GU-0004",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.55,
      "status": "Operational"
    },
    {
      "unit_id": 5,
      "generator_id": 3,
      "unit_code": "UNIT-0005",
      "unit_name": "GU-0005",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 53.3,
      "status": "Operational"
    },
    {
      "unit_id": 6,
      "generator_id": 3,
      "unit_code": "UNIT-0006",
      "unit_name": "GU-0006",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 58.71,
      "status": "Operational"
    },
    {
      "unit_id": 7,
      "generator_id": 4,
      "unit_code": "UNIT-0007",
      "unit_name": "GU-0007",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.39,
      "status": "Operational"
    },
    {
      "unit_id": 8,
      "generator_id": 4,
      "unit_code": "UNIT-0008",
      "unit_name": "GU-0008",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 43.01,
      "status": "Operational"
    },
    {
      "unit_id": 9,
      "generator_id": 5,
      "unit_code": "UNIT-0009",
      "unit_name": "GU-0009",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 37.28,
      "status": "Operational"
    },
    {
      "unit_id": 10,
      "generator_id": 5,
      "unit_code": "UNIT-0010",
      "unit_name": "GU-0010",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 30.22,
      "status": "Operational"
    },
    {
      "unit_id": 11,
      "generator_id": 6,
      "unit_code": "UNIT-0011",
      "unit_name": "GU-0011",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.78,
      "status": "Operational"
    },
    {
      "unit_id": 12,
      "generator_id": 6,
      "unit_code": "UNIT-0012",
      "unit_name": "GU-0012",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.04,
      "status": "Operational"
    },
    {
      "unit_id": 13,
      "generator_id": 7,
      "unit_code": "UNIT-0013",
      "unit_name": "GU-0013",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.92,
      "status": "Operational"
    },
    {
      "unit_id": 14,
      "generator_id": 7,
      "unit_code": "UNIT-0014",
      "unit_name": "GU-0014",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.24,
      "status": "Operational"
    },
    {
      "unit_id": 15,
      "generator_id": 8,
      "unit_code": "UNIT-0015",
      "unit_name": "GU-0015",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.36,
      "status": "Operational"
    },
    {
      "unit_id": 16,
      "generator_id": 8,
      "unit_code": "UNIT-0016",
      "unit_name": "GU-0016",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.4,
      "status": "Operational"
    },
    {
      "unit_id": 17,
      "generator_id": 9,
      "unit_code": "UNIT-0017",
      "unit_name": "GU-0017",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.97,
      "status": "Operational"
    },
    {
      "unit_id": 18,
      "generator_id": 9,
      "unit_code": "UNIT-0018",
      "unit_name": "GU-0018",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.83,
      "status": "Operational"
    },
    {
      "unit_id": 19,
      "generator_id": 10,
      "unit_code": "UNIT-0019",
      "unit_name": "GU-0019",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 42.04,
      "status": "Operational"
    },
    {
      "unit_id": 20,
      "generator_id": 10,
      "unit_code": "UNIT-0020",
      "unit_name": "GU-0020",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.49,
      "status": "Operational"
    },
    {
      "unit_id": 21,
      "generator_id": 11,
      "unit_code": "UNIT-0021",
      "unit_name": "GU-0021",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.51,
      "status": "Operational"
    },
    {
      "unit_id": 22,
      "generator_id": 11,
      "unit_code": "UNIT-0022",
      "unit_name": "GU-0022",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 55.8,
      "status": "Operational"
    },
    {
      "unit_id": 23,
      "generator_id": 12,
      "unit_code": "UNIT-0023",
      "unit_name": "GU-0023",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.71,
      "status": "Operational"
    },
    {
      "unit_id": 24,
      "generator_id": 12,
      "unit_code": "UNIT-0024",
      "unit_name": "GU-0024",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.11,
      "status": "Operational"
    },
    {
      "unit_id": 25,
      "generator_id": 13,
      "unit_code": "UNIT-0025",
      "unit_name": "GU-0025",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 51.62,
      "status": "Operational"
    },
    {
      "unit_id": 26,
      "generator_id": 13,
      "unit_code": "UNIT-0026",
      "unit_name": "GU-0026",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 58.61,
      "status": "Operational"
    },
    {
      "unit_id": 27,
      "generator_id": 14,
      "unit_code": "UNIT-0027",
      "unit_name": "GU-0027",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.33,
      "status": "Operational"
    },
    {
      "unit_id": 28,
      "generator_id": 14,
      "unit_code": "UNIT-0028",
      "unit_name": "GU-0028",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.77,
      "status": "Operational"
    },
    {
      "unit_id": 29,
      "generator_id": 15,
      "unit_code": "UNIT-0029",
      "unit_name": "GU-0029",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.46,
      "status": "Operational"
    },
    {
      "unit_id": 30,
      "generator_id": 15,
      "unit_code": "UNIT-0030",
      "unit_name": "GU-0030",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.37,
      "status": "Operational"
    },
    {
      "unit_id": 31,
      "generator_id": 16,
      "unit_code": "UNIT-0031",
      "unit_name": "GU-0031",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.21,
      "status": "Operational"
    },
    {
      "unit_id": 32,
      "generator_id": 16,
      "unit_code": "UNIT-0032",
      "unit_name": "GU-0032",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.98,
      "status": "Operational"
    },
    {
      "unit_id": 33,
      "generator_id": 17,
      "unit_code": "UNIT-0033",
      "unit_name": "GU-0033",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 51.52,
      "status": "Operational"
    },
    {
      "unit_id": 34,
      "generator_id": 17,
      "unit_code": "UNIT-0034",
      "unit_name": "GU-0034",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 52.41,
      "status": "Operational"
    },
    {
      "unit_id": 35,
      "generator_id": 18,
      "unit_code": "UNIT-0035",
      "unit_name": "GU-0035",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 35.03,
      "status": "Operational"
    },
    {
      "unit_id": 36,
      "generator_id": 18,
      "unit_code": "UNIT-0036",
      "unit_name": "GU-0036",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 32.67,
      "status": "Operational"
    },
    {
      "unit_id": 37,
      "generator_id": 19,
      "unit_code": "UNIT-0037",
      "unit_name": "GU-0037",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.66,
      "status": "Operational"
    },
    {
      "unit_id": 38,
      "generator_id": 19,
      "unit_code": "UNIT-0038",
      "unit_name": "GU-0038",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.43,
      "status": "Operational"
    },
    {
      "unit_id": 39,
      "generator_id": 20,
      "unit_code": "UNIT-0039",
      "unit_name": "GU-0039",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.1,
      "status": "Operational"
    },
    {
      "unit_id": 40,
      "generator_id": 20,
      "unit_code": "UNIT-0040",
      "unit_name": "GU-0040",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 46.61,
      "status": "Operational"
    },
    {
      "unit_id": 41,
      "generator_id": 21,
      "unit_code": "UNIT-0041",
      "unit_name": "GU-0041",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.34,
      "status": "Operational"
    },
    {
      "unit_id": 42,
      "generator_id": 21,
      "unit_code": "UNIT-0042",
      "unit_name": "GU-0042",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.36,
      "status": "Operational"
    },
    {
      "unit_id": 43,
      "generator_id": 22,
      "unit_code": "UNIT-0043",
      "unit_name": "GU-0043",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.35,
      "status": "Operational"
    },
    {
      "unit_id": 44,
      "generator_id": 22,
      "unit_code": "UNIT-0044",
      "unit_name": "GU-0044",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.04,
      "status": "Operational"
    },
    {
      "unit_id": 45,
      "generator_id": 23,
      "unit_code": "UNIT-0045",
      "unit_name": "GU-0045",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.8,
      "status": "Operational"
    },
    {
      "unit_id": 46,
      "generator_id": 23,
      "unit_code": "UNIT-0046",
      "unit_name": "GU-0046",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.07,
      "status": "Operational"
    },
    {
      "unit_id": 47,
      "generator_id": 24,
      "unit_code": "UNIT-0047",
      "unit_name": "GU-0047",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.55,
      "status": "Operational"
    },
    {
      "unit_id": 48,
      "generator_id": 24,
      "unit_code": "UNIT-0048",
      "unit_name": "GU-0048",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.77,
      "status": "Operational"
    },
    {
      "unit_id": 49,
      "generator_id": 25,
      "unit_code": "UNIT-0049",
      "unit_name": "GU-0049",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.88,
      "status": "Operational"
    },
    {
      "unit_id": 50,
      "generator_id": 25,
      "unit_code": "UNIT-0050",
      "unit_name": "GU-0050",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.59,
      "status": "Operational"
    },
    {
      "unit_id": 51,
      "generator_id": 26,
      "unit_code": "UNIT-0051",
      "unit_name": "GU-0051",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.11,
      "status": "Operational"
    },
    {
      "unit_id": 52,
      "generator_id": 26,
      "unit_code": "UNIT-0052",
      "unit_name": "GU-0052",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.48,
      "status": "Operational"
    },
    {
      "unit_id": 53,
      "generator_id": 27,
      "unit_code": "UNIT-0053",
      "unit_name": "GU-0053",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.74,
      "status": "Operational"
    },
    {
      "unit_id": 54,
      "generator_id": 27,
      "unit_code": "UNIT-0054",
      "unit_name": "GU-0054",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.91,
      "status": "Operational"
    },
    {
      "unit_id": 55,
      "generator_id": 28,
      "unit_code": "UNIT-0055",
      "unit_name": "GU-0055",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.21,
      "status": "Operational"
    },
    {
      "unit_id": 56,
      "generator_id": 28,
      "unit_code": "UNIT-0056",
      "unit_name": "GU-0056",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 47.44,
      "status": "Operational"
    },
    {
      "unit_id": 57,
      "generator_id": 29,
      "unit_code": "UNIT-0057",
      "unit_name": "GU-0057",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.83,
      "status": "Operational"
    },
    {
      "unit_id": 58,
      "generator_id": 29,
      "unit_code": "UNIT-0058",
      "unit_name": "GU-0058",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.48,
      "status": "Operational"
    },
    {
      "unit_id": 59,
      "generator_id": 30,
      "unit_code": "UNIT-0059",
      "unit_name": "GU-0059",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.39,
      "status": "Operational"
    },
    {
      "unit_id": 60,
      "generator_id": 30,
      "unit_code": "UNIT-0060",
      "unit_name": "GU-0060",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.94,
      "status": "Operational"
    },
    {
      "unit_id": 61,
      "generator_id": 31,
      "unit_code": "UNIT-0061",
      "unit_name": "GU-0061",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 48.77,
      "status": "Operational"
    },
    {
      "unit_id": 62,
      "generator_id": 31,
      "unit_code": "UNIT-0062",
      "unit_name": "GU-0062",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.22,
      "status": "Operational"
    },
    {
      "unit_id": 63,
      "generator_id": 32,
      "unit_code": "UNIT-0063",
      "unit_name": "GU-0063",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.92,
      "status": "Operational"
    },
    {
      "unit_id": 64,
      "generator_id": 32,
      "unit_code": "UNIT-0064",
      "unit_name": "GU-0064",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.79,
      "status": "Operational"
    },
    {
      "unit_id": 65,
      "generator_id": 33,
      "unit_code": "UNIT-0065",
      "unit_name": "GU-0065",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.69,
      "status": "Operational"
    },
    {
      "unit_id": 66,
      "generator_id": 33,
      "unit_code": "UNIT-0066",
      "unit_name": "GU-0066",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.59,
      "status": "Operational"
    },
    {
      "unit_id": 67,
      "generator_id": 34,
      "unit_code": "UNIT-0067",
      "unit_name": "GU-0067",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.23,
      "status": "Operational"
    },
    {
      "unit_id": 68,
      "generator_id": 34,
      "unit_code": "UNIT-0068",
      "unit_name": "GU-0068",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.28,
      "status": "Operational"
    },
    {
      "unit_id": 69,
      "generator_id": 35,
      "unit_code": "UNIT-0069",
      "unit_name": "GU-0069",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.04,
      "status": "Operational"
    },
    {
      "unit_id": 70,
      "generator_id": 35,
      "unit_code": "UNIT-0070",
      "unit_name": "GU-0070",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.52,
      "status": "Operational"
    },
    {
      "unit_id": 71,
      "generator_id": 36,
      "unit_code": "UNIT-0071",
      "unit_name": "GU-0071",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 31.52,
      "status": "Operational"
    },
    {
      "unit_id": 72,
      "generator_id": 36,
      "unit_code": "UNIT-0072",
      "unit_name": "GU-0072",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 35.6,
      "status": "Operational"
    },
    {
      "unit_id": 73,
      "generator_id": 37,
      "unit_code": "UNIT-0073",
      "unit_name": "GU-0073",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.42,
      "status": "Operational"
    },
    {
      "unit_id": 74,
      "generator_id": 37,
      "unit_code": "UNIT-0074",
      "unit_name": "GU-0074",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.94,
      "status": "Operational"
    },
    {
      "unit_id": 75,
      "generator_id": 38,
      "unit_code": "UNIT-0075",
      "unit_name": "GU-0075",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 31.22,
      "status": "Operational"
    },
    {
      "unit_id": 76,
      "generator_id": 38,
      "unit_code": "UNIT-0076",
      "unit_name": "GU-0076",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 32.54,
      "status": "Operational"
    },
    {
      "unit_id": 77,
      "generator_id": 39,
      "unit_code": "UNIT-0077",
      "unit_name": "GU-0077",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.2,
      "status": "Operational"
    },
    {
      "unit_id": 78,
      "generator_id": 39,
      "unit_code": "UNIT-0078",
      "unit_name": "GU-0078",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.48,
      "status": "Operational"
    },
    {
      "unit_id": 79,
      "generator_id": 40,
      "unit_code": "UNIT-0079",
      "unit_name": "GU-0079",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.86,
      "status": "Operational"
    },
    {
      "unit_id": 80,
      "generator_id": 40,
      "unit_code": "UNIT-0080",
      "unit_name": "GU-0080",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 48.68,
      "status": "Operational"
    },
    {
      "unit_id": 81,
      "generator_id": 41,
      "unit_code": "UNIT-0081",
      "unit_name": "GU-0081",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.65,
      "status": "Operational"
    },
    {
      "unit_id": 82,
      "generator_id": 41,
      "unit_code": "UNIT-0082",
      "unit_name": "GU-0082",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.47,
      "status": "Operational"
    },
    {
      "unit_id": 83,
      "generator_id": 42,
      "unit_code": "UNIT-0083",
      "unit_name": "GU-0083",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 46.62,
      "status": "Operational"
    },
    {
      "unit_id": 84,
      "generator_id": 42,
      "unit_code": "UNIT-0084",
      "unit_name": "GU-0084",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.42,
      "status": "Operational"
    },
    {
      "unit_id": 85,
      "generator_id": 43,
      "unit_code": "UNIT-0085",
      "unit_name": "GU-0085",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.37,
      "status": "Operational"
    },
    {
      "unit_id": 86,
      "generator_id": 43,
      "unit_code": "UNIT-0086",
      "unit_name": "GU-0086",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.6,
      "status": "Operational"
    },
    {
      "unit_id": 87,
      "generator_id": 44,
      "unit_code": "UNIT-0087",
      "unit_name": "GU-0087",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.01,
      "status": "Operational"
    },
    {
      "unit_id": 88,
      "generator_id": 44,
      "unit_code": "UNIT-0088",
      "unit_name": "GU-0088",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.18,
      "status": "Operational"
    },
    {
      "unit_id": 89,
      "generator_id": 45,
      "unit_code": "UNIT-0089",
      "unit_name": "GU-0089",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.47,
      "status": "Operational"
    },
    {
      "unit_id": 90,
      "generator_id": 45,
      "unit_code": "UNIT-0090",
      "unit_name": "GU-0090",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.45,
      "status": "Operational"
    },
    {
      "unit_id": 91,
      "generator_id": 46,
      "unit_code": "UNIT-0091",
      "unit_name": "GU-0091",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.05,
      "status": "Operational"
    },
    {
      "unit_id": 92,
      "generator_id": 46,
      "unit_code": "UNIT-0092",
      "unit_name": "GU-0092",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.45,
      "status": "Operational"
    },
    {
      "unit_id": 93,
      "generator_id": 47,
      "unit_code": "UNIT-0093",
      "unit_name": "GU-0093",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.23,
      "status": "Operational"
    },
    {
      "unit_id": 94,
      "generator_id": 47,
      "unit_code": "UNIT-0094",
      "unit_name": "GU-0094",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.09,
      "status": "Operational"
    },
    {
      "unit_id": 95,
      "generator_id": 48,
      "unit_code": "UNIT-0095",
      "unit_name": "GU-0095",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 58.73,
      "status": "Operational"
    },
    {
      "unit_id": 96,
      "generator_id": 48,
      "unit_code": "UNIT-0096",
      "unit_name": "GU-0096",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 53.82,
      "status": "Operational"
    },
    {
      "unit_id": 97,
      "generator_id": 49,
      "unit_code": "UNIT-0097",
      "unit_name": "GU-0097",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.91,
      "status": "Operational"
    },
    {
      "unit_id": 98,
      "generator_id": 49,
      "unit_code": "UNIT-0098",
      "unit_name": "GU-0098",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.83,
      "status": "Operational"
    },
    {
      "unit_id": 99,
      "generator_id": 50,
      "unit_code": "UNIT-0099",
      "unit_name": "GU-0099",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.38,
      "status": "Operational"
    },
    {
      "unit_id": 100,
      "generator_id": 50,
      "unit_code": "UNIT-0100",
      "unit_name": "GU-0100",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.39,
      "status": "Operational"
    },
    {
      "unit_id": 101,
      "generator_id": 51,
      "unit_code": "UNIT-0101",
      "unit_name": "GU-0101",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.29,
      "status": "Operational"
    },
    {
      "unit_id": 102,
      "generator_id": 51,
      "unit_code": "UNIT-0102",
      "unit_name": "GU-0102",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 42.27,
      "status": "Operational"
    },
    {
      "unit_id": 103,
      "generator_id": 52,
      "unit_code": "UNIT-0103",
      "unit_name": "GU-0103",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 49.77,
      "status": "Operational"
    },
    {
      "unit_id": 104,
      "generator_id": 52,
      "unit_code": "UNIT-0104",
      "unit_name": "GU-0104",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 58.47,
      "status": "Operational"
    },
    {
      "unit_id": 105,
      "generator_id": 53,
      "unit_code": "UNIT-0105",
      "unit_name": "GU-0105",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.93,
      "status": "Operational"
    },
    {
      "unit_id": 106,
      "generator_id": 53,
      "unit_code": "UNIT-0106",
      "unit_name": "GU-0106",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.7,
      "status": "Operational"
    },
    {
      "unit_id": 107,
      "generator_id": 54,
      "unit_code": "UNIT-0107",
      "unit_name": "GU-0107",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 35.07,
      "status": "Operational"
    },
    {
      "unit_id": 108,
      "generator_id": 54,
      "unit_code": "UNIT-0108",
      "unit_name": "GU-0108",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 34.74,
      "status": "Operational"
    },
    {
      "unit_id": 109,
      "generator_id": 55,
      "unit_code": "UNIT-0109",
      "unit_name": "GU-0109",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 31.09,
      "status": "Operational"
    },
    {
      "unit_id": 110,
      "generator_id": 55,
      "unit_code": "UNIT-0110",
      "unit_name": "GU-0110",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 30.87,
      "status": "Operational"
    },
    {
      "unit_id": 111,
      "generator_id": 56,
      "unit_code": "UNIT-0111",
      "unit_name": "GU-0111",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.08,
      "status": "Operational"
    },
    {
      "unit_id": 112,
      "generator_id": 56,
      "unit_code": "UNIT-0112",
      "unit_name": "GU-0112",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.3,
      "status": "Operational"
    },
    {
      "unit_id": 113,
      "generator_id": 57,
      "unit_code": "UNIT-0113",
      "unit_name": "GU-0113",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.8,
      "status": "Operational"
    },
    {
      "unit_id": 114,
      "generator_id": 57,
      "unit_code": "UNIT-0114",
      "unit_name": "GU-0114",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.91,
      "status": "Operational"
    },
    {
      "unit_id": 115,
      "generator_id": 58,
      "unit_code": "UNIT-0115",
      "unit_name": "GU-0115",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.06,
      "status": "Operational"
    },
    {
      "unit_id": 116,
      "generator_id": 58,
      "unit_code": "UNIT-0116",
      "unit_name": "GU-0116",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.19,
      "status": "Operational"
    },
    {
      "unit_id": 117,
      "generator_id": 59,
      "unit_code": "UNIT-0117",
      "unit_name": "GU-0117",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 50.06,
      "status": "Operational"
    },
    {
      "unit_id": 118,
      "generator_id": 59,
      "unit_code": "UNIT-0118",
      "unit_name": "GU-0118",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 58.86,
      "status": "Operational"
    },
    {
      "unit_id": 119,
      "generator_id": 60,
      "unit_code": "UNIT-0119",
      "unit_name": "GU-0119",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.91,
      "status": "Operational"
    },
    {
      "unit_id": 120,
      "generator_id": 60,
      "unit_code": "UNIT-0120",
      "unit_name": "GU-0120",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 48.91,
      "status": "Operational"
    },
    {
      "unit_id": 121,
      "generator_id": 61,
      "unit_code": "UNIT-0121",
      "unit_name": "GU-0121",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.95,
      "status": "Operational"
    },
    {
      "unit_id": 122,
      "generator_id": 61,
      "unit_code": "UNIT-0122",
      "unit_name": "GU-0122",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.96,
      "status": "Operational"
    },
    {
      "unit_id": 123,
      "generator_id": 62,
      "unit_code": "UNIT-0123",
      "unit_name": "GU-0123",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.95,
      "status": "Operational"
    },
    {
      "unit_id": 124,
      "generator_id": 62,
      "unit_code": "UNIT-0124",
      "unit_name": "GU-0124",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.55,
      "status": "Operational"
    },
    {
      "unit_id": 125,
      "generator_id": 63,
      "unit_code": "UNIT-0125",
      "unit_name": "GU-0125",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.71,
      "status": "Operational"
    },
    {
      "unit_id": 126,
      "generator_id": 63,
      "unit_code": "UNIT-0126",
      "unit_name": "GU-0126",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.3,
      "status": "Operational"
    },
    {
      "unit_id": 127,
      "generator_id": 64,
      "unit_code": "UNIT-0127",
      "unit_name": "GU-0127",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 51.69,
      "status": "Operational"
    },
    {
      "unit_id": 128,
      "generator_id": 64,
      "unit_code": "UNIT-0128",
      "unit_name": "GU-0128",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 55.69,
      "status": "Operational"
    },
    {
      "unit_id": 129,
      "generator_id": 65,
      "unit_code": "UNIT-0129",
      "unit_name": "GU-0129",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.62,
      "status": "Operational"
    },
    {
      "unit_id": 130,
      "generator_id": 65,
      "unit_code": "UNIT-0130",
      "unit_name": "GU-0130",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.34,
      "status": "Operational"
    },
    {
      "unit_id": 131,
      "generator_id": 66,
      "unit_code": "UNIT-0131",
      "unit_name": "GU-0131",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 49.16,
      "status": "Operational"
    },
    {
      "unit_id": 132,
      "generator_id": 66,
      "unit_code": "UNIT-0132",
      "unit_name": "GU-0132",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 55.21,
      "status": "Operational"
    },
    {
      "unit_id": 133,
      "generator_id": 67,
      "unit_code": "UNIT-0133",
      "unit_name": "GU-0133",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.42,
      "status": "Operational"
    },
    {
      "unit_id": 134,
      "generator_id": 67,
      "unit_code": "UNIT-0134",
      "unit_name": "GU-0134",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.32,
      "status": "Operational"
    },
    {
      "unit_id": 135,
      "generator_id": 68,
      "unit_code": "UNIT-0135",
      "unit_name": "GU-0135",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.68,
      "status": "Operational"
    },
    {
      "unit_id": 136,
      "generator_id": 68,
      "unit_code": "UNIT-0136",
      "unit_name": "GU-0136",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.95,
      "status": "Operational"
    },
    {
      "unit_id": 137,
      "generator_id": 69,
      "unit_code": "UNIT-0137",
      "unit_name": "GU-0137",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.04,
      "status": "Operational"
    },
    {
      "unit_id": 138,
      "generator_id": 69,
      "unit_code": "UNIT-0138",
      "unit_name": "GU-0138",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.9,
      "status": "Operational"
    },
    {
      "unit_id": 139,
      "generator_id": 70,
      "unit_code": "UNIT-0139",
      "unit_name": "GU-0139",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 34.14,
      "status": "Operational"
    },
    {
      "unit_id": 140,
      "generator_id": 70,
      "unit_code": "UNIT-0140",
      "unit_name": "GU-0140",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 36.43,
      "status": "Operational"
    },
    {
      "unit_id": 141,
      "generator_id": 71,
      "unit_code": "UNIT-0141",
      "unit_name": "GU-0141",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.14,
      "status": "Operational"
    },
    {
      "unit_id": 142,
      "generator_id": 71,
      "unit_code": "UNIT-0142",
      "unit_name": "GU-0142",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.54,
      "status": "Operational"
    },
    {
      "unit_id": 143,
      "generator_id": 72,
      "unit_code": "UNIT-0143",
      "unit_name": "GU-0143",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.33,
      "status": "Operational"
    },
    {
      "unit_id": 144,
      "generator_id": 72,
      "unit_code": "UNIT-0144",
      "unit_name": "GU-0144",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.01,
      "status": "Operational"
    },
    {
      "unit_id": 145,
      "generator_id": 73,
      "unit_code": "UNIT-0145",
      "unit_name": "GU-0145",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 37.17,
      "status": "Operational"
    },
    {
      "unit_id": 146,
      "generator_id": 73,
      "unit_code": "UNIT-0146",
      "unit_name": "GU-0146",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 34.47,
      "status": "Operational"
    },
    {
      "unit_id": 147,
      "generator_id": 74,
      "unit_code": "UNIT-0147",
      "unit_name": "GU-0147",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.85,
      "status": "Operational"
    },
    {
      "unit_id": 148,
      "generator_id": 74,
      "unit_code": "UNIT-0148",
      "unit_name": "GU-0148",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 43.13,
      "status": "Operational"
    },
    {
      "unit_id": 149,
      "generator_id": 75,
      "unit_code": "UNIT-0149",
      "unit_name": "GU-0149",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 31.73,
      "status": "Operational"
    },
    {
      "unit_id": 150,
      "generator_id": 75,
      "unit_code": "UNIT-0150",
      "unit_name": "GU-0150",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 34.59,
      "status": "Operational"
    },
    {
      "unit_id": 151,
      "generator_id": 76,
      "unit_code": "UNIT-0151",
      "unit_name": "GU-0151",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 42.33,
      "status": "Operational"
    },
    {
      "unit_id": 152,
      "generator_id": 76,
      "unit_code": "UNIT-0152",
      "unit_name": "GU-0152",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 42.46,
      "status": "Operational"
    },
    {
      "unit_id": 153,
      "generator_id": 77,
      "unit_code": "UNIT-0153",
      "unit_name": "GU-0153",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.16,
      "status": "Operational"
    },
    {
      "unit_id": 154,
      "generator_id": 77,
      "unit_code": "UNIT-0154",
      "unit_name": "GU-0154",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.77,
      "status": "Operational"
    },
    {
      "unit_id": 155,
      "generator_id": 78,
      "unit_code": "UNIT-0155",
      "unit_name": "GU-0155",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.47,
      "status": "Operational"
    },
    {
      "unit_id": 156,
      "generator_id": 78,
      "unit_code": "UNIT-0156",
      "unit_name": "GU-0156",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.04,
      "status": "Operational"
    },
    {
      "unit_id": 157,
      "generator_id": 79,
      "unit_code": "UNIT-0157",
      "unit_name": "GU-0157",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.1,
      "status": "Operational"
    },
    {
      "unit_id": 158,
      "generator_id": 79,
      "unit_code": "UNIT-0158",
      "unit_name": "GU-0158",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 53.67,
      "status": "Operational"
    },
    {
      "unit_id": 159,
      "generator_id": 80,
      "unit_code": "UNIT-0159",
      "unit_name": "GU-0159",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.81,
      "status": "Operational"
    },
    {
      "unit_id": 160,
      "generator_id": 80,
      "unit_code": "UNIT-0160",
      "unit_name": "GU-0160",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.24,
      "status": "Operational"
    },
    {
      "unit_id": 161,
      "generator_id": 81,
      "unit_code": "UNIT-0161",
      "unit_name": "GU-0161",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.7,
      "status": "Operational"
    },
    {
      "unit_id": 162,
      "generator_id": 81,
      "unit_code": "UNIT-0162",
      "unit_name": "GU-0162",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.83,
      "status": "Operational"
    },
    {
      "unit_id": 163,
      "generator_id": 82,
      "unit_code": "UNIT-0163",
      "unit_name": "GU-0163",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.66,
      "status": "Operational"
    },
    {
      "unit_id": 164,
      "generator_id": 82,
      "unit_code": "UNIT-0164",
      "unit_name": "GU-0164",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.4,
      "status": "Operational"
    },
    {
      "unit_id": 165,
      "generator_id": 83,
      "unit_code": "UNIT-0165",
      "unit_name": "GU-0165",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.01,
      "status": "Operational"
    },
    {
      "unit_id": 166,
      "generator_id": 83,
      "unit_code": "UNIT-0166",
      "unit_name": "GU-0166",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.46,
      "status": "Operational"
    },
    {
      "unit_id": 167,
      "generator_id": 84,
      "unit_code": "UNIT-0167",
      "unit_name": "GU-0167",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.72,
      "status": "Operational"
    },
    {
      "unit_id": 168,
      "generator_id": 84,
      "unit_code": "UNIT-0168",
      "unit_name": "GU-0168",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.94,
      "status": "Operational"
    },
    {
      "unit_id": 169,
      "generator_id": 85,
      "unit_code": "UNIT-0169",
      "unit_name": "GU-0169",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 42.43,
      "status": "Operational"
    },
    {
      "unit_id": 170,
      "generator_id": 85,
      "unit_code": "UNIT-0170",
      "unit_name": "GU-0170",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.98,
      "status": "Operational"
    },
    {
      "unit_id": 171,
      "generator_id": 86,
      "unit_code": "UNIT-0171",
      "unit_name": "GU-0171",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 50.95,
      "status": "Operational"
    },
    {
      "unit_id": 172,
      "generator_id": 86,
      "unit_code": "UNIT-0172",
      "unit_name": "GU-0172",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 56.1,
      "status": "Operational"
    },
    {
      "unit_id": 173,
      "generator_id": 87,
      "unit_code": "UNIT-0173",
      "unit_name": "GU-0173",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.44,
      "status": "Operational"
    },
    {
      "unit_id": 174,
      "generator_id": 87,
      "unit_code": "UNIT-0174",
      "unit_name": "GU-0174",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.43,
      "status": "Operational"
    },
    {
      "unit_id": 175,
      "generator_id": 88,
      "unit_code": "UNIT-0175",
      "unit_name": "GU-0175",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.88,
      "status": "Operational"
    },
    {
      "unit_id": 176,
      "generator_id": 88,
      "unit_code": "UNIT-0176",
      "unit_name": "GU-0176",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.27,
      "status": "Operational"
    },
    {
      "unit_id": 177,
      "generator_id": 89,
      "unit_code": "UNIT-0177",
      "unit_name": "GU-0177",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.72,
      "status": "Operational"
    },
    {
      "unit_id": 178,
      "generator_id": 89,
      "unit_code": "UNIT-0178",
      "unit_name": "GU-0178",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.59,
      "status": "Operational"
    },
    {
      "unit_id": 179,
      "generator_id": 90,
      "unit_code": "UNIT-0179",
      "unit_name": "GU-0179",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.61,
      "status": "Operational"
    },
    {
      "unit_id": 180,
      "generator_id": 90,
      "unit_code": "UNIT-0180",
      "unit_name": "GU-0180",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.58,
      "status": "Operational"
    },
    {
      "unit_id": 181,
      "generator_id": 91,
      "unit_code": "UNIT-0181",
      "unit_name": "GU-0181",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 57.01,
      "status": "Operational"
    },
    {
      "unit_id": 182,
      "generator_id": 91,
      "unit_code": "UNIT-0182",
      "unit_name": "GU-0182",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 49.49,
      "status": "Operational"
    },
    {
      "unit_id": 183,
      "generator_id": 92,
      "unit_code": "UNIT-0183",
      "unit_name": "GU-0183",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.74,
      "status": "Operational"
    },
    {
      "unit_id": 184,
      "generator_id": 92,
      "unit_code": "UNIT-0184",
      "unit_name": "GU-0184",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.45,
      "status": "Operational"
    },
    {
      "unit_id": 185,
      "generator_id": 93,
      "unit_code": "UNIT-0185",
      "unit_name": "GU-0185",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.38,
      "status": "Operational"
    },
    {
      "unit_id": 186,
      "generator_id": 93,
      "unit_code": "UNIT-0186",
      "unit_name": "GU-0186",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.26,
      "status": "Operational"
    },
    {
      "unit_id": 187,
      "generator_id": 94,
      "unit_code": "UNIT-0187",
      "unit_name": "GU-0187",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.9,
      "status": "Operational"
    },
    {
      "unit_id": 188,
      "generator_id": 94,
      "unit_code": "UNIT-0188",
      "unit_name": "GU-0188",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.37,
      "status": "Operational"
    },
    {
      "unit_id": 189,
      "generator_id": 95,
      "unit_code": "UNIT-0189",
      "unit_name": "GU-0189",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.89,
      "status": "Operational"
    },
    {
      "unit_id": 190,
      "generator_id": 95,
      "unit_code": "UNIT-0190",
      "unit_name": "GU-0190",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.63,
      "status": "Operational"
    },
    {
      "unit_id": 191,
      "generator_id": 96,
      "unit_code": "UNIT-0191",
      "unit_name": "GU-0191",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 45.33,
      "status": "Operational"
    },
    {
      "unit_id": 192,
      "generator_id": 96,
      "unit_code": "UNIT-0192",
      "unit_name": "GU-0192",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.07,
      "status": "Operational"
    },
    {
      "unit_id": 193,
      "generator_id": 97,
      "unit_code": "UNIT-0193",
      "unit_name": "GU-0193",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.38,
      "status": "Operational"
    },
    {
      "unit_id": 194,
      "generator_id": 97,
      "unit_code": "UNIT-0194",
      "unit_name": "GU-0194",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.69,
      "status": "Operational"
    },
    {
      "unit_id": 195,
      "generator_id": 98,
      "unit_code": "UNIT-0195",
      "unit_name": "GU-0195",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.02,
      "status": "Operational"
    },
    {
      "unit_id": 196,
      "generator_id": 98,
      "unit_code": "UNIT-0196",
      "unit_name": "GU-0196",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.79,
      "status": "Operational"
    },
    {
      "unit_id": 197,
      "generator_id": 99,
      "unit_code": "UNIT-0197",
      "unit_name": "GU-0197",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 59.36,
      "status": "Operational"
    },
    {
      "unit_id": 198,
      "generator_id": 99,
      "unit_code": "UNIT-0198",
      "unit_name": "GU-0198",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 51.39,
      "status": "Operational"
    },
    {
      "unit_id": 199,
      "generator_id": 100,
      "unit_code": "UNIT-0199",
      "unit_name": "GU-0199",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.55,
      "status": "Operational"
    },
    {
      "unit_id": 200,
      "generator_id": 100,
      "unit_code": "UNIT-0200",
      "unit_name": "GU-0200",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.06,
      "status": "Operational"
    },
    {
      "unit_id": 201,
      "generator_id": 101,
      "unit_code": "UNIT-0201",
      "unit_name": "GU-0201",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.64,
      "status": "Operational"
    },
    {
      "unit_id": 202,
      "generator_id": 101,
      "unit_code": "UNIT-0202",
      "unit_name": "GU-0202",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.33,
      "status": "Operational"
    },
    {
      "unit_id": 203,
      "generator_id": 102,
      "unit_code": "UNIT-0203",
      "unit_name": "GU-0203",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.48,
      "status": "Operational"
    },
    {
      "unit_id": 204,
      "generator_id": 102,
      "unit_code": "UNIT-0204",
      "unit_name": "GU-0204",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.53,
      "status": "Operational"
    },
    {
      "unit_id": 205,
      "generator_id": 103,
      "unit_code": "UNIT-0205",
      "unit_name": "GU-0205",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.84,
      "status": "Operational"
    },
    {
      "unit_id": 206,
      "generator_id": 103,
      "unit_code": "UNIT-0206",
      "unit_name": "GU-0206",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.19,
      "status": "Operational"
    },
    {
      "unit_id": 207,
      "generator_id": 104,
      "unit_code": "UNIT-0207",
      "unit_name": "GU-0207",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 46.61,
      "status": "Operational"
    },
    {
      "unit_id": 208,
      "generator_id": 104,
      "unit_code": "UNIT-0208",
      "unit_name": "GU-0208",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.76,
      "status": "Operational"
    },
    {
      "unit_id": 209,
      "generator_id": 105,
      "unit_code": "UNIT-0209",
      "unit_name": "GU-0209",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 42.71,
      "status": "Operational"
    },
    {
      "unit_id": 210,
      "generator_id": 105,
      "unit_code": "UNIT-0210",
      "unit_name": "GU-0210",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 42.42,
      "status": "Operational"
    },
    {
      "unit_id": 211,
      "generator_id": 106,
      "unit_code": "UNIT-0211",
      "unit_name": "GU-0211",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 32.61,
      "status": "Operational"
    },
    {
      "unit_id": 212,
      "generator_id": 106,
      "unit_code": "UNIT-0212",
      "unit_name": "GU-0212",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 30.5,
      "status": "Operational"
    },
    {
      "unit_id": 213,
      "generator_id": 107,
      "unit_code": "UNIT-0213",
      "unit_name": "GU-0213",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.55,
      "status": "Operational"
    },
    {
      "unit_id": 214,
      "generator_id": 107,
      "unit_code": "UNIT-0214",
      "unit_name": "GU-0214",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.13,
      "status": "Operational"
    },
    {
      "unit_id": 215,
      "generator_id": 108,
      "unit_code": "UNIT-0215",
      "unit_name": "GU-0215",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.96,
      "status": "Operational"
    },
    {
      "unit_id": 216,
      "generator_id": 108,
      "unit_code": "UNIT-0216",
      "unit_name": "GU-0216",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.41,
      "status": "Operational"
    },
    {
      "unit_id": 217,
      "generator_id": 109,
      "unit_code": "UNIT-0217",
      "unit_name": "GU-0217",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 55.38,
      "status": "Operational"
    },
    {
      "unit_id": 218,
      "generator_id": 109,
      "unit_code": "UNIT-0218",
      "unit_name": "GU-0218",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.15,
      "status": "Operational"
    },
    {
      "unit_id": 219,
      "generator_id": 110,
      "unit_code": "UNIT-0219",
      "unit_name": "GU-0219",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.5,
      "status": "Operational"
    },
    {
      "unit_id": 220,
      "generator_id": 110,
      "unit_code": "UNIT-0220",
      "unit_name": "GU-0220",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.49,
      "status": "Operational"
    },
    {
      "unit_id": 221,
      "generator_id": 111,
      "unit_code": "UNIT-0221",
      "unit_name": "GU-0221",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.48,
      "status": "Operational"
    },
    {
      "unit_id": 222,
      "generator_id": 111,
      "unit_code": "UNIT-0222",
      "unit_name": "GU-0222",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.72,
      "status": "Operational"
    },
    {
      "unit_id": 223,
      "generator_id": 112,
      "unit_code": "UNIT-0223",
      "unit_name": "GU-0223",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 51.12,
      "status": "Operational"
    },
    {
      "unit_id": 224,
      "generator_id": 112,
      "unit_code": "UNIT-0224",
      "unit_name": "GU-0224",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 52.79,
      "status": "Operational"
    },
    {
      "unit_id": 225,
      "generator_id": 113,
      "unit_code": "UNIT-0225",
      "unit_name": "GU-0225",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.91,
      "status": "Operational"
    },
    {
      "unit_id": 226,
      "generator_id": 113,
      "unit_code": "UNIT-0226",
      "unit_name": "GU-0226",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.52,
      "status": "Operational"
    },
    {
      "unit_id": 227,
      "generator_id": 114,
      "unit_code": "UNIT-0227",
      "unit_name": "GU-0227",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 56.52,
      "status": "Operational"
    },
    {
      "unit_id": 228,
      "generator_id": 114,
      "unit_code": "UNIT-0228",
      "unit_name": "GU-0228",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 50.15,
      "status": "Operational"
    },
    {
      "unit_id": 229,
      "generator_id": 115,
      "unit_code": "UNIT-0229",
      "unit_name": "GU-0229",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 34.53,
      "status": "Operational"
    },
    {
      "unit_id": 230,
      "generator_id": 115,
      "unit_code": "UNIT-0230",
      "unit_name": "GU-0230",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 30.81,
      "status": "Operational"
    },
    {
      "unit_id": 231,
      "generator_id": 116,
      "unit_code": "UNIT-0231",
      "unit_name": "GU-0231",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.98,
      "status": "Operational"
    },
    {
      "unit_id": 232,
      "generator_id": 116,
      "unit_code": "UNIT-0232",
      "unit_name": "GU-0232",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.04,
      "status": "Operational"
    },
    {
      "unit_id": 233,
      "generator_id": 117,
      "unit_code": "UNIT-0233",
      "unit_name": "GU-0233",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 48.53,
      "status": "Operational"
    },
    {
      "unit_id": 234,
      "generator_id": 117,
      "unit_code": "UNIT-0234",
      "unit_name": "GU-0234",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 58.15,
      "status": "Operational"
    },
    {
      "unit_id": 235,
      "generator_id": 118,
      "unit_code": "UNIT-0235",
      "unit_name": "GU-0235",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.93,
      "status": "Operational"
    },
    {
      "unit_id": 236,
      "generator_id": 118,
      "unit_code": "UNIT-0236",
      "unit_name": "GU-0236",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.25,
      "status": "Operational"
    },
    {
      "unit_id": 237,
      "generator_id": 119,
      "unit_code": "UNIT-0237",
      "unit_name": "GU-0237",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.41,
      "status": "Operational"
    },
    {
      "unit_id": 238,
      "generator_id": 119,
      "unit_code": "UNIT-0238",
      "unit_name": "GU-0238",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.39,
      "status": "Operational"
    },
    {
      "unit_id": 239,
      "generator_id": 120,
      "unit_code": "UNIT-0239",
      "unit_name": "GU-0239",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.26,
      "status": "Operational"
    },
    {
      "unit_id": 240,
      "generator_id": 120,
      "unit_code": "UNIT-0240",
      "unit_name": "GU-0240",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.3,
      "status": "Operational"
    },
    {
      "unit_id": 241,
      "generator_id": 121,
      "unit_code": "UNIT-0241",
      "unit_name": "GU-0241",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.66,
      "status": "Operational"
    },
    {
      "unit_id": 242,
      "generator_id": 121,
      "unit_code": "UNIT-0242",
      "unit_name": "GU-0242",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.87,
      "status": "Operational"
    },
    {
      "unit_id": 243,
      "generator_id": 122,
      "unit_code": "UNIT-0243",
      "unit_name": "GU-0243",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.34,
      "status": "Operational"
    },
    {
      "unit_id": 244,
      "generator_id": 122,
      "unit_code": "UNIT-0244",
      "unit_name": "GU-0244",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.16,
      "status": "Operational"
    },
    {
      "unit_id": 245,
      "generator_id": 123,
      "unit_code": "UNIT-0245",
      "unit_name": "GU-0245",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.08,
      "status": "Operational"
    },
    {
      "unit_id": 246,
      "generator_id": 123,
      "unit_code": "UNIT-0246",
      "unit_name": "GU-0246",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.36,
      "status": "Operational"
    },
    {
      "unit_id": 247,
      "generator_id": 124,
      "unit_code": "UNIT-0247",
      "unit_name": "GU-0247",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.37,
      "status": "Operational"
    },
    {
      "unit_id": 248,
      "generator_id": 124,
      "unit_code": "UNIT-0248",
      "unit_name": "GU-0248",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.95,
      "status": "Operational"
    },
    {
      "unit_id": 249,
      "generator_id": 125,
      "unit_code": "UNIT-0249",
      "unit_name": "GU-0249",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.93,
      "status": "Operational"
    },
    {
      "unit_id": 250,
      "generator_id": 125,
      "unit_code": "UNIT-0250",
      "unit_name": "GU-0250",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.14,
      "status": "Operational"
    },
    {
      "unit_id": 251,
      "generator_id": 126,
      "unit_code": "UNIT-0251",
      "unit_name": "GU-0251",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.04,
      "status": "Operational"
    },
    {
      "unit_id": 252,
      "generator_id": 126,
      "unit_code": "UNIT-0252",
      "unit_name": "GU-0252",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.21,
      "status": "Operational"
    },
    {
      "unit_id": 253,
      "generator_id": 127,
      "unit_code": "UNIT-0253",
      "unit_name": "GU-0253",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.74,
      "status": "Operational"
    },
    {
      "unit_id": 254,
      "generator_id": 127,
      "unit_code": "UNIT-0254",
      "unit_name": "GU-0254",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.55,
      "status": "Operational"
    },
    {
      "unit_id": 255,
      "generator_id": 128,
      "unit_code": "UNIT-0255",
      "unit_name": "GU-0255",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 43.59,
      "status": "Operational"
    },
    {
      "unit_id": 256,
      "generator_id": 128,
      "unit_code": "UNIT-0256",
      "unit_name": "GU-0256",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 48.6,
      "status": "Operational"
    },
    {
      "unit_id": 257,
      "generator_id": 129,
      "unit_code": "UNIT-0257",
      "unit_name": "GU-0257",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.74,
      "status": "Operational"
    },
    {
      "unit_id": 258,
      "generator_id": 129,
      "unit_code": "UNIT-0258",
      "unit_name": "GU-0258",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.48,
      "status": "Operational"
    },
    {
      "unit_id": 259,
      "generator_id": 130,
      "unit_code": "UNIT-0259",
      "unit_name": "GU-0259",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 48.25,
      "status": "Operational"
    },
    {
      "unit_id": 260,
      "generator_id": 130,
      "unit_code": "UNIT-0260",
      "unit_name": "GU-0260",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 48.49,
      "status": "Operational"
    },
    {
      "unit_id": 261,
      "generator_id": 131,
      "unit_code": "UNIT-0261",
      "unit_name": "GU-0261",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.83,
      "status": "Operational"
    },
    {
      "unit_id": 262,
      "generator_id": 131,
      "unit_code": "UNIT-0262",
      "unit_name": "GU-0262",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.82,
      "status": "Operational"
    },
    {
      "unit_id": 263,
      "generator_id": 132,
      "unit_code": "UNIT-0263",
      "unit_name": "GU-0263",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.19,
      "status": "Operational"
    },
    {
      "unit_id": 264,
      "generator_id": 132,
      "unit_code": "UNIT-0264",
      "unit_name": "GU-0264",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.99,
      "status": "Operational"
    },
    {
      "unit_id": 265,
      "generator_id": 133,
      "unit_code": "UNIT-0265",
      "unit_name": "GU-0265",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 35.73,
      "status": "Operational"
    },
    {
      "unit_id": 266,
      "generator_id": 133,
      "unit_code": "UNIT-0266",
      "unit_name": "GU-0266",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 30.27,
      "status": "Operational"
    },
    {
      "unit_id": 267,
      "generator_id": 134,
      "unit_code": "UNIT-0267",
      "unit_name": "GU-0267",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.95,
      "status": "Operational"
    },
    {
      "unit_id": 268,
      "generator_id": 134,
      "unit_code": "UNIT-0268",
      "unit_name": "GU-0268",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.0,
      "status": "Operational"
    },
    {
      "unit_id": 269,
      "generator_id": 135,
      "unit_code": "UNIT-0269",
      "unit_name": "GU-0269",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 47.08,
      "status": "Operational"
    },
    {
      "unit_id": 270,
      "generator_id": 135,
      "unit_code": "UNIT-0270",
      "unit_name": "GU-0270",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 42.81,
      "status": "Operational"
    },
    {
      "unit_id": 271,
      "generator_id": 136,
      "unit_code": "UNIT-0271",
      "unit_name": "GU-0271",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.98,
      "status": "Operational"
    },
    {
      "unit_id": 272,
      "generator_id": 136,
      "unit_code": "UNIT-0272",
      "unit_name": "GU-0272",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.16,
      "status": "Operational"
    },
    {
      "unit_id": 273,
      "generator_id": 137,
      "unit_code": "UNIT-0273",
      "unit_name": "GU-0273",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.48,
      "status": "Operational"
    },
    {
      "unit_id": 274,
      "generator_id": 137,
      "unit_code": "UNIT-0274",
      "unit_name": "GU-0274",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.67,
      "status": "Operational"
    },
    {
      "unit_id": 275,
      "generator_id": 138,
      "unit_code": "UNIT-0275",
      "unit_name": "GU-0275",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 55.76,
      "status": "Operational"
    },
    {
      "unit_id": 276,
      "generator_id": 138,
      "unit_code": "UNIT-0276",
      "unit_name": "GU-0276",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.87,
      "status": "Operational"
    },
    {
      "unit_id": 277,
      "generator_id": 139,
      "unit_code": "UNIT-0277",
      "unit_name": "GU-0277",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.49,
      "status": "Operational"
    },
    {
      "unit_id": 278,
      "generator_id": 139,
      "unit_code": "UNIT-0278",
      "unit_name": "GU-0278",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.94,
      "status": "Operational"
    },
    {
      "unit_id": 279,
      "generator_id": 140,
      "unit_code": "UNIT-0279",
      "unit_name": "GU-0279",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 46.89,
      "status": "Operational"
    },
    {
      "unit_id": 280,
      "generator_id": 140,
      "unit_code": "UNIT-0280",
      "unit_name": "GU-0280",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 45.95,
      "status": "Operational"
    },
    {
      "unit_id": 281,
      "generator_id": 141,
      "unit_code": "UNIT-0281",
      "unit_name": "GU-0281",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.98,
      "status": "Operational"
    },
    {
      "unit_id": 282,
      "generator_id": 141,
      "unit_code": "UNIT-0282",
      "unit_name": "GU-0282",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.96,
      "status": "Operational"
    },
    {
      "unit_id": 283,
      "generator_id": 142,
      "unit_code": "UNIT-0283",
      "unit_name": "GU-0283",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 50.85,
      "status": "Operational"
    },
    {
      "unit_id": 284,
      "generator_id": 142,
      "unit_code": "UNIT-0284",
      "unit_name": "GU-0284",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 49.83,
      "status": "Operational"
    },
    {
      "unit_id": 285,
      "generator_id": 143,
      "unit_code": "UNIT-0285",
      "unit_name": "GU-0285",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.15,
      "status": "Operational"
    },
    {
      "unit_id": 286,
      "generator_id": 143,
      "unit_code": "UNIT-0286",
      "unit_name": "GU-0286",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.22,
      "status": "Operational"
    },
    {
      "unit_id": 287,
      "generator_id": 144,
      "unit_code": "UNIT-0287",
      "unit_name": "GU-0287",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.79,
      "status": "Operational"
    },
    {
      "unit_id": 288,
      "generator_id": 144,
      "unit_code": "UNIT-0288",
      "unit_name": "GU-0288",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.21,
      "status": "Operational"
    },
    {
      "unit_id": 289,
      "generator_id": 145,
      "unit_code": "UNIT-0289",
      "unit_name": "GU-0289",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 47.41,
      "status": "Operational"
    },
    {
      "unit_id": 290,
      "generator_id": 145,
      "unit_code": "UNIT-0290",
      "unit_name": "GU-0290",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.45,
      "status": "Operational"
    },
    {
      "unit_id": 291,
      "generator_id": 146,
      "unit_code": "UNIT-0291",
      "unit_name": "GU-0291",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.72,
      "status": "Operational"
    },
    {
      "unit_id": 292,
      "generator_id": 146,
      "unit_code": "UNIT-0292",
      "unit_name": "GU-0292",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.85,
      "status": "Operational"
    },
    {
      "unit_id": 293,
      "generator_id": 147,
      "unit_code": "UNIT-0293",
      "unit_name": "GU-0293",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.02,
      "status": "Operational"
    },
    {
      "unit_id": 294,
      "generator_id": 147,
      "unit_code": "UNIT-0294",
      "unit_name": "GU-0294",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 55.32,
      "status": "Operational"
    },
    {
      "unit_id": 295,
      "generator_id": 148,
      "unit_code": "UNIT-0295",
      "unit_name": "GU-0295",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.08,
      "status": "Operational"
    },
    {
      "unit_id": 296,
      "generator_id": 148,
      "unit_code": "UNIT-0296",
      "unit_name": "GU-0296",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.41,
      "status": "Operational"
    },
    {
      "unit_id": 297,
      "generator_id": 149,
      "unit_code": "UNIT-0297",
      "unit_name": "GU-0297",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.1,
      "status": "Operational"
    },
    {
      "unit_id": 298,
      "generator_id": 149,
      "unit_code": "UNIT-0298",
      "unit_name": "GU-0298",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.96,
      "status": "Operational"
    },
    {
      "unit_id": 299,
      "generator_id": 150,
      "unit_code": "UNIT-0299",
      "unit_name": "GU-0299",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.66,
      "status": "Operational"
    },
    {
      "unit_id": 300,
      "generator_id": 150,
      "unit_code": "UNIT-0300",
      "unit_name": "GU-0300",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.45,
      "status": "Operational"
    },
    {
      "unit_id": 301,
      "generator_id": 151,
      "unit_code": "UNIT-0301",
      "unit_name": "GU-0301",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 36.09,
      "status": "Operational"
    },
    {
      "unit_id": 302,
      "generator_id": 151,
      "unit_code": "UNIT-0302",
      "unit_name": "GU-0302",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 37.02,
      "status": "Operational"
    },
    {
      "unit_id": 303,
      "generator_id": 152,
      "unit_code": "UNIT-0303",
      "unit_name": "GU-0303",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.09,
      "status": "Operational"
    },
    {
      "unit_id": 304,
      "generator_id": 152,
      "unit_code": "UNIT-0304",
      "unit_name": "GU-0304",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.46,
      "status": "Operational"
    },
    {
      "unit_id": 305,
      "generator_id": 153,
      "unit_code": "UNIT-0305",
      "unit_name": "GU-0305",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.38,
      "status": "Operational"
    },
    {
      "unit_id": 306,
      "generator_id": 153,
      "unit_code": "UNIT-0306",
      "unit_name": "GU-0306",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.55,
      "status": "Operational"
    },
    {
      "unit_id": 307,
      "generator_id": 154,
      "unit_code": "UNIT-0307",
      "unit_name": "GU-0307",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.92,
      "status": "Operational"
    },
    {
      "unit_id": 308,
      "generator_id": 154,
      "unit_code": "UNIT-0308",
      "unit_name": "GU-0308",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.41,
      "status": "Operational"
    },
    {
      "unit_id": 309,
      "generator_id": 155,
      "unit_code": "UNIT-0309",
      "unit_name": "GU-0309",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.78,
      "status": "Operational"
    },
    {
      "unit_id": 310,
      "generator_id": 155,
      "unit_code": "UNIT-0310",
      "unit_name": "GU-0310",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.35,
      "status": "Operational"
    },
    {
      "unit_id": 311,
      "generator_id": 156,
      "unit_code": "UNIT-0311",
      "unit_name": "GU-0311",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 58.66,
      "status": "Operational"
    },
    {
      "unit_id": 312,
      "generator_id": 156,
      "unit_code": "UNIT-0312",
      "unit_name": "GU-0312",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.48,
      "status": "Operational"
    },
    {
      "unit_id": 313,
      "generator_id": 157,
      "unit_code": "UNIT-0313",
      "unit_name": "GU-0313",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.58,
      "status": "Operational"
    },
    {
      "unit_id": 314,
      "generator_id": 157,
      "unit_code": "UNIT-0314",
      "unit_name": "GU-0314",
      "technology": "Wind",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.68,
      "status": "Operational"
    },
    {
      "unit_id": 315,
      "generator_id": 158,
      "unit_code": "UNIT-0315",
      "unit_name": "GU-0315",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.83,
      "status": "Operational"
    },
    {
      "unit_id": 316,
      "generator_id": 158,
      "unit_code": "UNIT-0316",
      "unit_name": "GU-0316",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.73,
      "status": "Operational"
    },
    {
      "unit_id": 317,
      "generator_id": 159,
      "unit_code": "UNIT-0317",
      "unit_name": "GU-0317",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.65,
      "status": "Operational"
    },
    {
      "unit_id": 318,
      "generator_id": 159,
      "unit_code": "UNIT-0318",
      "unit_name": "GU-0318",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.33,
      "status": "Operational"
    },
    {
      "unit_id": 319,
      "generator_id": 160,
      "unit_code": "UNIT-0319",
      "unit_name": "GU-0319",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.14,
      "status": "Operational"
    },
    {
      "unit_id": 320,
      "generator_id": 160,
      "unit_code": "UNIT-0320",
      "unit_name": "GU-0320",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 47.38,
      "status": "Operational"
    },
    {
      "unit_id": 321,
      "generator_id": 161,
      "unit_code": "UNIT-0321",
      "unit_name": "GU-0321",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.91,
      "status": "Operational"
    },
    {
      "unit_id": 322,
      "generator_id": 161,
      "unit_code": "UNIT-0322",
      "unit_name": "GU-0322",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.65,
      "status": "Operational"
    },
    {
      "unit_id": 323,
      "generator_id": 162,
      "unit_code": "UNIT-0323",
      "unit_name": "GU-0323",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.28,
      "status": "Operational"
    },
    {
      "unit_id": 324,
      "generator_id": 162,
      "unit_code": "UNIT-0324",
      "unit_name": "GU-0324",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 56.95,
      "status": "Operational"
    },
    {
      "unit_id": 325,
      "generator_id": 163,
      "unit_code": "UNIT-0325",
      "unit_name": "GU-0325",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 50.26,
      "status": "Operational"
    },
    {
      "unit_id": 326,
      "generator_id": 163,
      "unit_code": "UNIT-0326",
      "unit_name": "GU-0326",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 52.74,
      "status": "Operational"
    },
    {
      "unit_id": 327,
      "generator_id": 164,
      "unit_code": "UNIT-0327",
      "unit_name": "GU-0327",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.41,
      "status": "Operational"
    },
    {
      "unit_id": 328,
      "generator_id": 164,
      "unit_code": "UNIT-0328",
      "unit_name": "GU-0328",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.52,
      "status": "Operational"
    },
    {
      "unit_id": 329,
      "generator_id": 165,
      "unit_code": "UNIT-0329",
      "unit_name": "GU-0329",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.79,
      "status": "Operational"
    },
    {
      "unit_id": 330,
      "generator_id": 165,
      "unit_code": "UNIT-0330",
      "unit_name": "GU-0330",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.25,
      "status": "Operational"
    },
    {
      "unit_id": 331,
      "generator_id": 166,
      "unit_code": "UNIT-0331",
      "unit_name": "GU-0331",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.58,
      "status": "Operational"
    },
    {
      "unit_id": 332,
      "generator_id": 166,
      "unit_code": "UNIT-0332",
      "unit_name": "GU-0332",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.56,
      "status": "Operational"
    },
    {
      "unit_id": 333,
      "generator_id": 167,
      "unit_code": "UNIT-0333",
      "unit_name": "GU-0333",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.32,
      "status": "Operational"
    },
    {
      "unit_id": 334,
      "generator_id": 167,
      "unit_code": "UNIT-0334",
      "unit_name": "GU-0334",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.96,
      "status": "Operational"
    },
    {
      "unit_id": 335,
      "generator_id": 168,
      "unit_code": "UNIT-0335",
      "unit_name": "GU-0335",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.77,
      "status": "Operational"
    },
    {
      "unit_id": 336,
      "generator_id": 168,
      "unit_code": "UNIT-0336",
      "unit_name": "GU-0336",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.34,
      "status": "Operational"
    },
    {
      "unit_id": 337,
      "generator_id": 169,
      "unit_code": "UNIT-0337",
      "unit_name": "GU-0337",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 32.18,
      "status": "Operational"
    },
    {
      "unit_id": 338,
      "generator_id": 169,
      "unit_code": "UNIT-0338",
      "unit_name": "GU-0338",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 32.22,
      "status": "Operational"
    },
    {
      "unit_id": 339,
      "generator_id": 170,
      "unit_code": "UNIT-0339",
      "unit_name": "GU-0339",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 47.15,
      "status": "Operational"
    },
    {
      "unit_id": 340,
      "generator_id": 170,
      "unit_code": "UNIT-0340",
      "unit_name": "GU-0340",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.82,
      "status": "Operational"
    },
    {
      "unit_id": 341,
      "generator_id": 171,
      "unit_code": "UNIT-0341",
      "unit_name": "GU-0341",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.74,
      "status": "Operational"
    },
    {
      "unit_id": 342,
      "generator_id": 171,
      "unit_code": "UNIT-0342",
      "unit_name": "GU-0342",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.08,
      "status": "Operational"
    },
    {
      "unit_id": 343,
      "generator_id": 172,
      "unit_code": "UNIT-0343",
      "unit_name": "GU-0343",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 32.37,
      "status": "Operational"
    },
    {
      "unit_id": 344,
      "generator_id": 172,
      "unit_code": "UNIT-0344",
      "unit_name": "GU-0344",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 35.56,
      "status": "Operational"
    },
    {
      "unit_id": 345,
      "generator_id": 173,
      "unit_code": "UNIT-0345",
      "unit_name": "GU-0345",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.58,
      "status": "Operational"
    },
    {
      "unit_id": 346,
      "generator_id": 173,
      "unit_code": "UNIT-0346",
      "unit_name": "GU-0346",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.97,
      "status": "Operational"
    },
    {
      "unit_id": 347,
      "generator_id": 174,
      "unit_code": "UNIT-0347",
      "unit_name": "GU-0347",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 34.95,
      "status": "Operational"
    },
    {
      "unit_id": 348,
      "generator_id": 174,
      "unit_code": "UNIT-0348",
      "unit_name": "GU-0348",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 34.12,
      "status": "Operational"
    },
    {
      "unit_id": 349,
      "generator_id": 175,
      "unit_code": "UNIT-0349",
      "unit_name": "GU-0349",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 30.96,
      "status": "Operational"
    },
    {
      "unit_id": 350,
      "generator_id": 175,
      "unit_code": "UNIT-0350",
      "unit_name": "GU-0350",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 32.63,
      "status": "Operational"
    },
    {
      "unit_id": 351,
      "generator_id": 176,
      "unit_code": "UNIT-0351",
      "unit_name": "GU-0351",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 33.05,
      "status": "Operational"
    },
    {
      "unit_id": 352,
      "generator_id": 176,
      "unit_code": "UNIT-0352",
      "unit_name": "GU-0352",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 34.22,
      "status": "Operational"
    },
    {
      "unit_id": 353,
      "generator_id": 177,
      "unit_code": "UNIT-0353",
      "unit_name": "GU-0353",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.83,
      "status": "Operational"
    },
    {
      "unit_id": 354,
      "generator_id": 177,
      "unit_code": "UNIT-0354",
      "unit_name": "GU-0354",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.81,
      "status": "Operational"
    },
    {
      "unit_id": 355,
      "generator_id": 178,
      "unit_code": "UNIT-0355",
      "unit_name": "GU-0355",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.6,
      "status": "Operational"
    },
    {
      "unit_id": 356,
      "generator_id": 178,
      "unit_code": "UNIT-0356",
      "unit_name": "GU-0356",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.21,
      "status": "Operational"
    },
    {
      "unit_id": 357,
      "generator_id": 179,
      "unit_code": "UNIT-0357",
      "unit_name": "GU-0357",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.68,
      "status": "Operational"
    },
    {
      "unit_id": 358,
      "generator_id": 179,
      "unit_code": "UNIT-0358",
      "unit_name": "GU-0358",
      "technology": "Solar",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.4,
      "status": "Operational"
    },
    {
      "unit_id": 359,
      "generator_id": 180,
      "unit_code": "UNIT-0359",
      "unit_name": "GU-0359",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 58.09,
      "status": "Operational"
    },
    {
      "unit_id": 360,
      "generator_id": 180,
      "unit_code": "UNIT-0360",
      "unit_name": "GU-0360",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 59.35,
      "status": "Operational"
    },
    {
      "unit_id": 361,
      "generator_id": 181,
      "unit_code": "UNIT-0361",
      "unit_name": "GU-0361",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 56.39,
      "status": "Operational"
    },
    {
      "unit_id": 362,
      "generator_id": 181,
      "unit_code": "UNIT-0362",
      "unit_name": "GU-0362",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.54,
      "status": "Operational"
    },
    {
      "unit_id": 363,
      "generator_id": 182,
      "unit_code": "UNIT-0363",
      "unit_name": "GU-0363",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.95,
      "status": "Operational"
    },
    {
      "unit_id": 364,
      "generator_id": 182,
      "unit_code": "UNIT-0364",
      "unit_name": "GU-0364",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.05,
      "status": "Operational"
    },
    {
      "unit_id": 365,
      "generator_id": 183,
      "unit_code": "UNIT-0365",
      "unit_name": "GU-0365",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 51.66,
      "status": "Operational"
    },
    {
      "unit_id": 366,
      "generator_id": 183,
      "unit_code": "UNIT-0366",
      "unit_name": "GU-0366",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 57.47,
      "status": "Operational"
    },
    {
      "unit_id": 367,
      "generator_id": 184,
      "unit_code": "UNIT-0367",
      "unit_name": "GU-0367",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.6,
      "status": "Operational"
    },
    {
      "unit_id": 368,
      "generator_id": 184,
      "unit_code": "UNIT-0368",
      "unit_name": "GU-0368",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.84,
      "status": "Operational"
    },
    {
      "unit_id": 369,
      "generator_id": 185,
      "unit_code": "UNIT-0369",
      "unit_name": "GU-0369",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 55.7,
      "status": "Operational"
    },
    {
      "unit_id": 370,
      "generator_id": 185,
      "unit_code": "UNIT-0370",
      "unit_name": "GU-0370",
      "technology": "Hybrid",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 51.4,
      "status": "Operational"
    },
    {
      "unit_id": 371,
      "generator_id": 186,
      "unit_code": "UNIT-0371",
      "unit_name": "GU-0371",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.06,
      "status": "Operational"
    },
    {
      "unit_id": 372,
      "generator_id": 186,
      "unit_code": "UNIT-0372",
      "unit_name": "GU-0372",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 44.61,
      "status": "Operational"
    },
    {
      "unit_id": 373,
      "generator_id": 187,
      "unit_code": "UNIT-0373",
      "unit_name": "GU-0373",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 43.46,
      "status": "Operational"
    },
    {
      "unit_id": 374,
      "generator_id": 187,
      "unit_code": "UNIT-0374",
      "unit_name": "GU-0374",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 47.6,
      "status": "Operational"
    },
    {
      "unit_id": 375,
      "generator_id": 188,
      "unit_code": "UNIT-0375",
      "unit_name": "GU-0375",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.45,
      "status": "Operational"
    },
    {
      "unit_id": 376,
      "generator_id": 188,
      "unit_code": "UNIT-0376",
      "unit_name": "GU-0376",
      "technology": "Solar",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.65,
      "status": "Operational"
    },
    {
      "unit_id": 377,
      "generator_id": 189,
      "unit_code": "UNIT-0377",
      "unit_name": "GU-0377",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 46.1,
      "status": "Operational"
    },
    {
      "unit_id": 378,
      "generator_id": 189,
      "unit_code": "UNIT-0378",
      "unit_name": "GU-0378",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 42.22,
      "status": "Operational"
    },
    {
      "unit_id": 379,
      "generator_id": 190,
      "unit_code": "UNIT-0379",
      "unit_name": "GU-0379",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.05,
      "status": "Operational"
    },
    {
      "unit_id": 380,
      "generator_id": 190,
      "unit_code": "UNIT-0380",
      "unit_name": "GU-0380",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.54,
      "status": "Operational"
    },
    {
      "unit_id": 381,
      "generator_id": 191,
      "unit_code": "UNIT-0381",
      "unit_name": "GU-0381",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 33.24,
      "status": "Operational"
    },
    {
      "unit_id": 382,
      "generator_id": 191,
      "unit_code": "UNIT-0382",
      "unit_name": "GU-0382",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 36.83,
      "status": "Operational"
    },
    {
      "unit_id": 383,
      "generator_id": 192,
      "unit_code": "UNIT-0383",
      "unit_name": "GU-0383",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.85,
      "status": "Operational"
    },
    {
      "unit_id": 384,
      "generator_id": 192,
      "unit_code": "UNIT-0384",
      "unit_name": "GU-0384",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.96,
      "status": "Operational"
    },
    {
      "unit_id": 385,
      "generator_id": 193,
      "unit_code": "UNIT-0385",
      "unit_name": "GU-0385",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 32.45,
      "status": "Operational"
    },
    {
      "unit_id": 386,
      "generator_id": 193,
      "unit_code": "UNIT-0386",
      "unit_name": "GU-0386",
      "technology": "Hybrid",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 30.79,
      "status": "Operational"
    },
    {
      "unit_id": 387,
      "generator_id": 194,
      "unit_code": "UNIT-0387",
      "unit_name": "GU-0387",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.96,
      "status": "Operational"
    },
    {
      "unit_id": 388,
      "generator_id": 194,
      "unit_code": "UNIT-0388",
      "unit_name": "GU-0388",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.52,
      "status": "Operational"
    },
    {
      "unit_id": 389,
      "generator_id": 195,
      "unit_code": "UNIT-0389",
      "unit_name": "GU-0389",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.91,
      "status": "Operational"
    },
    {
      "unit_id": 390,
      "generator_id": 195,
      "unit_code": "UNIT-0390",
      "unit_name": "GU-0390",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.36,
      "status": "Operational"
    },
    {
      "unit_id": 391,
      "generator_id": 196,
      "unit_code": "UNIT-0391",
      "unit_name": "GU-0391",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.11,
      "status": "Operational"
    },
    {
      "unit_id": 392,
      "generator_id": 196,
      "unit_code": "UNIT-0392",
      "unit_name": "GU-0392",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.98,
      "status": "Operational"
    },
    {
      "unit_id": 393,
      "generator_id": 197,
      "unit_code": "UNIT-0393",
      "unit_name": "GU-0393",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 51.06,
      "status": "Operational"
    },
    {
      "unit_id": 394,
      "generator_id": 197,
      "unit_code": "UNIT-0394",
      "unit_name": "GU-0394",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 58.96,
      "status": "Operational"
    },
    {
      "unit_id": 395,
      "generator_id": 198,
      "unit_code": "UNIT-0395",
      "unit_name": "GU-0395",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.66,
      "status": "Operational"
    },
    {
      "unit_id": 396,
      "generator_id": 198,
      "unit_code": "UNIT-0396",
      "unit_name": "GU-0396",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.14,
      "status": "Operational"
    },
    {
      "unit_id": 397,
      "generator_id": 199,
      "unit_code": "UNIT-0397",
      "unit_name": "GU-0397",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.58,
      "status": "Operational"
    },
    {
      "unit_id": 398,
      "generator_id": 199,
      "unit_code": "UNIT-0398",
      "unit_name": "GU-0398",
      "technology": "Hybrid",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 12.98,
      "status": "Operational"
    },
    {
      "unit_id": 399,
      "generator_id": 200,
      "unit_code": "UNIT-0399",
      "unit_name": "GU-0399",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 44.22,
      "status": "Operational"
    },
    {
      "unit_id": 400,
      "generator_id": 200,
      "unit_code": "UNIT-0400",
      "unit_name": "GU-0400",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.19,
      "status": "Operational"
    },
    {
      "unit_id": 401,
      "generator_id": 201,
      "unit_code": "UNIT-0401",
      "unit_name": "GU-0401",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 31.1,
      "status": "Operational"
    },
    {
      "unit_id": 402,
      "generator_id": 201,
      "unit_code": "UNIT-0402",
      "unit_name": "GU-0402",
      "technology": "Solar",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 32.07,
      "status": "Operational"
    },
    {
      "unit_id": 403,
      "generator_id": 202,
      "unit_code": "UNIT-0403",
      "unit_name": "GU-0403",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.93,
      "status": "Operational"
    },
    {
      "unit_id": 404,
      "generator_id": 202,
      "unit_code": "UNIT-0404",
      "unit_name": "GU-0404",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.86,
      "status": "Operational"
    },
    {
      "unit_id": 405,
      "generator_id": 203,
      "unit_code": "UNIT-0405",
      "unit_name": "GU-0405",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 46.09,
      "status": "Operational"
    },
    {
      "unit_id": 406,
      "generator_id": 203,
      "unit_code": "UNIT-0406",
      "unit_name": "GU-0406",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.18,
      "status": "Operational"
    },
    {
      "unit_id": 407,
      "generator_id": 204,
      "unit_code": "UNIT-0407",
      "unit_name": "GU-0407",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.89,
      "status": "Operational"
    },
    {
      "unit_id": 408,
      "generator_id": 204,
      "unit_code": "UNIT-0408",
      "unit_name": "GU-0408",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.37,
      "status": "Operational"
    },
    {
      "unit_id": 409,
      "generator_id": 205,
      "unit_code": "UNIT-0409",
      "unit_name": "GU-0409",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.12,
      "status": "Operational"
    },
    {
      "unit_id": 410,
      "generator_id": 205,
      "unit_code": "UNIT-0410",
      "unit_name": "GU-0410",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.6,
      "status": "Operational"
    },
    {
      "unit_id": 411,
      "generator_id": 206,
      "unit_code": "UNIT-0411",
      "unit_name": "GU-0411",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.95,
      "status": "Operational"
    },
    {
      "unit_id": 412,
      "generator_id": 206,
      "unit_code": "UNIT-0412",
      "unit_name": "GU-0412",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.5,
      "status": "Operational"
    },
    {
      "unit_id": 413,
      "generator_id": 207,
      "unit_code": "UNIT-0413",
      "unit_name": "GU-0413",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.4,
      "status": "Operational"
    },
    {
      "unit_id": 414,
      "generator_id": 207,
      "unit_code": "UNIT-0414",
      "unit_name": "GU-0414",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 51.9,
      "status": "Operational"
    },
    {
      "unit_id": 415,
      "generator_id": 208,
      "unit_code": "UNIT-0415",
      "unit_name": "GU-0415",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.34,
      "status": "Operational"
    },
    {
      "unit_id": 416,
      "generator_id": 208,
      "unit_code": "UNIT-0416",
      "unit_name": "GU-0416",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.0,
      "status": "Operational"
    },
    {
      "unit_id": 417,
      "generator_id": 209,
      "unit_code": "UNIT-0417",
      "unit_name": "GU-0417",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 48.66,
      "status": "Operational"
    },
    {
      "unit_id": 418,
      "generator_id": 209,
      "unit_code": "UNIT-0418",
      "unit_name": "GU-0418",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.69,
      "status": "Operational"
    },
    {
      "unit_id": 419,
      "generator_id": 210,
      "unit_code": "UNIT-0419",
      "unit_name": "GU-0419",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.21,
      "status": "Operational"
    },
    {
      "unit_id": 420,
      "generator_id": 210,
      "unit_code": "UNIT-0420",
      "unit_name": "GU-0420",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.11,
      "status": "Operational"
    },
    {
      "unit_id": 421,
      "generator_id": 211,
      "unit_code": "UNIT-0421",
      "unit_name": "GU-0421",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 53.82,
      "status": "Operational"
    },
    {
      "unit_id": 422,
      "generator_id": 211,
      "unit_code": "UNIT-0422",
      "unit_name": "GU-0422",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 53.43,
      "status": "Operational"
    },
    {
      "unit_id": 423,
      "generator_id": 212,
      "unit_code": "UNIT-0423",
      "unit_name": "GU-0423",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 13.3,
      "status": "Operational"
    },
    {
      "unit_id": 424,
      "generator_id": 212,
      "unit_code": "UNIT-0424",
      "unit_name": "GU-0424",
      "technology": "Wind",
      "rated_capacity_mw": 15.0,
      "available_capacity_mw": 14.65,
      "status": "Operational"
    },
    {
      "unit_id": 425,
      "generator_id": 213,
      "unit_code": "UNIT-0425",
      "unit_name": "GU-0425",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.18,
      "status": "Operational"
    },
    {
      "unit_id": 426,
      "generator_id": 213,
      "unit_code": "UNIT-0426",
      "unit_name": "GU-0426",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.83,
      "status": "Operational"
    },
    {
      "unit_id": 427,
      "generator_id": 214,
      "unit_code": "UNIT-0427",
      "unit_name": "GU-0427",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.06,
      "status": "Operational"
    },
    {
      "unit_id": 428,
      "generator_id": 214,
      "unit_code": "UNIT-0428",
      "unit_name": "GU-0428",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.33,
      "status": "Operational"
    },
    {
      "unit_id": 429,
      "generator_id": 215,
      "unit_code": "UNIT-0429",
      "unit_name": "GU-0429",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.08,
      "status": "Operational"
    },
    {
      "unit_id": 430,
      "generator_id": 215,
      "unit_code": "UNIT-0430",
      "unit_name": "GU-0430",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.84,
      "status": "Operational"
    },
    {
      "unit_id": 431,
      "generator_id": 216,
      "unit_code": "UNIT-0431",
      "unit_name": "GU-0431",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.44,
      "status": "Operational"
    },
    {
      "unit_id": 432,
      "generator_id": 216,
      "unit_code": "UNIT-0432",
      "unit_name": "GU-0432",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.44,
      "status": "Operational"
    },
    {
      "unit_id": 433,
      "generator_id": 217,
      "unit_code": "UNIT-0433",
      "unit_name": "GU-0433",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.23,
      "status": "Operational"
    },
    {
      "unit_id": 434,
      "generator_id": 217,
      "unit_code": "UNIT-0434",
      "unit_name": "GU-0434",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.75,
      "status": "Operational"
    },
    {
      "unit_id": 435,
      "generator_id": 218,
      "unit_code": "UNIT-0435",
      "unit_name": "GU-0435",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.31,
      "status": "Operational"
    },
    {
      "unit_id": 436,
      "generator_id": 218,
      "unit_code": "UNIT-0436",
      "unit_name": "GU-0436",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.31,
      "status": "Operational"
    },
    {
      "unit_id": 437,
      "generator_id": 219,
      "unit_code": "UNIT-0437",
      "unit_name": "GU-0437",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.34,
      "status": "Operational"
    },
    {
      "unit_id": 438,
      "generator_id": 219,
      "unit_code": "UNIT-0438",
      "unit_name": "GU-0438",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.87,
      "status": "Operational"
    },
    {
      "unit_id": 439,
      "generator_id": 220,
      "unit_code": "UNIT-0439",
      "unit_name": "GU-0439",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 33.44,
      "status": "Operational"
    },
    {
      "unit_id": 440,
      "generator_id": 220,
      "unit_code": "UNIT-0440",
      "unit_name": "GU-0440",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 30.47,
      "status": "Operational"
    },
    {
      "unit_id": 441,
      "generator_id": 221,
      "unit_code": "UNIT-0441",
      "unit_name": "GU-0441",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 53.51,
      "status": "Operational"
    },
    {
      "unit_id": 442,
      "generator_id": 221,
      "unit_code": "UNIT-0442",
      "unit_name": "GU-0442",
      "technology": "Solar",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.47,
      "status": "Operational"
    },
    {
      "unit_id": 443,
      "generator_id": 222,
      "unit_code": "UNIT-0443",
      "unit_name": "GU-0443",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 53.01,
      "status": "Operational"
    },
    {
      "unit_id": 444,
      "generator_id": 222,
      "unit_code": "UNIT-0444",
      "unit_name": "GU-0444",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 51.35,
      "status": "Operational"
    },
    {
      "unit_id": 445,
      "generator_id": 223,
      "unit_code": "UNIT-0445",
      "unit_name": "GU-0445",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 12.39,
      "status": "Operational"
    },
    {
      "unit_id": 446,
      "generator_id": 223,
      "unit_code": "UNIT-0446",
      "unit_name": "GU-0446",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.37,
      "status": "Operational"
    },
    {
      "unit_id": 447,
      "generator_id": 224,
      "unit_code": "UNIT-0447",
      "unit_name": "GU-0447",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.18,
      "status": "Operational"
    },
    {
      "unit_id": 448,
      "generator_id": 224,
      "unit_code": "UNIT-0448",
      "unit_name": "GU-0448",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.06,
      "status": "Operational"
    },
    {
      "unit_id": 449,
      "generator_id": 225,
      "unit_code": "UNIT-0449",
      "unit_name": "GU-0449",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 33.41,
      "status": "Operational"
    },
    {
      "unit_id": 450,
      "generator_id": 225,
      "unit_code": "UNIT-0450",
      "unit_name": "GU-0450",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 30.68,
      "status": "Operational"
    },
    {
      "unit_id": 451,
      "generator_id": 226,
      "unit_code": "UNIT-0451",
      "unit_name": "GU-0451",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 54.68,
      "status": "Operational"
    },
    {
      "unit_id": 452,
      "generator_id": 226,
      "unit_code": "UNIT-0452",
      "unit_name": "GU-0452",
      "technology": "Wind",
      "rated_capacity_mw": 60.0,
      "available_capacity_mw": 48.47,
      "status": "Operational"
    },
    {
      "unit_id": 453,
      "generator_id": 227,
      "unit_code": "UNIT-0453",
      "unit_name": "GU-0453",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.21,
      "status": "Operational"
    },
    {
      "unit_id": 454,
      "generator_id": 227,
      "unit_code": "UNIT-0454",
      "unit_name": "GU-0454",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.05,
      "status": "Operational"
    },
    {
      "unit_id": 455,
      "generator_id": 228,
      "unit_code": "UNIT-0455",
      "unit_name": "GU-0455",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.55,
      "status": "Operational"
    },
    {
      "unit_id": 456,
      "generator_id": 228,
      "unit_code": "UNIT-0456",
      "unit_name": "GU-0456",
      "technology": "Solar",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.28,
      "status": "Operational"
    },
    {
      "unit_id": 457,
      "generator_id": 229,
      "unit_code": "UNIT-0457",
      "unit_name": "GU-0457",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.41,
      "status": "Operational"
    },
    {
      "unit_id": 458,
      "generator_id": 229,
      "unit_code": "UNIT-0458",
      "unit_name": "GU-0458",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 43.09,
      "status": "Operational"
    },
    {
      "unit_id": 459,
      "generator_id": 230,
      "unit_code": "UNIT-0459",
      "unit_name": "GU-0459",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.58,
      "status": "Operational"
    },
    {
      "unit_id": 460,
      "generator_id": 230,
      "unit_code": "UNIT-0460",
      "unit_name": "GU-0460",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.77,
      "status": "Operational"
    },
    {
      "unit_id": 461,
      "generator_id": 231,
      "unit_code": "UNIT-0461",
      "unit_name": "GU-0461",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.97,
      "status": "Operational"
    },
    {
      "unit_id": 462,
      "generator_id": 231,
      "unit_code": "UNIT-0462",
      "unit_name": "GU-0462",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.94,
      "status": "Operational"
    },
    {
      "unit_id": 463,
      "generator_id": 232,
      "unit_code": "UNIT-0463",
      "unit_name": "GU-0463",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.06,
      "status": "Operational"
    },
    {
      "unit_id": 464,
      "generator_id": 232,
      "unit_code": "UNIT-0464",
      "unit_name": "GU-0464",
      "technology": "Hybrid",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 8.78,
      "status": "Operational"
    },
    {
      "unit_id": 465,
      "generator_id": 233,
      "unit_code": "UNIT-0465",
      "unit_name": "GU-0465",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.47,
      "status": "Operational"
    },
    {
      "unit_id": 466,
      "generator_id": 233,
      "unit_code": "UNIT-0466",
      "unit_name": "GU-0466",
      "technology": "Wind",
      "rated_capacity_mw": 10.0,
      "available_capacity_mw": 9.57,
      "status": "Operational"
    },
    {
      "unit_id": 467,
      "generator_id": 234,
      "unit_code": "UNIT-0467",
      "unit_name": "GU-0467",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 10.45,
      "status": "Operational"
    },
    {
      "unit_id": 468,
      "generator_id": 234,
      "unit_code": "UNIT-0468",
      "unit_name": "GU-0468",
      "technology": "Hybrid",
      "rated_capacity_mw": 12.5,
      "available_capacity_mw": 11.72,
      "status": "Operational"
    },
    {
      "unit_id": 469,
      "generator_id": 235,
      "unit_code": "UNIT-0469",
      "unit_name": "GU-0469",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 36.48,
      "status": "Operational"
    },
    {
      "unit_id": 470,
      "generator_id": 235,
      "unit_code": "UNIT-0470",
      "unit_name": "GU-0470",
      "technology": "Wind",
      "rated_capacity_mw": 37.5,
      "available_capacity_mw": 34.34,
      "status": "Operational"
    },
    {
      "unit_id": 471,
      "generator_id": 236,
      "unit_code": "UNIT-0471",
      "unit_name": "GU-0471",
      "technology": "Wind",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 65.3,
      "status": "Operational"
    },
    {
      "unit_id": 472,
      "generator_id": 237,
      "unit_code": "UNIT-0472",
      "unit_name": "GU-0472",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 88.56,
      "status": "Operational"
    },
    {
      "unit_id": 473,
      "generator_id": 238,
      "unit_code": "UNIT-0473",
      "unit_name": "GU-0473",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 26.46,
      "status": "Operational"
    },
    {
      "unit_id": 474,
      "generator_id": 239,
      "unit_code": "UNIT-0474",
      "unit_name": "GU-0474",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 27.02,
      "status": "Operational"
    },
    {
      "unit_id": 475,
      "generator_id": 240,
      "unit_code": "UNIT-0475",
      "unit_name": "GU-0475",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 104.57,
      "status": "Operational"
    },
    {
      "unit_id": 476,
      "generator_id": 241,
      "unit_code": "UNIT-0476",
      "unit_name": "GU-0476",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.86,
      "status": "Operational"
    },
    {
      "unit_id": 477,
      "generator_id": 242,
      "unit_code": "UNIT-0477",
      "unit_name": "GU-0477",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 27.82,
      "status": "Operational"
    },
    {
      "unit_id": 478,
      "generator_id": 243,
      "unit_code": "UNIT-0478",
      "unit_name": "GU-0478",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 24.35,
      "status": "Operational"
    },
    {
      "unit_id": 479,
      "generator_id": 244,
      "unit_code": "UNIT-0479",
      "unit_name": "GU-0479",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.06,
      "status": "Operational"
    },
    {
      "unit_id": 480,
      "generator_id": 245,
      "unit_code": "UNIT-0480",
      "unit_name": "GU-0480",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.15,
      "status": "Operational"
    },
    {
      "unit_id": 481,
      "generator_id": 246,
      "unit_code": "UNIT-0481",
      "unit_name": "GU-0481",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.6,
      "status": "Operational"
    },
    {
      "unit_id": 482,
      "generator_id": 247,
      "unit_code": "UNIT-0482",
      "unit_name": "GU-0482",
      "technology": "Hybrid",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 113.75,
      "status": "Operational"
    },
    {
      "unit_id": 483,
      "generator_id": 248,
      "unit_code": "UNIT-0483",
      "unit_name": "GU-0483",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 80.96,
      "status": "Operational"
    },
    {
      "unit_id": 484,
      "generator_id": 249,
      "unit_code": "UNIT-0484",
      "unit_name": "GU-0484",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 97.47,
      "status": "Operational"
    },
    {
      "unit_id": 485,
      "generator_id": 250,
      "unit_code": "UNIT-0485",
      "unit_name": "GU-0485",
      "technology": "Solar",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 62.33,
      "status": "Operational"
    },
    {
      "unit_id": 486,
      "generator_id": 251,
      "unit_code": "UNIT-0486",
      "unit_name": "GU-0486",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.87,
      "status": "Operational"
    },
    {
      "unit_id": 487,
      "generator_id": 252,
      "unit_code": "UNIT-0487",
      "unit_name": "GU-0487",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 88.18,
      "status": "Operational"
    },
    {
      "unit_id": 488,
      "generator_id": 253,
      "unit_code": "UNIT-0488",
      "unit_name": "GU-0488",
      "technology": "Solar",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 68.59,
      "status": "Operational"
    },
    {
      "unit_id": 489,
      "generator_id": 254,
      "unit_code": "UNIT-0489",
      "unit_name": "GU-0489",
      "technology": "Solar",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 109.58,
      "status": "Operational"
    },
    {
      "unit_id": 490,
      "generator_id": 255,
      "unit_code": "UNIT-0490",
      "unit_name": "GU-0490",
      "technology": "Solar",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 33.83,
      "status": "Operational"
    },
    {
      "unit_id": 491,
      "generator_id": 256,
      "unit_code": "UNIT-0491",
      "unit_name": "GU-0491",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.86,
      "status": "Operational"
    },
    {
      "unit_id": 492,
      "generator_id": 257,
      "unit_code": "UNIT-0492",
      "unit_name": "GU-0492",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 94.94,
      "status": "Operational"
    },
    {
      "unit_id": 493,
      "generator_id": 258,
      "unit_code": "UNIT-0493",
      "unit_name": "GU-0493",
      "technology": "Wind",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 62.84,
      "status": "Operational"
    },
    {
      "unit_id": 494,
      "generator_id": 259,
      "unit_code": "UNIT-0494",
      "unit_name": "GU-0494",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 94.1,
      "status": "Operational"
    },
    {
      "unit_id": 495,
      "generator_id": 260,
      "unit_code": "UNIT-0495",
      "unit_name": "GU-0495",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 101.88,
      "status": "Operational"
    },
    {
      "unit_id": 496,
      "generator_id": 261,
      "unit_code": "UNIT-0496",
      "unit_name": "GU-0496",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.13,
      "status": "Operational"
    },
    {
      "unit_id": 497,
      "generator_id": 262,
      "unit_code": "UNIT-0497",
      "unit_name": "GU-0497",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.22,
      "status": "Operational"
    },
    {
      "unit_id": 498,
      "generator_id": 263,
      "unit_code": "UNIT-0498",
      "unit_name": "GU-0498",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 27.55,
      "status": "Operational"
    },
    {
      "unit_id": 499,
      "generator_id": 264,
      "unit_code": "UNIT-0499",
      "unit_name": "GU-0499",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 29.62,
      "status": "Operational"
    },
    {
      "unit_id": 500,
      "generator_id": 265,
      "unit_code": "UNIT-0500",
      "unit_name": "GU-0500",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.53,
      "status": "Operational"
    },
    {
      "unit_id": 501,
      "generator_id": 266,
      "unit_code": "UNIT-0501",
      "unit_name": "GU-0501",
      "technology": "Solar",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 32.59,
      "status": "Operational"
    },
    {
      "unit_id": 502,
      "generator_id": 267,
      "unit_code": "UNIT-0502",
      "unit_name": "GU-0502",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 95.34,
      "status": "Operational"
    },
    {
      "unit_id": 503,
      "generator_id": 268,
      "unit_code": "UNIT-0503",
      "unit_name": "GU-0503",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 34.39,
      "status": "Operational"
    },
    {
      "unit_id": 504,
      "generator_id": 269,
      "unit_code": "UNIT-0504",
      "unit_name": "GU-0504",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 98.35,
      "status": "Operational"
    },
    {
      "unit_id": 505,
      "generator_id": 270,
      "unit_code": "UNIT-0505",
      "unit_name": "GU-0505",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 32.43,
      "status": "Operational"
    },
    {
      "unit_id": 506,
      "generator_id": 271,
      "unit_code": "UNIT-0506",
      "unit_name": "GU-0506",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 82.66,
      "status": "Operational"
    },
    {
      "unit_id": 507,
      "generator_id": 272,
      "unit_code": "UNIT-0507",
      "unit_name": "GU-0507",
      "technology": "Hybrid",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 65.79,
      "status": "Operational"
    },
    {
      "unit_id": 508,
      "generator_id": 273,
      "unit_code": "UNIT-0508",
      "unit_name": "GU-0508",
      "technology": "Solar",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 73.12,
      "status": "Operational"
    },
    {
      "unit_id": 509,
      "generator_id": 274,
      "unit_code": "UNIT-0509",
      "unit_name": "GU-0509",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 112.17,
      "status": "Operational"
    },
    {
      "unit_id": 510,
      "generator_id": 275,
      "unit_code": "UNIT-0510",
      "unit_name": "GU-0510",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.91,
      "status": "Operational"
    },
    {
      "unit_id": 511,
      "generator_id": 276,
      "unit_code": "UNIT-0511",
      "unit_name": "GU-0511",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.11,
      "status": "Operational"
    },
    {
      "unit_id": 512,
      "generator_id": 277,
      "unit_code": "UNIT-0512",
      "unit_name": "GU-0512",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 24.25,
      "status": "Operational"
    },
    {
      "unit_id": 513,
      "generator_id": 278,
      "unit_code": "UNIT-0513",
      "unit_name": "GU-0513",
      "technology": "Hybrid",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 73.28,
      "status": "Operational"
    },
    {
      "unit_id": 514,
      "generator_id": 279,
      "unit_code": "UNIT-0514",
      "unit_name": "GU-0514",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 101.64,
      "status": "Operational"
    },
    {
      "unit_id": 515,
      "generator_id": 280,
      "unit_code": "UNIT-0515",
      "unit_name": "GU-0515",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.79,
      "status": "Operational"
    },
    {
      "unit_id": 516,
      "generator_id": 281,
      "unit_code": "UNIT-0516",
      "unit_name": "GU-0516",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.27,
      "status": "Operational"
    },
    {
      "unit_id": 517,
      "generator_id": 282,
      "unit_code": "UNIT-0517",
      "unit_name": "GU-0517",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 110.33,
      "status": "Operational"
    },
    {
      "unit_id": 518,
      "generator_id": 283,
      "unit_code": "UNIT-0518",
      "unit_name": "GU-0518",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 41.25,
      "status": "Operational"
    },
    {
      "unit_id": 519,
      "generator_id": 284,
      "unit_code": "UNIT-0519",
      "unit_name": "GU-0519",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 39.66,
      "status": "Operational"
    },
    {
      "unit_id": 520,
      "generator_id": 285,
      "unit_code": "UNIT-0520",
      "unit_name": "GU-0520",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 46.95,
      "status": "Operational"
    },
    {
      "unit_id": 521,
      "generator_id": 286,
      "unit_code": "UNIT-0521",
      "unit_name": "GU-0521",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.22,
      "status": "Operational"
    },
    {
      "unit_id": 522,
      "generator_id": 287,
      "unit_code": "UNIT-0522",
      "unit_name": "GU-0522",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 88.05,
      "status": "Operational"
    },
    {
      "unit_id": 523,
      "generator_id": 288,
      "unit_code": "UNIT-0523",
      "unit_name": "GU-0523",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.25,
      "status": "Operational"
    },
    {
      "unit_id": 524,
      "generator_id": 289,
      "unit_code": "UNIT-0524",
      "unit_name": "GU-0524",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 34.47,
      "status": "Operational"
    },
    {
      "unit_id": 525,
      "generator_id": 290,
      "unit_code": "UNIT-0525",
      "unit_name": "GU-0525",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.6,
      "status": "Operational"
    },
    {
      "unit_id": 526,
      "generator_id": 291,
      "unit_code": "UNIT-0526",
      "unit_name": "GU-0526",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 38.85,
      "status": "Operational"
    },
    {
      "unit_id": 527,
      "generator_id": 292,
      "unit_code": "UNIT-0527",
      "unit_name": "GU-0527",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 37.67,
      "status": "Operational"
    },
    {
      "unit_id": 528,
      "generator_id": 293,
      "unit_code": "UNIT-0528",
      "unit_name": "GU-0528",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.63,
      "status": "Operational"
    },
    {
      "unit_id": 529,
      "generator_id": 294,
      "unit_code": "UNIT-0529",
      "unit_name": "GU-0529",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 27.39,
      "status": "Operational"
    },
    {
      "unit_id": 530,
      "generator_id": 295,
      "unit_code": "UNIT-0530",
      "unit_name": "GU-0530",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 39.87,
      "status": "Operational"
    },
    {
      "unit_id": 531,
      "generator_id": 296,
      "unit_code": "UNIT-0531",
      "unit_name": "GU-0531",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.57,
      "status": "Operational"
    },
    {
      "unit_id": 532,
      "generator_id": 297,
      "unit_code": "UNIT-0532",
      "unit_name": "GU-0532",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 44.68,
      "status": "Operational"
    },
    {
      "unit_id": 533,
      "generator_id": 298,
      "unit_code": "UNIT-0533",
      "unit_name": "GU-0533",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 93.64,
      "status": "Operational"
    },
    {
      "unit_id": 534,
      "generator_id": 299,
      "unit_code": "UNIT-0534",
      "unit_name": "GU-0534",
      "technology": "Hybrid",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 107.19,
      "status": "Operational"
    },
    {
      "unit_id": 535,
      "generator_id": 300,
      "unit_code": "UNIT-0535",
      "unit_name": "GU-0535",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 37.33,
      "status": "Operational"
    },
    {
      "unit_id": 536,
      "generator_id": 301,
      "unit_code": "UNIT-0536",
      "unit_name": "GU-0536",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.96,
      "status": "Operational"
    },
    {
      "unit_id": 537,
      "generator_id": 302,
      "unit_code": "UNIT-0537",
      "unit_name": "GU-0537",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.21,
      "status": "Operational"
    },
    {
      "unit_id": 538,
      "generator_id": 303,
      "unit_code": "UNIT-0538",
      "unit_name": "GU-0538",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 43.33,
      "status": "Operational"
    },
    {
      "unit_id": 539,
      "generator_id": 304,
      "unit_code": "UNIT-0539",
      "unit_name": "GU-0539",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.11,
      "status": "Operational"
    },
    {
      "unit_id": 540,
      "generator_id": 305,
      "unit_code": "UNIT-0540",
      "unit_name": "GU-0540",
      "technology": "Wind",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 65.49,
      "status": "Operational"
    },
    {
      "unit_id": 541,
      "generator_id": 306,
      "unit_code": "UNIT-0541",
      "unit_name": "GU-0541",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 119.87,
      "status": "Operational"
    },
    {
      "unit_id": 542,
      "generator_id": 307,
      "unit_code": "UNIT-0542",
      "unit_name": "GU-0542",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 28.03,
      "status": "Operational"
    },
    {
      "unit_id": 543,
      "generator_id": 308,
      "unit_code": "UNIT-0543",
      "unit_name": "GU-0543",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.48,
      "status": "Operational"
    },
    {
      "unit_id": 544,
      "generator_id": 309,
      "unit_code": "UNIT-0544",
      "unit_name": "GU-0544",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.98,
      "status": "Operational"
    },
    {
      "unit_id": 545,
      "generator_id": 310,
      "unit_code": "UNIT-0545",
      "unit_name": "GU-0545",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 87.12,
      "status": "Operational"
    },
    {
      "unit_id": 546,
      "generator_id": 311,
      "unit_code": "UNIT-0546",
      "unit_name": "GU-0546",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 96.89,
      "status": "Operational"
    },
    {
      "unit_id": 547,
      "generator_id": 312,
      "unit_code": "UNIT-0547",
      "unit_name": "GU-0547",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 90.47,
      "status": "Operational"
    },
    {
      "unit_id": 548,
      "generator_id": 313,
      "unit_code": "UNIT-0548",
      "unit_name": "GU-0548",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 38.47,
      "status": "Operational"
    },
    {
      "unit_id": 549,
      "generator_id": 314,
      "unit_code": "UNIT-0549",
      "unit_name": "GU-0549",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 98.56,
      "status": "Operational"
    },
    {
      "unit_id": 550,
      "generator_id": 315,
      "unit_code": "UNIT-0550",
      "unit_name": "GU-0550",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.53,
      "status": "Operational"
    },
    {
      "unit_id": 551,
      "generator_id": 316,
      "unit_code": "UNIT-0551",
      "unit_name": "GU-0551",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 92.77,
      "status": "Operational"
    },
    {
      "unit_id": 552,
      "generator_id": 317,
      "unit_code": "UNIT-0552",
      "unit_name": "GU-0552",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 96.11,
      "status": "Operational"
    },
    {
      "unit_id": 553,
      "generator_id": 318,
      "unit_code": "UNIT-0553",
      "unit_name": "GU-0553",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 92.48,
      "status": "Operational"
    },
    {
      "unit_id": 554,
      "generator_id": 319,
      "unit_code": "UNIT-0554",
      "unit_name": "GU-0554",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 42.27,
      "status": "Operational"
    },
    {
      "unit_id": 555,
      "generator_id": 320,
      "unit_code": "UNIT-0555",
      "unit_name": "GU-0555",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.17,
      "status": "Operational"
    },
    {
      "unit_id": 556,
      "generator_id": 321,
      "unit_code": "UNIT-0556",
      "unit_name": "GU-0556",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 19.95,
      "status": "Operational"
    },
    {
      "unit_id": 557,
      "generator_id": 322,
      "unit_code": "UNIT-0557",
      "unit_name": "GU-0557",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 24.01,
      "status": "Operational"
    },
    {
      "unit_id": 558,
      "generator_id": 323,
      "unit_code": "UNIT-0558",
      "unit_name": "GU-0558",
      "technology": "Solar",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 110.93,
      "status": "Operational"
    },
    {
      "unit_id": 559,
      "generator_id": 324,
      "unit_code": "UNIT-0559",
      "unit_name": "GU-0559",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 85.58,
      "status": "Operational"
    },
    {
      "unit_id": 560,
      "generator_id": 325,
      "unit_code": "UNIT-0560",
      "unit_name": "GU-0560",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 38.58,
      "status": "Operational"
    },
    {
      "unit_id": 561,
      "generator_id": 326,
      "unit_code": "UNIT-0561",
      "unit_name": "GU-0561",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.85,
      "status": "Operational"
    },
    {
      "unit_id": 562,
      "generator_id": 327,
      "unit_code": "UNIT-0562",
      "unit_name": "GU-0562",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 97.47,
      "status": "Operational"
    },
    {
      "unit_id": 563,
      "generator_id": 328,
      "unit_code": "UNIT-0563",
      "unit_name": "GU-0563",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 44.17,
      "status": "Operational"
    },
    {
      "unit_id": 564,
      "generator_id": 329,
      "unit_code": "UNIT-0564",
      "unit_name": "GU-0564",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 110.18,
      "status": "Operational"
    },
    {
      "unit_id": 565,
      "generator_id": 330,
      "unit_code": "UNIT-0565",
      "unit_name": "GU-0565",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 39.03,
      "status": "Operational"
    },
    {
      "unit_id": 566,
      "generator_id": 331,
      "unit_code": "UNIT-0566",
      "unit_name": "GU-0566",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 24.55,
      "status": "Operational"
    },
    {
      "unit_id": 567,
      "generator_id": 332,
      "unit_code": "UNIT-0567",
      "unit_name": "GU-0567",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.68,
      "status": "Operational"
    },
    {
      "unit_id": 568,
      "generator_id": 333,
      "unit_code": "UNIT-0568",
      "unit_name": "GU-0568",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.68,
      "status": "Operational"
    },
    {
      "unit_id": 569,
      "generator_id": 334,
      "unit_code": "UNIT-0569",
      "unit_name": "GU-0569",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.76,
      "status": "Operational"
    },
    {
      "unit_id": 570,
      "generator_id": 335,
      "unit_code": "UNIT-0570",
      "unit_name": "GU-0570",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 98.54,
      "status": "Operational"
    },
    {
      "unit_id": 571,
      "generator_id": 336,
      "unit_code": "UNIT-0571",
      "unit_name": "GU-0571",
      "technology": "Hybrid",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 73.08,
      "status": "Operational"
    },
    {
      "unit_id": 572,
      "generator_id": 337,
      "unit_code": "UNIT-0572",
      "unit_name": "GU-0572",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 26.75,
      "status": "Operational"
    },
    {
      "unit_id": 573,
      "generator_id": 338,
      "unit_code": "UNIT-0573",
      "unit_name": "GU-0573",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 115.24,
      "status": "Operational"
    },
    {
      "unit_id": 574,
      "generator_id": 339,
      "unit_code": "UNIT-0574",
      "unit_name": "GU-0574",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.27,
      "status": "Operational"
    },
    {
      "unit_id": 575,
      "generator_id": 340,
      "unit_code": "UNIT-0575",
      "unit_name": "GU-0575",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 46.22,
      "status": "Operational"
    },
    {
      "unit_id": 576,
      "generator_id": 341,
      "unit_code": "UNIT-0576",
      "unit_name": "GU-0576",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.63,
      "status": "Operational"
    },
    {
      "unit_id": 577,
      "generator_id": 342,
      "unit_code": "UNIT-0577",
      "unit_name": "GU-0577",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.25,
      "status": "Operational"
    },
    {
      "unit_id": 578,
      "generator_id": 343,
      "unit_code": "UNIT-0578",
      "unit_name": "GU-0578",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 47.96,
      "status": "Operational"
    },
    {
      "unit_id": 579,
      "generator_id": 344,
      "unit_code": "UNIT-0579",
      "unit_name": "GU-0579",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.37,
      "status": "Operational"
    },
    {
      "unit_id": 580,
      "generator_id": 345,
      "unit_code": "UNIT-0580",
      "unit_name": "GU-0580",
      "technology": "Solar",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 49.32,
      "status": "Operational"
    },
    {
      "unit_id": 581,
      "generator_id": 346,
      "unit_code": "UNIT-0581",
      "unit_name": "GU-0581",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 45.93,
      "status": "Operational"
    },
    {
      "unit_id": 582,
      "generator_id": 347,
      "unit_code": "UNIT-0582",
      "unit_name": "GU-0582",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 83.24,
      "status": "Operational"
    },
    {
      "unit_id": 583,
      "generator_id": 348,
      "unit_code": "UNIT-0583",
      "unit_name": "GU-0583",
      "technology": "Solar",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 70.34,
      "status": "Operational"
    },
    {
      "unit_id": 584,
      "generator_id": 349,
      "unit_code": "UNIT-0584",
      "unit_name": "GU-0584",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.12,
      "status": "Operational"
    },
    {
      "unit_id": 585,
      "generator_id": 350,
      "unit_code": "UNIT-0585",
      "unit_name": "GU-0585",
      "technology": "Solar",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 102.22,
      "status": "Operational"
    },
    {
      "unit_id": 586,
      "generator_id": 351,
      "unit_code": "UNIT-0586",
      "unit_name": "GU-0586",
      "technology": "Wind",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 62.98,
      "status": "Operational"
    },
    {
      "unit_id": 587,
      "generator_id": 352,
      "unit_code": "UNIT-0587",
      "unit_name": "GU-0587",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 86.69,
      "status": "Operational"
    },
    {
      "unit_id": 588,
      "generator_id": 353,
      "unit_code": "UNIT-0588",
      "unit_name": "GU-0588",
      "technology": "Solar",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 38.58,
      "status": "Operational"
    },
    {
      "unit_id": 589,
      "generator_id": 354,
      "unit_code": "UNIT-0589",
      "unit_name": "GU-0589",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 35.27,
      "status": "Operational"
    },
    {
      "unit_id": 590,
      "generator_id": 355,
      "unit_code": "UNIT-0590",
      "unit_name": "GU-0590",
      "technology": "Hybrid",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 73.26,
      "status": "Operational"
    },
    {
      "unit_id": 591,
      "generator_id": 356,
      "unit_code": "UNIT-0591",
      "unit_name": "GU-0591",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 27.58,
      "status": "Operational"
    },
    {
      "unit_id": 592,
      "generator_id": 357,
      "unit_code": "UNIT-0592",
      "unit_name": "GU-0592",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.64,
      "status": "Operational"
    },
    {
      "unit_id": 593,
      "generator_id": 358,
      "unit_code": "UNIT-0593",
      "unit_name": "GU-0593",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 35.23,
      "status": "Operational"
    },
    {
      "unit_id": 594,
      "generator_id": 359,
      "unit_code": "UNIT-0594",
      "unit_name": "GU-0594",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.98,
      "status": "Operational"
    },
    {
      "unit_id": 595,
      "generator_id": 360,
      "unit_code": "UNIT-0595",
      "unit_name": "GU-0595",
      "technology": "Hybrid",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 118.75,
      "status": "Operational"
    },
    {
      "unit_id": 596,
      "generator_id": 361,
      "unit_code": "UNIT-0596",
      "unit_name": "GU-0596",
      "technology": "Wind",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 61.59,
      "status": "Operational"
    },
    {
      "unit_id": 597,
      "generator_id": 362,
      "unit_code": "UNIT-0597",
      "unit_name": "GU-0597",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 91.77,
      "status": "Operational"
    },
    {
      "unit_id": 598,
      "generator_id": 363,
      "unit_code": "UNIT-0598",
      "unit_name": "GU-0598",
      "technology": "Hybrid",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 71.96,
      "status": "Operational"
    },
    {
      "unit_id": 599,
      "generator_id": 364,
      "unit_code": "UNIT-0599",
      "unit_name": "GU-0599",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 84.49,
      "status": "Operational"
    },
    {
      "unit_id": 600,
      "generator_id": 365,
      "unit_code": "UNIT-0600",
      "unit_name": "GU-0600",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.82,
      "status": "Operational"
    },
    {
      "unit_id": 601,
      "generator_id": 366,
      "unit_code": "UNIT-0601",
      "unit_name": "GU-0601",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.53,
      "status": "Operational"
    },
    {
      "unit_id": 602,
      "generator_id": 367,
      "unit_code": "UNIT-0602",
      "unit_name": "GU-0602",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 28.51,
      "status": "Operational"
    },
    {
      "unit_id": 603,
      "generator_id": 368,
      "unit_code": "UNIT-0603",
      "unit_name": "GU-0603",
      "technology": "Solar",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 34.53,
      "status": "Operational"
    },
    {
      "unit_id": 604,
      "generator_id": 369,
      "unit_code": "UNIT-0604",
      "unit_name": "GU-0604",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.37,
      "status": "Operational"
    },
    {
      "unit_id": 605,
      "generator_id": 370,
      "unit_code": "UNIT-0605",
      "unit_name": "GU-0605",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 108.74,
      "status": "Operational"
    },
    {
      "unit_id": 606,
      "generator_id": 371,
      "unit_code": "UNIT-0606",
      "unit_name": "GU-0606",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 35.26,
      "status": "Operational"
    },
    {
      "unit_id": 607,
      "generator_id": 372,
      "unit_code": "UNIT-0607",
      "unit_name": "GU-0607",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 39.95,
      "status": "Operational"
    },
    {
      "unit_id": 608,
      "generator_id": 373,
      "unit_code": "UNIT-0608",
      "unit_name": "GU-0608",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 98.84,
      "status": "Operational"
    },
    {
      "unit_id": 609,
      "generator_id": 374,
      "unit_code": "UNIT-0609",
      "unit_name": "GU-0609",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.93,
      "status": "Operational"
    },
    {
      "unit_id": 610,
      "generator_id": 375,
      "unit_code": "UNIT-0610",
      "unit_name": "GU-0610",
      "technology": "Solar",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 36.96,
      "status": "Operational"
    },
    {
      "unit_id": 611,
      "generator_id": 376,
      "unit_code": "UNIT-0611",
      "unit_name": "GU-0611",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.31,
      "status": "Operational"
    },
    {
      "unit_id": 612,
      "generator_id": 377,
      "unit_code": "UNIT-0612",
      "unit_name": "GU-0612",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 88.89,
      "status": "Operational"
    },
    {
      "unit_id": 613,
      "generator_id": 378,
      "unit_code": "UNIT-0613",
      "unit_name": "GU-0613",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 89.19,
      "status": "Operational"
    },
    {
      "unit_id": 614,
      "generator_id": 379,
      "unit_code": "UNIT-0614",
      "unit_name": "GU-0614",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 84.7,
      "status": "Operational"
    },
    {
      "unit_id": 615,
      "generator_id": 380,
      "unit_code": "UNIT-0615",
      "unit_name": "GU-0615",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 91.3,
      "status": "Operational"
    },
    {
      "unit_id": 616,
      "generator_id": 381,
      "unit_code": "UNIT-0616",
      "unit_name": "GU-0616",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 100.52,
      "status": "Operational"
    },
    {
      "unit_id": 617,
      "generator_id": 382,
      "unit_code": "UNIT-0617",
      "unit_name": "GU-0617",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 89.21,
      "status": "Operational"
    },
    {
      "unit_id": 618,
      "generator_id": 383,
      "unit_code": "UNIT-0618",
      "unit_name": "GU-0618",
      "technology": "Solar",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 38.58,
      "status": "Operational"
    },
    {
      "unit_id": 619,
      "generator_id": 384,
      "unit_code": "UNIT-0619",
      "unit_name": "GU-0619",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 96.04,
      "status": "Operational"
    },
    {
      "unit_id": 620,
      "generator_id": 385,
      "unit_code": "UNIT-0620",
      "unit_name": "GU-0620",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 33.9,
      "status": "Operational"
    },
    {
      "unit_id": 621,
      "generator_id": 386,
      "unit_code": "UNIT-0621",
      "unit_name": "GU-0621",
      "technology": "Solar",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 36.99,
      "status": "Operational"
    },
    {
      "unit_id": 622,
      "generator_id": 387,
      "unit_code": "UNIT-0622",
      "unit_name": "GU-0622",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 98.94,
      "status": "Operational"
    },
    {
      "unit_id": 623,
      "generator_id": 388,
      "unit_code": "UNIT-0623",
      "unit_name": "GU-0623",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.93,
      "status": "Operational"
    },
    {
      "unit_id": 624,
      "generator_id": 389,
      "unit_code": "UNIT-0624",
      "unit_name": "GU-0624",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 29.88,
      "status": "Operational"
    },
    {
      "unit_id": 625,
      "generator_id": 390,
      "unit_code": "UNIT-0625",
      "unit_name": "GU-0625",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 117.38,
      "status": "Operational"
    },
    {
      "unit_id": 626,
      "generator_id": 391,
      "unit_code": "UNIT-0626",
      "unit_name": "GU-0626",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 17.3,
      "status": "Operational"
    },
    {
      "unit_id": 627,
      "generator_id": 392,
      "unit_code": "UNIT-0627",
      "unit_name": "GU-0627",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 47.44,
      "status": "Operational"
    },
    {
      "unit_id": 628,
      "generator_id": 393,
      "unit_code": "UNIT-0628",
      "unit_name": "GU-0628",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.27,
      "status": "Operational"
    },
    {
      "unit_id": 629,
      "generator_id": 394,
      "unit_code": "UNIT-0629",
      "unit_name": "GU-0629",
      "technology": "Solar",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 63.53,
      "status": "Operational"
    },
    {
      "unit_id": 630,
      "generator_id": 395,
      "unit_code": "UNIT-0630",
      "unit_name": "GU-0630",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 97.35,
      "status": "Operational"
    },
    {
      "unit_id": 631,
      "generator_id": 396,
      "unit_code": "UNIT-0631",
      "unit_name": "GU-0631",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.68,
      "status": "Operational"
    },
    {
      "unit_id": 632,
      "generator_id": 397,
      "unit_code": "UNIT-0632",
      "unit_name": "GU-0632",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 37.82,
      "status": "Operational"
    },
    {
      "unit_id": 633,
      "generator_id": 398,
      "unit_code": "UNIT-0633",
      "unit_name": "GU-0633",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.71,
      "status": "Operational"
    },
    {
      "unit_id": 634,
      "generator_id": 399,
      "unit_code": "UNIT-0634",
      "unit_name": "GU-0634",
      "technology": "Wind",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 62.23,
      "status": "Operational"
    },
    {
      "unit_id": 635,
      "generator_id": 400,
      "unit_code": "UNIT-0635",
      "unit_name": "GU-0635",
      "technology": "Hybrid",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 60.21,
      "status": "Operational"
    },
    {
      "unit_id": 636,
      "generator_id": 401,
      "unit_code": "UNIT-0636",
      "unit_name": "GU-0636",
      "technology": "Solar",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 32.28,
      "status": "Operational"
    },
    {
      "unit_id": 637,
      "generator_id": 402,
      "unit_code": "UNIT-0637",
      "unit_name": "GU-0637",
      "technology": "Solar",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 64.84,
      "status": "Operational"
    },
    {
      "unit_id": 638,
      "generator_id": 403,
      "unit_code": "UNIT-0638",
      "unit_name": "GU-0638",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 90.33,
      "status": "Operational"
    },
    {
      "unit_id": 639,
      "generator_id": 404,
      "unit_code": "UNIT-0639",
      "unit_name": "GU-0639",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 40.54,
      "status": "Operational"
    },
    {
      "unit_id": 640,
      "generator_id": 405,
      "unit_code": "UNIT-0640",
      "unit_name": "GU-0640",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 27.45,
      "status": "Operational"
    },
    {
      "unit_id": 641,
      "generator_id": 406,
      "unit_code": "UNIT-0641",
      "unit_name": "GU-0641",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.3,
      "status": "Operational"
    },
    {
      "unit_id": 642,
      "generator_id": 407,
      "unit_code": "UNIT-0642",
      "unit_name": "GU-0642",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 39.86,
      "status": "Operational"
    },
    {
      "unit_id": 643,
      "generator_id": 408,
      "unit_code": "UNIT-0643",
      "unit_name": "GU-0643",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 32.14,
      "status": "Operational"
    },
    {
      "unit_id": 644,
      "generator_id": 409,
      "unit_code": "UNIT-0644",
      "unit_name": "GU-0644",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 26.13,
      "status": "Operational"
    },
    {
      "unit_id": 645,
      "generator_id": 410,
      "unit_code": "UNIT-0645",
      "unit_name": "GU-0645",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 24.57,
      "status": "Operational"
    },
    {
      "unit_id": 646,
      "generator_id": 411,
      "unit_code": "UNIT-0646",
      "unit_name": "GU-0646",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 26.85,
      "status": "Operational"
    },
    {
      "unit_id": 647,
      "generator_id": 412,
      "unit_code": "UNIT-0647",
      "unit_name": "GU-0647",
      "technology": "Hybrid",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 109.3,
      "status": "Operational"
    },
    {
      "unit_id": 648,
      "generator_id": 413,
      "unit_code": "UNIT-0648",
      "unit_name": "GU-0648",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 113.75,
      "status": "Operational"
    },
    {
      "unit_id": 649,
      "generator_id": 414,
      "unit_code": "UNIT-0649",
      "unit_name": "GU-0649",
      "technology": "Hybrid",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 98.01,
      "status": "Operational"
    },
    {
      "unit_id": 650,
      "generator_id": 415,
      "unit_code": "UNIT-0650",
      "unit_name": "GU-0650",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 97.49,
      "status": "Operational"
    },
    {
      "unit_id": 651,
      "generator_id": 416,
      "unit_code": "UNIT-0651",
      "unit_name": "GU-0651",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 35.62,
      "status": "Operational"
    },
    {
      "unit_id": 652,
      "generator_id": 417,
      "unit_code": "UNIT-0652",
      "unit_name": "GU-0652",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.21,
      "status": "Operational"
    },
    {
      "unit_id": 653,
      "generator_id": 418,
      "unit_code": "UNIT-0653",
      "unit_name": "GU-0653",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 92.57,
      "status": "Operational"
    },
    {
      "unit_id": 654,
      "generator_id": 419,
      "unit_code": "UNIT-0654",
      "unit_name": "GU-0654",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.18,
      "status": "Operational"
    },
    {
      "unit_id": 655,
      "generator_id": 420,
      "unit_code": "UNIT-0655",
      "unit_name": "GU-0655",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 86.04,
      "status": "Operational"
    },
    {
      "unit_id": 656,
      "generator_id": 421,
      "unit_code": "UNIT-0656",
      "unit_name": "GU-0656",
      "technology": "Solar",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 99.64,
      "status": "Operational"
    },
    {
      "unit_id": 657,
      "generator_id": 422,
      "unit_code": "UNIT-0657",
      "unit_name": "GU-0657",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.73,
      "status": "Operational"
    },
    {
      "unit_id": 658,
      "generator_id": 423,
      "unit_code": "UNIT-0658",
      "unit_name": "GU-0658",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.1,
      "status": "Operational"
    },
    {
      "unit_id": 659,
      "generator_id": 424,
      "unit_code": "UNIT-0659",
      "unit_name": "GU-0659",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 27.96,
      "status": "Operational"
    },
    {
      "unit_id": 660,
      "generator_id": 425,
      "unit_code": "UNIT-0660",
      "unit_name": "GU-0660",
      "technology": "Solar",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 35.5,
      "status": "Operational"
    },
    {
      "unit_id": 661,
      "generator_id": 426,
      "unit_code": "UNIT-0661",
      "unit_name": "GU-0661",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 28.81,
      "status": "Operational"
    },
    {
      "unit_id": 662,
      "generator_id": 427,
      "unit_code": "UNIT-0662",
      "unit_name": "GU-0662",
      "technology": "Hybrid",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 48.75,
      "status": "Operational"
    },
    {
      "unit_id": 663,
      "generator_id": 428,
      "unit_code": "UNIT-0663",
      "unit_name": "GU-0663",
      "technology": "Wind",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 71.91,
      "status": "Operational"
    },
    {
      "unit_id": 664,
      "generator_id": 429,
      "unit_code": "UNIT-0664",
      "unit_name": "GU-0664",
      "technology": "Wind",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 81.37,
      "status": "Operational"
    },
    {
      "unit_id": 665,
      "generator_id": 430,
      "unit_code": "UNIT-0665",
      "unit_name": "GU-0665",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.96,
      "status": "Operational"
    },
    {
      "unit_id": 666,
      "generator_id": 431,
      "unit_code": "UNIT-0666",
      "unit_name": "GU-0666",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.82,
      "status": "Operational"
    },
    {
      "unit_id": 667,
      "generator_id": 432,
      "unit_code": "UNIT-0667",
      "unit_name": "GU-0667",
      "technology": "Wind",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 65.74,
      "status": "Operational"
    },
    {
      "unit_id": 668,
      "generator_id": 433,
      "unit_code": "UNIT-0668",
      "unit_name": "GU-0668",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.45,
      "status": "Operational"
    },
    {
      "unit_id": 669,
      "generator_id": 434,
      "unit_code": "UNIT-0669",
      "unit_name": "GU-0669",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.53,
      "status": "Operational"
    },
    {
      "unit_id": 670,
      "generator_id": 435,
      "unit_code": "UNIT-0670",
      "unit_name": "GU-0670",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 28.2,
      "status": "Operational"
    },
    {
      "unit_id": 671,
      "generator_id": 436,
      "unit_code": "UNIT-0671",
      "unit_name": "GU-0671",
      "technology": "Hybrid",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 106.65,
      "status": "Operational"
    },
    {
      "unit_id": 672,
      "generator_id": 437,
      "unit_code": "UNIT-0672",
      "unit_name": "GU-0672",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 34.79,
      "status": "Operational"
    },
    {
      "unit_id": 673,
      "generator_id": 438,
      "unit_code": "UNIT-0673",
      "unit_name": "GU-0673",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 35.1,
      "status": "Operational"
    },
    {
      "unit_id": 674,
      "generator_id": 439,
      "unit_code": "UNIT-0674",
      "unit_name": "GU-0674",
      "technology": "Wind",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 99.51,
      "status": "Operational"
    },
    {
      "unit_id": 675,
      "generator_id": 440,
      "unit_code": "UNIT-0675",
      "unit_name": "GU-0675",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.81,
      "status": "Operational"
    },
    {
      "unit_id": 676,
      "generator_id": 441,
      "unit_code": "UNIT-0676",
      "unit_name": "GU-0676",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 29.94,
      "status": "Operational"
    },
    {
      "unit_id": 677,
      "generator_id": 442,
      "unit_code": "UNIT-0677",
      "unit_name": "GU-0677",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.28,
      "status": "Operational"
    },
    {
      "unit_id": 678,
      "generator_id": 443,
      "unit_code": "UNIT-0678",
      "unit_name": "GU-0678",
      "technology": "Solar",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 16.46,
      "status": "Operational"
    },
    {
      "unit_id": 679,
      "generator_id": 444,
      "unit_code": "UNIT-0679",
      "unit_name": "GU-0679",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 26.71,
      "status": "Operational"
    },
    {
      "unit_id": 680,
      "generator_id": 445,
      "unit_code": "UNIT-0680",
      "unit_name": "GU-0680",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 24.93,
      "status": "Operational"
    },
    {
      "unit_id": 681,
      "generator_id": 446,
      "unit_code": "UNIT-0681",
      "unit_name": "GU-0681",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.06,
      "status": "Operational"
    },
    {
      "unit_id": 682,
      "generator_id": 447,
      "unit_code": "UNIT-0682",
      "unit_name": "GU-0682",
      "technology": "Wind",
      "rated_capacity_mw": 50.0,
      "available_capacity_mw": 43.32,
      "status": "Operational"
    },
    {
      "unit_id": 683,
      "generator_id": 448,
      "unit_code": "UNIT-0683",
      "unit_name": "GU-0683",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 34.58,
      "status": "Operational"
    },
    {
      "unit_id": 684,
      "generator_id": 449,
      "unit_code": "UNIT-0684",
      "unit_name": "GU-0684",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.24,
      "status": "Operational"
    },
    {
      "unit_id": 685,
      "generator_id": 450,
      "unit_code": "UNIT-0685",
      "unit_name": "GU-0685",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 24.38,
      "status": "Operational"
    },
    {
      "unit_id": 686,
      "generator_id": 451,
      "unit_code": "UNIT-0686",
      "unit_name": "GU-0686",
      "technology": "Solar",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 101.17,
      "status": "Operational"
    },
    {
      "unit_id": 687,
      "generator_id": 452,
      "unit_code": "UNIT-0687",
      "unit_name": "GU-0687",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.85,
      "status": "Operational"
    },
    {
      "unit_id": 688,
      "generator_id": 453,
      "unit_code": "UNIT-0688",
      "unit_name": "GU-0688",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.55,
      "status": "Operational"
    },
    {
      "unit_id": 689,
      "generator_id": 454,
      "unit_code": "UNIT-0689",
      "unit_name": "GU-0689",
      "technology": "Solar",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 114.49,
      "status": "Operational"
    },
    {
      "unit_id": 690,
      "generator_id": 455,
      "unit_code": "UNIT-0690",
      "unit_name": "GU-0690",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.75,
      "status": "Operational"
    },
    {
      "unit_id": 691,
      "generator_id": 456,
      "unit_code": "UNIT-0691",
      "unit_name": "GU-0691",
      "technology": "Wind",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.62,
      "status": "Operational"
    },
    {
      "unit_id": 692,
      "generator_id": 457,
      "unit_code": "UNIT-0692",
      "unit_name": "GU-0692",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.95,
      "status": "Operational"
    },
    {
      "unit_id": 693,
      "generator_id": 458,
      "unit_code": "UNIT-0693",
      "unit_name": "GU-0693",
      "technology": "Hybrid",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 62.88,
      "status": "Operational"
    },
    {
      "unit_id": 694,
      "generator_id": 459,
      "unit_code": "UNIT-0694",
      "unit_name": "GU-0694",
      "technology": "Hybrid",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 115.78,
      "status": "Operational"
    },
    {
      "unit_id": 695,
      "generator_id": 460,
      "unit_code": "UNIT-0695",
      "unit_name": "GU-0695",
      "technology": "Solar",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 39.49,
      "status": "Operational"
    },
    {
      "unit_id": 696,
      "generator_id": 461,
      "unit_code": "UNIT-0696",
      "unit_name": "GU-0696",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.9,
      "status": "Operational"
    },
    {
      "unit_id": 697,
      "generator_id": 462,
      "unit_code": "UNIT-0697",
      "unit_name": "GU-0697",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 24.63,
      "status": "Operational"
    },
    {
      "unit_id": 698,
      "generator_id": 463,
      "unit_code": "UNIT-0698",
      "unit_name": "GU-0698",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.35,
      "status": "Operational"
    },
    {
      "unit_id": 699,
      "generator_id": 464,
      "unit_code": "UNIT-0699",
      "unit_name": "GU-0699",
      "technology": "Hybrid",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 115.5,
      "status": "Operational"
    },
    {
      "unit_id": 700,
      "generator_id": 465,
      "unit_code": "UNIT-0700",
      "unit_name": "GU-0700",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 25.61,
      "status": "Operational"
    },
    {
      "unit_id": 701,
      "generator_id": 466,
      "unit_code": "UNIT-0701",
      "unit_name": "GU-0701",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 26.08,
      "status": "Operational"
    },
    {
      "unit_id": 702,
      "generator_id": 467,
      "unit_code": "UNIT-0702",
      "unit_name": "GU-0702",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 33.7,
      "status": "Operational"
    },
    {
      "unit_id": 703,
      "generator_id": 468,
      "unit_code": "UNIT-0703",
      "unit_name": "GU-0703",
      "technology": "Hybrid",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 70.84,
      "status": "Operational"
    },
    {
      "unit_id": 704,
      "generator_id": 469,
      "unit_code": "UNIT-0704",
      "unit_name": "GU-0704",
      "technology": "Hybrid",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 27.79,
      "status": "Operational"
    },
    {
      "unit_id": 705,
      "generator_id": 470,
      "unit_code": "UNIT-0705",
      "unit_name": "GU-0705",
      "technology": "Solar",
      "rated_capacity_mw": 30.0,
      "available_capacity_mw": 24.61,
      "status": "Operational"
    },
    {
      "unit_id": 706,
      "generator_id": 471,
      "unit_code": "UNIT-0706",
      "unit_name": "GU-0706",
      "technology": "Wind",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 22.22,
      "status": "Operational"
    },
    {
      "unit_id": 707,
      "generator_id": 472,
      "unit_code": "UNIT-0707",
      "unit_name": "GU-0707",
      "technology": "Hybrid",
      "rated_capacity_mw": 100.0,
      "available_capacity_mw": 83.75,
      "status": "Operational"
    },
    {
      "unit_id": 708,
      "generator_id": 473,
      "unit_code": "UNIT-0708",
      "unit_name": "GU-0708",
      "technology": "Hybrid",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 72.79,
      "status": "Operational"
    },
    {
      "unit_id": 709,
      "generator_id": 474,
      "unit_code": "UNIT-0709",
      "unit_name": "GU-0709",
      "technology": "Wind",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 35.6,
      "status": "Operational"
    },
    {
      "unit_id": 710,
      "generator_id": 475,
      "unit_code": "UNIT-0710",
      "unit_name": "GU-0710",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 23.2,
      "status": "Operational"
    },
    {
      "unit_id": 711,
      "generator_id": 476,
      "unit_code": "UNIT-0711",
      "unit_name": "GU-0711",
      "technology": "Solar",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 111.51,
      "status": "Operational"
    },
    {
      "unit_id": 712,
      "generator_id": 477,
      "unit_code": "UNIT-0712",
      "unit_name": "GU-0712",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 35.72,
      "status": "Operational"
    },
    {
      "unit_id": 713,
      "generator_id": 478,
      "unit_code": "UNIT-0713",
      "unit_name": "GU-0713",
      "technology": "Wind",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 71.61,
      "status": "Operational"
    },
    {
      "unit_id": 714,
      "generator_id": 479,
      "unit_code": "UNIT-0714",
      "unit_name": "GU-0714",
      "technology": "Solar",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 20.93,
      "status": "Operational"
    },
    {
      "unit_id": 715,
      "generator_id": 480,
      "unit_code": "UNIT-0715",
      "unit_name": "GU-0715",
      "technology": "Hybrid",
      "rated_capacity_mw": 40.0,
      "available_capacity_mw": 36.12,
      "status": "Operational"
    },
    {
      "unit_id": 716,
      "generator_id": 481,
      "unit_code": "UNIT-0716",
      "unit_name": "GU-0716",
      "technology": "Wind",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.49,
      "status": "Operational"
    },
    {
      "unit_id": 717,
      "generator_id": 482,
      "unit_code": "UNIT-0717",
      "unit_name": "GU-0717",
      "technology": "Hybrid",
      "rated_capacity_mw": 20.0,
      "available_capacity_mw": 18.08,
      "status": "Operational"
    },
    {
      "unit_id": 718,
      "generator_id": 483,
      "unit_code": "UNIT-0718",
      "unit_name": "GU-0718",
      "technology": "Hybrid",
      "rated_capacity_mw": 25.0,
      "available_capacity_mw": 21.96,
      "status": "Operational"
    },
    {
      "unit_id": 719,
      "generator_id": 484,
      "unit_code": "UNIT-0719",
      "unit_name": "GU-0719",
      "technology": "Solar",
      "rated_capacity_mw": 120.0,
      "available_capacity_mw": 112.77,
      "status": "Operational"
    },
    {
      "unit_id": 720,
      "generator_id": 485,
      "unit_code": "UNIT-0720",
      "unit_name": "GU-0720",
      "technology": "Wind",
      "rated_capacity_mw": 75.0,
      "available_capacity_mw": 67.53,
      "status": "Operational"
    }
  ],
  "utilities": [
    {
      "utility_id": 1,
      "name": "MSEDCL",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 2,
      "name": "BEST",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 3,
      "name": "TPC Distribution",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 4,
      "name": "Adani Electricity",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 5,
      "name": "Torrent Power",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 6,
      "name": "CIDCO Utility",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 7,
      "name": "Mahavitaran Pune",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 8,
      "name": "Mahavitaran Nashik",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 9,
      "name": "Mahavitaran Nagpur",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 10,
      "name": "Mahavitaran Aurangabad",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 11,
      "name": "Mahavitaran Kolhapur",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 12,
      "name": "Mahavitaran Satara",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 13,
      "name": "Mahavitaran Solapur",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 14,
      "name": "Mahavitaran Jalgaon",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 15,
      "name": "Mahavitaran Latur",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 16,
      "name": "Mahavitaran Amravati",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 17,
      "name": "Pune Utility",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 18,
      "name": "Nagpur Utility",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 19,
      "name": "Nashik Utility",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 20,
      "name": "Aurangabad Utility",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 21,
      "name": "Kolhapur Utility",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 22,
      "name": "Reliance Utility",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 23,
      "name": "Green Power Utility",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 24,
      "name": "West Grid Utility",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    },
    {
      "utility_id": 25,
      "name": "Central Grid Utility",
      "category": "DISCOM",
      "state": "Maharashtra",
      "status": "Active"
    }
  ],
  "consumers": [
    {
      "consumer_id": 1,
      "name": "Industrial Consumer 1",
      "consumer_type": "Open Access",
      "utility_id": 1,
      "status": "Active"
    },
    {
      "consumer_id": 2,
      "name": "Industrial Consumer 2",
      "consumer_type": "Captive",
      "utility_id": 2,
      "status": "Active"
    },
    {
      "consumer_id": 3,
      "name": "Industrial Consumer 3",
      "consumer_type": "Open Access",
      "utility_id": 3,
      "status": "Active"
    },
    {
      "consumer_id": 4,
      "name": "Industrial Consumer 4",
      "consumer_type": "Captive",
      "utility_id": 4,
      "status": "Active"
    },
    {
      "consumer_id": 5,
      "name": "Industrial Consumer 5",
      "consumer_type": "Open Access",
      "utility_id": 5,
      "status": "Active"
    },
    {
      "consumer_id": 6,
      "name": "Industrial Consumer 6",
      "consumer_type": "Captive",
      "utility_id": 6,
      "status": "Active"
    },
    {
      "consumer_id": 7,
      "name": "Industrial Consumer 7",
      "consumer_type": "Open Access",
      "utility_id": 7,
      "status": "Active"
    },
    {
      "consumer_id": 8,
      "name": "Industrial Consumer 8",
      "consumer_type": "Captive",
      "utility_id": 8,
      "status": "Active"
    },
    {
      "consumer_id": 9,
      "name": "Industrial Consumer 9",
      "consumer_type": "Open Access",
      "utility_id": 9,
      "status": "Active"
    },
    {
      "consumer_id": 10,
      "name": "Industrial Consumer 10",
      "consumer_type": "Captive",
      "utility_id": 10,
      "status": "Active"
    },
    {
      "consumer_id": 11,
      "name": "Industrial Consumer 11",
      "consumer_type": "Open Access",
      "utility_id": 11,
      "status": "Active"
    },
    {
      "consumer_id": 12,
      "name": "Industrial Consumer 12",
      "consumer_type": "Captive",
      "utility_id": 12,
      "status": "Active"
    },
    {
      "consumer_id": 13,
      "name": "Industrial Consumer 13",
      "consumer_type": "Open Access",
      "utility_id": 13,
      "status": "Active"
    },
    {
      "consumer_id": 14,
      "name": "Industrial Consumer 14",
      "consumer_type": "Captive",
      "utility_id": 14,
      "status": "Active"
    },
    {
      "consumer_id": 15,
      "name": "Industrial Consumer 15",
      "consumer_type": "Open Access",
      "utility_id": 15,
      "status": "Active"
    },
    {
      "consumer_id": 16,
      "name": "Industrial Consumer 16",
      "consumer_type": "Captive",
      "utility_id": 16,
      "status": "Active"
    },
    {
      "consumer_id": 17,
      "name": "Industrial Consumer 17",
      "consumer_type": "Open Access",
      "utility_id": 17,
      "status": "Active"
    },
    {
      "consumer_id": 18,
      "name": "Industrial Consumer 18",
      "consumer_type": "Captive",
      "utility_id": 18,
      "status": "Active"
    },
    {
      "consumer_id": 19,
      "name": "Industrial Consumer 19",
      "consumer_type": "Open Access",
      "utility_id": 19,
      "status": "Active"
    },
    {
      "consumer_id": 20,
      "name": "Industrial Consumer 20",
      "consumer_type": "Captive",
      "utility_id": 20,
      "status": "Active"
    },
    {
      "consumer_id": 21,
      "name": "Industrial Consumer 21",
      "consumer_type": "Open Access",
      "utility_id": 21,
      "status": "Active"
    },
    {
      "consumer_id": 22,
      "name": "Industrial Consumer 22",
      "consumer_type": "Captive",
      "utility_id": 22,
      "status": "Active"
    },
    {
      "consumer_id": 23,
      "name": "Industrial Consumer 23",
      "consumer_type": "Open Access",
      "utility_id": 23,
      "status": "Active"
    },
    {
      "consumer_id": 24,
      "name": "Industrial Consumer 24",
      "consumer_type": "Captive",
      "utility_id": 24,
      "status": "Active"
    },
    {
      "consumer_id": 25,
      "name": "Industrial Consumer 25",
      "consumer_type": "Open Access",
      "utility_id": 25,
      "status": "Active"
    },
    {
      "consumer_id": 26,
      "name": "Industrial Consumer 26",
      "consumer_type": "Captive",
      "utility_id": 1,
      "status": "Active"
    },
    {
      "consumer_id": 27,
      "name": "Industrial Consumer 27",
      "consumer_type": "Open Access",
      "utility_id": 2,
      "status": "Active"
    },
    {
      "consumer_id": 28,
      "name": "Industrial Consumer 28",
      "consumer_type": "Captive",
      "utility_id": 3,
      "status": "Active"
    },
    {
      "consumer_id": 29,
      "name": "Industrial Consumer 29",
      "consumer_type": "Open Access",
      "utility_id": 4,
      "status": "Active"
    },
    {
      "consumer_id": 30,
      "name": "Industrial Consumer 30",
      "consumer_type": "Captive",
      "utility_id": 5,
      "status": "Active"
    },
    {
      "consumer_id": 31,
      "name": "Industrial Consumer 31",
      "consumer_type": "Open Access",
      "utility_id": 6,
      "status": "Active"
    },
    {
      "consumer_id": 32,
      "name": "Industrial Consumer 32",
      "consumer_type": "Captive",
      "utility_id": 7,
      "status": "Active"
    },
    {
      "consumer_id": 33,
      "name": "Industrial Consumer 33",
      "consumer_type": "Open Access",
      "utility_id": 8,
      "status": "Active"
    },
    {
      "consumer_id": 34,
      "name": "Industrial Consumer 34",
      "consumer_type": "Captive",
      "utility_id": 9,
      "status": "Active"
    },
    {
      "consumer_id": 35,
      "name": "Industrial Consumer 35",
      "consumer_type": "Open Access",
      "utility_id": 10,
      "status": "Active"
    },
    {
      "consumer_id": 36,
      "name": "Industrial Consumer 36",
      "consumer_type": "Captive",
      "utility_id": 11,
      "status": "Active"
    },
    {
      "consumer_id": 37,
      "name": "Industrial Consumer 37",
      "consumer_type": "Open Access",
      "utility_id": 12,
      "status": "Active"
    },
    {
      "consumer_id": 38,
      "name": "Industrial Consumer 38",
      "consumer_type": "Captive",
      "utility_id": 13,
      "status": "Active"
    },
    {
      "consumer_id": 39,
      "name": "Industrial Consumer 39",
      "consumer_type": "Open Access",
      "utility_id": 14,
      "status": "Active"
    },
    {
      "consumer_id": 40,
      "name": "Industrial Consumer 40",
      "consumer_type": "Captive",
      "utility_id": 15,
      "status": "Active"
    }
  ],
  "contracts": [
    {
      "contract_id": 1,
      "contract_no": "CTR-2026-0001",
      "generator_unit_id": 1,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.0,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 2,
      "contract_no": "CTR-2026-0002",
      "generator_unit_id": 2,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.71,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 3,
      "contract_no": "CTR-2026-0003",
      "generator_unit_id": 3,
      "buyer_type": "Consumer",
      "buyer_id": 3,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.19,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 4,
      "contract_no": "CTR-2026-0004",
      "generator_unit_id": 4,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 5,
      "contract_no": "CTR-2026-0005",
      "generator_unit_id": 5,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.68,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 6,
      "contract_no": "CTR-2026-0006",
      "generator_unit_id": 6,
      "buyer_type": "Consumer",
      "buyer_id": 6,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.03,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 7,
      "contract_no": "CTR-2026-0007",
      "generator_unit_id": 7,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 8,
      "contract_no": "CTR-2026-0008",
      "generator_unit_id": 8,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.08,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 9,
      "contract_no": "CTR-2026-0009",
      "generator_unit_id": 9,
      "buyer_type": "Consumer",
      "buyer_id": 9,
      "contract_type": "Captive",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.1,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 10,
      "contract_no": "CTR-2026-0010",
      "generator_unit_id": 10,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.78,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 11,
      "contract_no": "CTR-2026-0011",
      "generator_unit_id": 11,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.1,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 12,
      "contract_no": "CTR-2026-0012",
      "generator_unit_id": 12,
      "buyer_type": "Consumer",
      "buyer_id": 12,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.43,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 13,
      "contract_no": "CTR-2026-0013",
      "generator_unit_id": 13,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "PPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.88,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 14,
      "contract_no": "CTR-2026-0014",
      "generator_unit_id": 14,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.26,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 15,
      "contract_no": "CTR-2026-0015",
      "generator_unit_id": 15,
      "buyer_type": "Consumer",
      "buyer_id": 15,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.02,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 16,
      "contract_no": "CTR-2026-0016",
      "generator_unit_id": 16,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.08,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 17,
      "contract_no": "CTR-2026-0017",
      "generator_unit_id": 17,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.02,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 18,
      "contract_no": "CTR-2026-0018",
      "generator_unit_id": 18,
      "buyer_type": "Consumer",
      "buyer_id": 18,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.64,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 19,
      "contract_no": "CTR-2026-0019",
      "generator_unit_id": 19,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.23,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 20,
      "contract_no": "CTR-2026-0020",
      "generator_unit_id": 20,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.0,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 21,
      "contract_no": "CTR-2026-0021",
      "generator_unit_id": 21,
      "buyer_type": "Consumer",
      "buyer_id": 21,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 22,
      "contract_no": "CTR-2026-0022",
      "generator_unit_id": 22,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.14,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 23,
      "contract_no": "CTR-2026-0023",
      "generator_unit_id": 23,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.8,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 24,
      "contract_no": "CTR-2026-0024",
      "generator_unit_id": 24,
      "buyer_type": "Consumer",
      "buyer_id": 24,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 25,
      "contract_no": "CTR-2026-0025",
      "generator_unit_id": 25,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 26,
      "contract_no": "CTR-2026-0026",
      "generator_unit_id": 26,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.44,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 27,
      "contract_no": "CTR-2026-0027",
      "generator_unit_id": 27,
      "buyer_type": "Consumer",
      "buyer_id": 27,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.5,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 28,
      "contract_no": "CTR-2026-0028",
      "generator_unit_id": 28,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.78,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 29,
      "contract_no": "CTR-2026-0029",
      "generator_unit_id": 29,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.01,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 30,
      "contract_no": "CTR-2026-0030",
      "generator_unit_id": 30,
      "buyer_type": "Consumer",
      "buyer_id": 30,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.04,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 31,
      "contract_no": "CTR-2026-0031",
      "generator_unit_id": 31,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.91,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 32,
      "contract_no": "CTR-2026-0032",
      "generator_unit_id": 32,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.74,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 33,
      "contract_no": "CTR-2026-0033",
      "generator_unit_id": 33,
      "buyer_type": "Consumer",
      "buyer_id": 33,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.59,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 34,
      "contract_no": "CTR-2026-0034",
      "generator_unit_id": 34,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.09,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 35,
      "contract_no": "CTR-2026-0035",
      "generator_unit_id": 35,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.37,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 36,
      "contract_no": "CTR-2026-0036",
      "generator_unit_id": 36,
      "buyer_type": "Consumer",
      "buyer_id": 36,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 37,
      "contract_no": "CTR-2026-0037",
      "generator_unit_id": 37,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 5.22,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 38,
      "contract_no": "CTR-2026-0038",
      "generator_unit_id": 38,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.78,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 39,
      "contract_no": "CTR-2026-0039",
      "generator_unit_id": 39,
      "buyer_type": "Consumer",
      "buyer_id": 39,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 5.32,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 40,
      "contract_no": "CTR-2026-0040",
      "generator_unit_id": 40,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 5.28,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 41,
      "contract_no": "CTR-2026-0041",
      "generator_unit_id": 41,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.69,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 42,
      "contract_no": "CTR-2026-0042",
      "generator_unit_id": 42,
      "buyer_type": "Consumer",
      "buyer_id": 2,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 2.82,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 43,
      "contract_no": "CTR-2026-0043",
      "generator_unit_id": 43,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.74,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 44,
      "contract_no": "CTR-2026-0044",
      "generator_unit_id": 44,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.65,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 45,
      "contract_no": "CTR-2026-0045",
      "generator_unit_id": 45,
      "buyer_type": "Consumer",
      "buyer_id": 5,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.18,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 46,
      "contract_no": "CTR-2026-0046",
      "generator_unit_id": 46,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 5.21,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 47,
      "contract_no": "CTR-2026-0047",
      "generator_unit_id": 47,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.39,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 48,
      "contract_no": "CTR-2026-0048",
      "generator_unit_id": 48,
      "buyer_type": "Consumer",
      "buyer_id": 8,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 2.9,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 49,
      "contract_no": "CTR-2026-0049",
      "generator_unit_id": 49,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.53,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 50,
      "contract_no": "CTR-2026-0050",
      "generator_unit_id": 50,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.4,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 51,
      "contract_no": "CTR-2026-0051",
      "generator_unit_id": 51,
      "buyer_type": "Consumer",
      "buyer_id": 11,
      "contract_type": "PPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.76,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 52,
      "contract_no": "CTR-2026-0052",
      "generator_unit_id": 52,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.14,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 53,
      "contract_no": "CTR-2026-0053",
      "generator_unit_id": 53,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.32,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 54,
      "contract_no": "CTR-2026-0054",
      "generator_unit_id": 54,
      "buyer_type": "Consumer",
      "buyer_id": 14,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 5.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 55,
      "contract_no": "CTR-2026-0055",
      "generator_unit_id": 55,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.61,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 56,
      "contract_no": "CTR-2026-0056",
      "generator_unit_id": 56,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 57,
      "contract_no": "CTR-2026-0057",
      "generator_unit_id": 57,
      "buyer_type": "Consumer",
      "buyer_id": 17,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.81,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 58,
      "contract_no": "CTR-2026-0058",
      "generator_unit_id": 58,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.67,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 59,
      "contract_no": "CTR-2026-0059",
      "generator_unit_id": 59,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.34,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 60,
      "contract_no": "CTR-2026-0060",
      "generator_unit_id": 60,
      "buyer_type": "Consumer",
      "buyer_id": 20,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.15,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 61,
      "contract_no": "CTR-2026-0061",
      "generator_unit_id": 61,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.68,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 62,
      "contract_no": "CTR-2026-0062",
      "generator_unit_id": 62,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.46,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 63,
      "contract_no": "CTR-2026-0063",
      "generator_unit_id": 63,
      "buyer_type": "Consumer",
      "buyer_id": 23,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.67,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 64,
      "contract_no": "CTR-2026-0064",
      "generator_unit_id": 64,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.17,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 65,
      "contract_no": "CTR-2026-0065",
      "generator_unit_id": 65,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.38,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 66,
      "contract_no": "CTR-2026-0066",
      "generator_unit_id": 66,
      "buyer_type": "Consumer",
      "buyer_id": 26,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.43,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 67,
      "contract_no": "CTR-2026-0067",
      "generator_unit_id": 67,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.11,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 68,
      "contract_no": "CTR-2026-0068",
      "generator_unit_id": 68,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.18,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 69,
      "contract_no": "CTR-2026-0069",
      "generator_unit_id": 69,
      "buyer_type": "Consumer",
      "buyer_id": 29,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 70,
      "contract_no": "CTR-2026-0070",
      "generator_unit_id": 70,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.93,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 71,
      "contract_no": "CTR-2026-0071",
      "generator_unit_id": 71,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.93,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 72,
      "contract_no": "CTR-2026-0072",
      "generator_unit_id": 72,
      "buyer_type": "Consumer",
      "buyer_id": 32,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 5.45,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 73,
      "contract_no": "CTR-2026-0073",
      "generator_unit_id": 73,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.26,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 74,
      "contract_no": "CTR-2026-0074",
      "generator_unit_id": 74,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.47,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 75,
      "contract_no": "CTR-2026-0075",
      "generator_unit_id": 75,
      "buyer_type": "Consumer",
      "buyer_id": 35,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 76,
      "contract_no": "CTR-2026-0076",
      "generator_unit_id": 76,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 77,
      "contract_no": "CTR-2026-0077",
      "generator_unit_id": 77,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 5.39,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 78,
      "contract_no": "CTR-2026-0078",
      "generator_unit_id": 78,
      "buyer_type": "Consumer",
      "buyer_id": 38,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.86,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 79,
      "contract_no": "CTR-2026-0079",
      "generator_unit_id": 79,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 5.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 80,
      "contract_no": "CTR-2026-0080",
      "generator_unit_id": 80,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.61,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 81,
      "contract_no": "CTR-2026-0081",
      "generator_unit_id": 81,
      "buyer_type": "Consumer",
      "buyer_id": 1,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 82,
      "contract_no": "CTR-2026-0082",
      "generator_unit_id": 82,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.77,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 83,
      "contract_no": "CTR-2026-0083",
      "generator_unit_id": 83,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 5.47,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 84,
      "contract_no": "CTR-2026-0084",
      "generator_unit_id": 84,
      "buyer_type": "Consumer",
      "buyer_id": 4,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.01,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 85,
      "contract_no": "CTR-2026-0085",
      "generator_unit_id": 85,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.7,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 86,
      "contract_no": "CTR-2026-0086",
      "generator_unit_id": 86,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.16,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 87,
      "contract_no": "CTR-2026-0087",
      "generator_unit_id": 87,
      "buyer_type": "Consumer",
      "buyer_id": 7,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.7,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 88,
      "contract_no": "CTR-2026-0088",
      "generator_unit_id": 88,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.14,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 89,
      "contract_no": "CTR-2026-0089",
      "generator_unit_id": 89,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.5,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 90,
      "contract_no": "CTR-2026-0090",
      "generator_unit_id": 90,
      "buyer_type": "Consumer",
      "buyer_id": 10,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 91,
      "contract_no": "CTR-2026-0091",
      "generator_unit_id": 91,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.64,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 92,
      "contract_no": "CTR-2026-0092",
      "generator_unit_id": 92,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.26,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 93,
      "contract_no": "CTR-2026-0093",
      "generator_unit_id": 93,
      "buyer_type": "Consumer",
      "buyer_id": 13,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.69,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 94,
      "contract_no": "CTR-2026-0094",
      "generator_unit_id": 94,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.98,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 95,
      "contract_no": "CTR-2026-0095",
      "generator_unit_id": 95,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.41,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 96,
      "contract_no": "CTR-2026-0096",
      "generator_unit_id": 96,
      "buyer_type": "Consumer",
      "buyer_id": 16,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.14,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 97,
      "contract_no": "CTR-2026-0097",
      "generator_unit_id": 97,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.41,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 98,
      "contract_no": "CTR-2026-0098",
      "generator_unit_id": 98,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.22,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 99,
      "contract_no": "CTR-2026-0099",
      "generator_unit_id": 99,
      "buyer_type": "Consumer",
      "buyer_id": 19,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.91,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 100,
      "contract_no": "CTR-2026-0100",
      "generator_unit_id": 100,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.66,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 101,
      "contract_no": "CTR-2026-0101",
      "generator_unit_id": 101,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.37,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 102,
      "contract_no": "CTR-2026-0102",
      "generator_unit_id": 102,
      "buyer_type": "Consumer",
      "buyer_id": 22,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 103,
      "contract_no": "CTR-2026-0103",
      "generator_unit_id": 103,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.6,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 104,
      "contract_no": "CTR-2026-0104",
      "generator_unit_id": 104,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.0,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 105,
      "contract_no": "CTR-2026-0105",
      "generator_unit_id": 105,
      "buyer_type": "Consumer",
      "buyer_id": 25,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.28,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 106,
      "contract_no": "CTR-2026-0106",
      "generator_unit_id": 106,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.73,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 107,
      "contract_no": "CTR-2026-0107",
      "generator_unit_id": 107,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.14,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 108,
      "contract_no": "CTR-2026-0108",
      "generator_unit_id": 108,
      "buyer_type": "Consumer",
      "buyer_id": 28,
      "contract_type": "Captive",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 109,
      "contract_no": "CTR-2026-0109",
      "generator_unit_id": 109,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 5.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 110,
      "contract_no": "CTR-2026-0110",
      "generator_unit_id": 110,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.04,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 111,
      "contract_no": "CTR-2026-0111",
      "generator_unit_id": 111,
      "buyer_type": "Consumer",
      "buyer_id": 31,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.08,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 112,
      "contract_no": "CTR-2026-0112",
      "generator_unit_id": 112,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.54,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 113,
      "contract_no": "CTR-2026-0113",
      "generator_unit_id": 113,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 2.82,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 114,
      "contract_no": "CTR-2026-0114",
      "generator_unit_id": 114,
      "buyer_type": "Consumer",
      "buyer_id": 34,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 115,
      "contract_no": "CTR-2026-0115",
      "generator_unit_id": 115,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.49,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 116,
      "contract_no": "CTR-2026-0116",
      "generator_unit_id": 116,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "PPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.67,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 117,
      "contract_no": "CTR-2026-0117",
      "generator_unit_id": 117,
      "buyer_type": "Consumer",
      "buyer_id": 37,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.7,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 118,
      "contract_no": "CTR-2026-0118",
      "generator_unit_id": 118,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.22,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 119,
      "contract_no": "CTR-2026-0119",
      "generator_unit_id": 119,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.0,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 120,
      "contract_no": "CTR-2026-0120",
      "generator_unit_id": 120,
      "buyer_type": "Consumer",
      "buyer_id": 40,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.67,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 121,
      "contract_no": "CTR-2026-0121",
      "generator_unit_id": 121,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.35,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 122,
      "contract_no": "CTR-2026-0122",
      "generator_unit_id": 122,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.75,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 123,
      "contract_no": "CTR-2026-0123",
      "generator_unit_id": 123,
      "buyer_type": "Consumer",
      "buyer_id": 3,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.73,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 124,
      "contract_no": "CTR-2026-0124",
      "generator_unit_id": 124,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 125,
      "contract_no": "CTR-2026-0125",
      "generator_unit_id": 125,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.72,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 126,
      "contract_no": "CTR-2026-0126",
      "generator_unit_id": 126,
      "buyer_type": "Consumer",
      "buyer_id": 6,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.8,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 127,
      "contract_no": "CTR-2026-0127",
      "generator_unit_id": 127,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.04,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 128,
      "contract_no": "CTR-2026-0128",
      "generator_unit_id": 128,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.49,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 129,
      "contract_no": "CTR-2026-0129",
      "generator_unit_id": 129,
      "buyer_type": "Consumer",
      "buyer_id": 9,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.75,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 130,
      "contract_no": "CTR-2026-0130",
      "generator_unit_id": 130,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.88,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 131,
      "contract_no": "CTR-2026-0131",
      "generator_unit_id": 131,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.16,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 132,
      "contract_no": "CTR-2026-0132",
      "generator_unit_id": 132,
      "buyer_type": "Consumer",
      "buyer_id": 12,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.71,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 133,
      "contract_no": "CTR-2026-0133",
      "generator_unit_id": 133,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.98,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 134,
      "contract_no": "CTR-2026-0134",
      "generator_unit_id": 134,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 135,
      "contract_no": "CTR-2026-0135",
      "generator_unit_id": 135,
      "buyer_type": "Consumer",
      "buyer_id": 15,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 136,
      "contract_no": "CTR-2026-0136",
      "generator_unit_id": 136,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.86,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 137,
      "contract_no": "CTR-2026-0137",
      "generator_unit_id": 137,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.29,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 138,
      "contract_no": "CTR-2026-0138",
      "generator_unit_id": 138,
      "buyer_type": "Consumer",
      "buyer_id": 18,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 2.99,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 139,
      "contract_no": "CTR-2026-0139",
      "generator_unit_id": 139,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "Captive",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.45,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 140,
      "contract_no": "CTR-2026-0140",
      "generator_unit_id": 140,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 141,
      "contract_no": "CTR-2026-0141",
      "generator_unit_id": 141,
      "buyer_type": "Consumer",
      "buyer_id": 21,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.23,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 142,
      "contract_no": "CTR-2026-0142",
      "generator_unit_id": 142,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.73,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 143,
      "contract_no": "CTR-2026-0143",
      "generator_unit_id": 143,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.75,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 144,
      "contract_no": "CTR-2026-0144",
      "generator_unit_id": 144,
      "buyer_type": "Consumer",
      "buyer_id": 24,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.63,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 145,
      "contract_no": "CTR-2026-0145",
      "generator_unit_id": 145,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.6,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 146,
      "contract_no": "CTR-2026-0146",
      "generator_unit_id": 146,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.7,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 147,
      "contract_no": "CTR-2026-0147",
      "generator_unit_id": 147,
      "buyer_type": "Consumer",
      "buyer_id": 27,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.79,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 148,
      "contract_no": "CTR-2026-0148",
      "generator_unit_id": 148,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.74,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 149,
      "contract_no": "CTR-2026-0149",
      "generator_unit_id": 149,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 5.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 150,
      "contract_no": "CTR-2026-0150",
      "generator_unit_id": 150,
      "buyer_type": "Consumer",
      "buyer_id": 30,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.82,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 151,
      "contract_no": "CTR-2026-0151",
      "generator_unit_id": 151,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.14,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 152,
      "contract_no": "CTR-2026-0152",
      "generator_unit_id": 152,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.94,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 153,
      "contract_no": "CTR-2026-0153",
      "generator_unit_id": 153,
      "buyer_type": "Consumer",
      "buyer_id": 33,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.23,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 154,
      "contract_no": "CTR-2026-0154",
      "generator_unit_id": 154,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.06,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 155,
      "contract_no": "CTR-2026-0155",
      "generator_unit_id": 155,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.59,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 156,
      "contract_no": "CTR-2026-0156",
      "generator_unit_id": 156,
      "buyer_type": "Consumer",
      "buyer_id": 36,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 157,
      "contract_no": "CTR-2026-0157",
      "generator_unit_id": 157,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.84,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 158,
      "contract_no": "CTR-2026-0158",
      "generator_unit_id": 158,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.95,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 159,
      "contract_no": "CTR-2026-0159",
      "generator_unit_id": 159,
      "buyer_type": "Consumer",
      "buyer_id": 39,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.68,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 160,
      "contract_no": "CTR-2026-0160",
      "generator_unit_id": 160,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.74,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 161,
      "contract_no": "CTR-2026-0161",
      "generator_unit_id": 161,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 2.81,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 162,
      "contract_no": "CTR-2026-0162",
      "generator_unit_id": 162,
      "buyer_type": "Consumer",
      "buyer_id": 2,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.85,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 163,
      "contract_no": "CTR-2026-0163",
      "generator_unit_id": 163,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.97,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 164,
      "contract_no": "CTR-2026-0164",
      "generator_unit_id": 164,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.08,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 165,
      "contract_no": "CTR-2026-0165",
      "generator_unit_id": 165,
      "buyer_type": "Consumer",
      "buyer_id": 5,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.85,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 166,
      "contract_no": "CTR-2026-0166",
      "generator_unit_id": 166,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.17,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 167,
      "contract_no": "CTR-2026-0167",
      "generator_unit_id": 167,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 2.97,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 168,
      "contract_no": "CTR-2026-0168",
      "generator_unit_id": 168,
      "buyer_type": "Consumer",
      "buyer_id": 8,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 169,
      "contract_no": "CTR-2026-0169",
      "generator_unit_id": 169,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 5.16,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 170,
      "contract_no": "CTR-2026-0170",
      "generator_unit_id": 170,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.57,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 171,
      "contract_no": "CTR-2026-0171",
      "generator_unit_id": 171,
      "buyer_type": "Consumer",
      "buyer_id": 11,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 2.9,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 172,
      "contract_no": "CTR-2026-0172",
      "generator_unit_id": 172,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.28,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 173,
      "contract_no": "CTR-2026-0173",
      "generator_unit_id": 173,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.21,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 174,
      "contract_no": "CTR-2026-0174",
      "generator_unit_id": 174,
      "buyer_type": "Consumer",
      "buyer_id": 14,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.91,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 175,
      "contract_no": "CTR-2026-0175",
      "generator_unit_id": 175,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.81,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 176,
      "contract_no": "CTR-2026-0176",
      "generator_unit_id": 176,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.26,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 177,
      "contract_no": "CTR-2026-0177",
      "generator_unit_id": 177,
      "buyer_type": "Consumer",
      "buyer_id": 17,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.53,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 178,
      "contract_no": "CTR-2026-0178",
      "generator_unit_id": 178,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 2.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 179,
      "contract_no": "CTR-2026-0179",
      "generator_unit_id": 179,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.75,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 180,
      "contract_no": "CTR-2026-0180",
      "generator_unit_id": 180,
      "buyer_type": "Consumer",
      "buyer_id": 20,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.16,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 181,
      "contract_no": "CTR-2026-0181",
      "generator_unit_id": 181,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.38,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 182,
      "contract_no": "CTR-2026-0182",
      "generator_unit_id": 182,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.15,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 183,
      "contract_no": "CTR-2026-0183",
      "generator_unit_id": 183,
      "buyer_type": "Consumer",
      "buyer_id": 23,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.63,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 184,
      "contract_no": "CTR-2026-0184",
      "generator_unit_id": 184,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 185,
      "contract_no": "CTR-2026-0185",
      "generator_unit_id": 185,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 186,
      "contract_no": "CTR-2026-0186",
      "generator_unit_id": 186,
      "buyer_type": "Consumer",
      "buyer_id": 26,
      "contract_type": "PPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.77,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 187,
      "contract_no": "CTR-2026-0187",
      "generator_unit_id": 187,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.99,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 188,
      "contract_no": "CTR-2026-0188",
      "generator_unit_id": 188,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.59,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 189,
      "contract_no": "CTR-2026-0189",
      "generator_unit_id": 189,
      "buyer_type": "Consumer",
      "buyer_id": 29,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.56,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 190,
      "contract_no": "CTR-2026-0190",
      "generator_unit_id": 190,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.06,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 191,
      "contract_no": "CTR-2026-0191",
      "generator_unit_id": 191,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.45,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 192,
      "contract_no": "CTR-2026-0192",
      "generator_unit_id": 192,
      "buyer_type": "Consumer",
      "buyer_id": 32,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 2.84,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 193,
      "contract_no": "CTR-2026-0193",
      "generator_unit_id": 193,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.32,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 194,
      "contract_no": "CTR-2026-0194",
      "generator_unit_id": 194,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.89,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 195,
      "contract_no": "CTR-2026-0195",
      "generator_unit_id": 195,
      "buyer_type": "Consumer",
      "buyer_id": 35,
      "contract_type": "PPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.73,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 196,
      "contract_no": "CTR-2026-0196",
      "generator_unit_id": 196,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.97,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 197,
      "contract_no": "CTR-2026-0197",
      "generator_unit_id": 197,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 198,
      "contract_no": "CTR-2026-0198",
      "generator_unit_id": 198,
      "buyer_type": "Consumer",
      "buyer_id": 38,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.02,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 199,
      "contract_no": "CTR-2026-0199",
      "generator_unit_id": 199,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.15,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 200,
      "contract_no": "CTR-2026-0200",
      "generator_unit_id": 200,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 2.92,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 201,
      "contract_no": "CTR-2026-0201",
      "generator_unit_id": 201,
      "buyer_type": "Consumer",
      "buyer_id": 1,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.41,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 202,
      "contract_no": "CTR-2026-0202",
      "generator_unit_id": 202,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.04,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 203,
      "contract_no": "CTR-2026-0203",
      "generator_unit_id": 203,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.07,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 204,
      "contract_no": "CTR-2026-0204",
      "generator_unit_id": 204,
      "buyer_type": "Consumer",
      "buyer_id": 4,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.52,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 205,
      "contract_no": "CTR-2026-0205",
      "generator_unit_id": 205,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.24,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 206,
      "contract_no": "CTR-2026-0206",
      "generator_unit_id": 206,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.26,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 207,
      "contract_no": "CTR-2026-0207",
      "generator_unit_id": 207,
      "buyer_type": "Consumer",
      "buyer_id": 7,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.8,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 208,
      "contract_no": "CTR-2026-0208",
      "generator_unit_id": 208,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.05,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 209,
      "contract_no": "CTR-2026-0209",
      "generator_unit_id": 209,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.83,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 210,
      "contract_no": "CTR-2026-0210",
      "generator_unit_id": 210,
      "buyer_type": "Consumer",
      "buyer_id": 10,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.32,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 211,
      "contract_no": "CTR-2026-0211",
      "generator_unit_id": 211,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.21,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 212,
      "contract_no": "CTR-2026-0212",
      "generator_unit_id": 212,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "Captive",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.84,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 213,
      "contract_no": "CTR-2026-0213",
      "generator_unit_id": 213,
      "buyer_type": "Consumer",
      "buyer_id": 13,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.08,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 214,
      "contract_no": "CTR-2026-0214",
      "generator_unit_id": 214,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.24,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 215,
      "contract_no": "CTR-2026-0215",
      "generator_unit_id": 215,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 216,
      "contract_no": "CTR-2026-0216",
      "generator_unit_id": 216,
      "buyer_type": "Consumer",
      "buyer_id": 16,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 2.98,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 217,
      "contract_no": "CTR-2026-0217",
      "generator_unit_id": 217,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.73,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 218,
      "contract_no": "CTR-2026-0218",
      "generator_unit_id": 218,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.13,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 219,
      "contract_no": "CTR-2026-0219",
      "generator_unit_id": 219,
      "buyer_type": "Consumer",
      "buyer_id": 19,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 220,
      "contract_no": "CTR-2026-0220",
      "generator_unit_id": 220,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.86,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 221,
      "contract_no": "CTR-2026-0221",
      "generator_unit_id": 221,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.09,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 222,
      "contract_no": "CTR-2026-0222",
      "generator_unit_id": 222,
      "buyer_type": "Consumer",
      "buyer_id": 22,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.05,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 223,
      "contract_no": "CTR-2026-0223",
      "generator_unit_id": 223,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.78,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 224,
      "contract_no": "CTR-2026-0224",
      "generator_unit_id": 224,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.34,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 225,
      "contract_no": "CTR-2026-0225",
      "generator_unit_id": 225,
      "buyer_type": "Consumer",
      "buyer_id": 25,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.94,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 226,
      "contract_no": "CTR-2026-0226",
      "generator_unit_id": 226,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.97,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 227,
      "contract_no": "CTR-2026-0227",
      "generator_unit_id": 227,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.11,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 228,
      "contract_no": "CTR-2026-0228",
      "generator_unit_id": 228,
      "buyer_type": "Consumer",
      "buyer_id": 28,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 229,
      "contract_no": "CTR-2026-0229",
      "generator_unit_id": 229,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.66,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 230,
      "contract_no": "CTR-2026-0230",
      "generator_unit_id": 230,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.5,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 231,
      "contract_no": "CTR-2026-0231",
      "generator_unit_id": 231,
      "buyer_type": "Consumer",
      "buyer_id": 31,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.21,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 232,
      "contract_no": "CTR-2026-0232",
      "generator_unit_id": 232,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.91,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 233,
      "contract_no": "CTR-2026-0233",
      "generator_unit_id": 233,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.02,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 234,
      "contract_no": "CTR-2026-0234",
      "generator_unit_id": 234,
      "buyer_type": "Consumer",
      "buyer_id": 34,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.21,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 235,
      "contract_no": "CTR-2026-0235",
      "generator_unit_id": 235,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.94,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 236,
      "contract_no": "CTR-2026-0236",
      "generator_unit_id": 236,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.31,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 237,
      "contract_no": "CTR-2026-0237",
      "generator_unit_id": 237,
      "buyer_type": "Consumer",
      "buyer_id": 37,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 2.81,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 238,
      "contract_no": "CTR-2026-0238",
      "generator_unit_id": 238,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.83,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 239,
      "contract_no": "CTR-2026-0239",
      "generator_unit_id": 239,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.44,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 240,
      "contract_no": "CTR-2026-0240",
      "generator_unit_id": 240,
      "buyer_type": "Consumer",
      "buyer_id": 40,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.78,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 241,
      "contract_no": "CTR-2026-0241",
      "generator_unit_id": 241,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.32,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 242,
      "contract_no": "CTR-2026-0242",
      "generator_unit_id": 242,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "PPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.54,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 243,
      "contract_no": "CTR-2026-0243",
      "generator_unit_id": 243,
      "buyer_type": "Consumer",
      "buyer_id": 3,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.09,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 244,
      "contract_no": "CTR-2026-0244",
      "generator_unit_id": 244,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 245,
      "contract_no": "CTR-2026-0245",
      "generator_unit_id": 245,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.44,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 246,
      "contract_no": "CTR-2026-0246",
      "generator_unit_id": 246,
      "buyer_type": "Consumer",
      "buyer_id": 6,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 2.8,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 247,
      "contract_no": "CTR-2026-0247",
      "generator_unit_id": 247,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.23,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 248,
      "contract_no": "CTR-2026-0248",
      "generator_unit_id": 248,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.77,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 249,
      "contract_no": "CTR-2026-0249",
      "generator_unit_id": 249,
      "buyer_type": "Consumer",
      "buyer_id": 9,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.53,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 250,
      "contract_no": "CTR-2026-0250",
      "generator_unit_id": 250,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.46,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 251,
      "contract_no": "CTR-2026-0251",
      "generator_unit_id": 251,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.21,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 252,
      "contract_no": "CTR-2026-0252",
      "generator_unit_id": 252,
      "buyer_type": "Consumer",
      "buyer_id": 12,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.49,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 253,
      "contract_no": "CTR-2026-0253",
      "generator_unit_id": 253,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.67,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 254,
      "contract_no": "CTR-2026-0254",
      "generator_unit_id": 254,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.13,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 255,
      "contract_no": "CTR-2026-0255",
      "generator_unit_id": 255,
      "buyer_type": "Consumer",
      "buyer_id": 15,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 256,
      "contract_no": "CTR-2026-0256",
      "generator_unit_id": 256,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.7,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 257,
      "contract_no": "CTR-2026-0257",
      "generator_unit_id": 257,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 5.05,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 258,
      "contract_no": "CTR-2026-0258",
      "generator_unit_id": 258,
      "buyer_type": "Consumer",
      "buyer_id": 18,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.62,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 259,
      "contract_no": "CTR-2026-0259",
      "generator_unit_id": 259,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.16,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 260,
      "contract_no": "CTR-2026-0260",
      "generator_unit_id": 260,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.37,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 261,
      "contract_no": "CTR-2026-0261",
      "generator_unit_id": 261,
      "buyer_type": "Consumer",
      "buyer_id": 21,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 5.45,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 262,
      "contract_no": "CTR-2026-0262",
      "generator_unit_id": 262,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 5.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 263,
      "contract_no": "CTR-2026-0263",
      "generator_unit_id": 263,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.72,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 264,
      "contract_no": "CTR-2026-0264",
      "generator_unit_id": 264,
      "buyer_type": "Consumer",
      "buyer_id": 24,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.74,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 265,
      "contract_no": "CTR-2026-0265",
      "generator_unit_id": 265,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.6,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 266,
      "contract_no": "CTR-2026-0266",
      "generator_unit_id": 266,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.06,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 267,
      "contract_no": "CTR-2026-0267",
      "generator_unit_id": 267,
      "buyer_type": "Consumer",
      "buyer_id": 27,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.39,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 268,
      "contract_no": "CTR-2026-0268",
      "generator_unit_id": 268,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.9,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 269,
      "contract_no": "CTR-2026-0269",
      "generator_unit_id": 269,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 270,
      "contract_no": "CTR-2026-0270",
      "generator_unit_id": 270,
      "buyer_type": "Consumer",
      "buyer_id": 30,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.11,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 271,
      "contract_no": "CTR-2026-0271",
      "generator_unit_id": 271,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.97,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 272,
      "contract_no": "CTR-2026-0272",
      "generator_unit_id": 272,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.02,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 273,
      "contract_no": "CTR-2026-0273",
      "generator_unit_id": 273,
      "buyer_type": "Consumer",
      "buyer_id": 33,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.48,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 274,
      "contract_no": "CTR-2026-0274",
      "generator_unit_id": 274,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.93,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 275,
      "contract_no": "CTR-2026-0275",
      "generator_unit_id": 275,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.09,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 276,
      "contract_no": "CTR-2026-0276",
      "generator_unit_id": 276,
      "buyer_type": "Consumer",
      "buyer_id": 36,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.27,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 277,
      "contract_no": "CTR-2026-0277",
      "generator_unit_id": 277,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 278,
      "contract_no": "CTR-2026-0278",
      "generator_unit_id": 278,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.36,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 279,
      "contract_no": "CTR-2026-0279",
      "generator_unit_id": 279,
      "buyer_type": "Consumer",
      "buyer_id": 39,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.43,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 280,
      "contract_no": "CTR-2026-0280",
      "generator_unit_id": 280,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 281,
      "contract_no": "CTR-2026-0281",
      "generator_unit_id": 281,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.64,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 282,
      "contract_no": "CTR-2026-0282",
      "generator_unit_id": 282,
      "buyer_type": "Consumer",
      "buyer_id": 2,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 2.89,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 283,
      "contract_no": "CTR-2026-0283",
      "generator_unit_id": 283,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.48,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 284,
      "contract_no": "CTR-2026-0284",
      "generator_unit_id": 284,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.26,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 285,
      "contract_no": "CTR-2026-0285",
      "generator_unit_id": 285,
      "buyer_type": "Consumer",
      "buyer_id": 5,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.26,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 286,
      "contract_no": "CTR-2026-0286",
      "generator_unit_id": 286,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.5,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 287,
      "contract_no": "CTR-2026-0287",
      "generator_unit_id": 287,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.95,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 288,
      "contract_no": "CTR-2026-0288",
      "generator_unit_id": 288,
      "buyer_type": "Consumer",
      "buyer_id": 8,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.5,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 289,
      "contract_no": "CTR-2026-0289",
      "generator_unit_id": 289,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.54,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 290,
      "contract_no": "CTR-2026-0290",
      "generator_unit_id": 290,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.29,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 291,
      "contract_no": "CTR-2026-0291",
      "generator_unit_id": 291,
      "buyer_type": "Consumer",
      "buyer_id": 11,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 292,
      "contract_no": "CTR-2026-0292",
      "generator_unit_id": 292,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.77,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 293,
      "contract_no": "CTR-2026-0293",
      "generator_unit_id": 293,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 2.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 294,
      "contract_no": "CTR-2026-0294",
      "generator_unit_id": 294,
      "buyer_type": "Consumer",
      "buyer_id": 14,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.98,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 295,
      "contract_no": "CTR-2026-0295",
      "generator_unit_id": 295,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 296,
      "contract_no": "CTR-2026-0296",
      "generator_unit_id": 296,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.89,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 297,
      "contract_no": "CTR-2026-0297",
      "generator_unit_id": 297,
      "buyer_type": "Consumer",
      "buyer_id": 17,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.13,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 298,
      "contract_no": "CTR-2026-0298",
      "generator_unit_id": 298,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.16,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 299,
      "contract_no": "CTR-2026-0299",
      "generator_unit_id": 299,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.71,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 300,
      "contract_no": "CTR-2026-0300",
      "generator_unit_id": 300,
      "buyer_type": "Consumer",
      "buyer_id": 20,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.79,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 301,
      "contract_no": "CTR-2026-0301",
      "generator_unit_id": 301,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.48,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 302,
      "contract_no": "CTR-2026-0302",
      "generator_unit_id": 302,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.14,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 303,
      "contract_no": "CTR-2026-0303",
      "generator_unit_id": 303,
      "buyer_type": "Consumer",
      "buyer_id": 23,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 304,
      "contract_no": "CTR-2026-0304",
      "generator_unit_id": 304,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.15,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 305,
      "contract_no": "CTR-2026-0305",
      "generator_unit_id": 305,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.35,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 306,
      "contract_no": "CTR-2026-0306",
      "generator_unit_id": 306,
      "buyer_type": "Consumer",
      "buyer_id": 26,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.04,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 307,
      "contract_no": "CTR-2026-0307",
      "generator_unit_id": 307,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 308,
      "contract_no": "CTR-2026-0308",
      "generator_unit_id": 308,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 309,
      "contract_no": "CTR-2026-0309",
      "generator_unit_id": 309,
      "buyer_type": "Consumer",
      "buyer_id": 29,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.9,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 310,
      "contract_no": "CTR-2026-0310",
      "generator_unit_id": 310,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.17,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 311,
      "contract_no": "CTR-2026-0311",
      "generator_unit_id": 311,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.96,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 312,
      "contract_no": "CTR-2026-0312",
      "generator_unit_id": 312,
      "buyer_type": "Consumer",
      "buyer_id": 32,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.71,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 313,
      "contract_no": "CTR-2026-0313",
      "generator_unit_id": 313,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.45,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 314,
      "contract_no": "CTR-2026-0314",
      "generator_unit_id": 314,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 315,
      "contract_no": "CTR-2026-0315",
      "generator_unit_id": 315,
      "buyer_type": "Consumer",
      "buyer_id": 35,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.23,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 316,
      "contract_no": "CTR-2026-0316",
      "generator_unit_id": 316,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.5,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 317,
      "contract_no": "CTR-2026-0317",
      "generator_unit_id": 317,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.32,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 318,
      "contract_no": "CTR-2026-0318",
      "generator_unit_id": 318,
      "buyer_type": "Consumer",
      "buyer_id": 38,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.27,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 319,
      "contract_no": "CTR-2026-0319",
      "generator_unit_id": 319,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.67,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 320,
      "contract_no": "CTR-2026-0320",
      "generator_unit_id": 320,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.23,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 321,
      "contract_no": "CTR-2026-0321",
      "generator_unit_id": 321,
      "buyer_type": "Consumer",
      "buyer_id": 1,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.13,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 322,
      "contract_no": "CTR-2026-0322",
      "generator_unit_id": 322,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 323,
      "contract_no": "CTR-2026-0323",
      "generator_unit_id": 323,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.66,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 324,
      "contract_no": "CTR-2026-0324",
      "generator_unit_id": 324,
      "buyer_type": "Consumer",
      "buyer_id": 4,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.31,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 325,
      "contract_no": "CTR-2026-0325",
      "generator_unit_id": 325,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 326,
      "contract_no": "CTR-2026-0326",
      "generator_unit_id": 326,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 2.94,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 327,
      "contract_no": "CTR-2026-0327",
      "generator_unit_id": 327,
      "buyer_type": "Consumer",
      "buyer_id": 7,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.07,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 328,
      "contract_no": "CTR-2026-0328",
      "generator_unit_id": 328,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.26,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 329,
      "contract_no": "CTR-2026-0329",
      "generator_unit_id": 329,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.47,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 330,
      "contract_no": "CTR-2026-0330",
      "generator_unit_id": 330,
      "buyer_type": "Consumer",
      "buyer_id": 10,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.48,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 331,
      "contract_no": "CTR-2026-0331",
      "generator_unit_id": 331,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.71,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 332,
      "contract_no": "CTR-2026-0332",
      "generator_unit_id": 332,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 333,
      "contract_no": "CTR-2026-0333",
      "generator_unit_id": 333,
      "buyer_type": "Consumer",
      "buyer_id": 13,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 2.8,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 334,
      "contract_no": "CTR-2026-0334",
      "generator_unit_id": 334,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.07,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 335,
      "contract_no": "CTR-2026-0335",
      "generator_unit_id": 335,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.01,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 336,
      "contract_no": "CTR-2026-0336",
      "generator_unit_id": 336,
      "buyer_type": "Consumer",
      "buyer_id": 16,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 337,
      "contract_no": "CTR-2026-0337",
      "generator_unit_id": 337,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.21,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 338,
      "contract_no": "CTR-2026-0338",
      "generator_unit_id": 338,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "Captive",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 339,
      "contract_no": "CTR-2026-0339",
      "generator_unit_id": 339,
      "buyer_type": "Consumer",
      "buyer_id": 19,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.38,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 340,
      "contract_no": "CTR-2026-0340",
      "generator_unit_id": 340,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.01,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 341,
      "contract_no": "CTR-2026-0341",
      "generator_unit_id": 341,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.48,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 342,
      "contract_no": "CTR-2026-0342",
      "generator_unit_id": 342,
      "buyer_type": "Consumer",
      "buyer_id": 22,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.97,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 343,
      "contract_no": "CTR-2026-0343",
      "generator_unit_id": 343,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.95,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 344,
      "contract_no": "CTR-2026-0344",
      "generator_unit_id": 344,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.22,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 345,
      "contract_no": "CTR-2026-0345",
      "generator_unit_id": 345,
      "buyer_type": "Consumer",
      "buyer_id": 25,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.53,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 346,
      "contract_no": "CTR-2026-0346",
      "generator_unit_id": 346,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.86,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 347,
      "contract_no": "CTR-2026-0347",
      "generator_unit_id": 347,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 5.07,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 348,
      "contract_no": "CTR-2026-0348",
      "generator_unit_id": 348,
      "buyer_type": "Consumer",
      "buyer_id": 28,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.39,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 349,
      "contract_no": "CTR-2026-0349",
      "generator_unit_id": 349,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.13,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 350,
      "contract_no": "CTR-2026-0350",
      "generator_unit_id": 350,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.35,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 351,
      "contract_no": "CTR-2026-0351",
      "generator_unit_id": 351,
      "buyer_type": "Consumer",
      "buyer_id": 31,
      "contract_type": "Captive",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.59,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 352,
      "contract_no": "CTR-2026-0352",
      "generator_unit_id": 352,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 353,
      "contract_no": "CTR-2026-0353",
      "generator_unit_id": 353,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.73,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 354,
      "contract_no": "CTR-2026-0354",
      "generator_unit_id": 354,
      "buyer_type": "Consumer",
      "buyer_id": 34,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.1,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 355,
      "contract_no": "CTR-2026-0355",
      "generator_unit_id": 355,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.27,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 356,
      "contract_no": "CTR-2026-0356",
      "generator_unit_id": 356,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.97,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 357,
      "contract_no": "CTR-2026-0357",
      "generator_unit_id": 357,
      "buyer_type": "Consumer",
      "buyer_id": 37,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 5.17,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 358,
      "contract_no": "CTR-2026-0358",
      "generator_unit_id": 358,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 5.39,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 359,
      "contract_no": "CTR-2026-0359",
      "generator_unit_id": 359,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 360,
      "contract_no": "CTR-2026-0360",
      "generator_unit_id": 360,
      "buyer_type": "Consumer",
      "buyer_id": 40,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.53,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 361,
      "contract_no": "CTR-2026-0361",
      "generator_unit_id": 361,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.16,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 362,
      "contract_no": "CTR-2026-0362",
      "generator_unit_id": 362,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.35,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 363,
      "contract_no": "CTR-2026-0363",
      "generator_unit_id": 363,
      "buyer_type": "Consumer",
      "buyer_id": 3,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.94,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 364,
      "contract_no": "CTR-2026-0364",
      "generator_unit_id": 364,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.9,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 365,
      "contract_no": "CTR-2026-0365",
      "generator_unit_id": 365,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.38,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 366,
      "contract_no": "CTR-2026-0366",
      "generator_unit_id": 366,
      "buyer_type": "Consumer",
      "buyer_id": 6,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 367,
      "contract_no": "CTR-2026-0367",
      "generator_unit_id": 367,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "EPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.39,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 368,
      "contract_no": "CTR-2026-0368",
      "generator_unit_id": 368,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.27,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 369,
      "contract_no": "CTR-2026-0369",
      "generator_unit_id": 369,
      "buyer_type": "Consumer",
      "buyer_id": 9,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.15,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 370,
      "contract_no": "CTR-2026-0370",
      "generator_unit_id": 370,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.27,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 371,
      "contract_no": "CTR-2026-0371",
      "generator_unit_id": 371,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.66,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 372,
      "contract_no": "CTR-2026-0372",
      "generator_unit_id": 372,
      "buyer_type": "Consumer",
      "buyer_id": 12,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.57,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 373,
      "contract_no": "CTR-2026-0373",
      "generator_unit_id": 373,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.28,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 374,
      "contract_no": "CTR-2026-0374",
      "generator_unit_id": 374,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.62,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 375,
      "contract_no": "CTR-2026-0375",
      "generator_unit_id": 375,
      "buyer_type": "Consumer",
      "buyer_id": 15,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 4.94,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 376,
      "contract_no": "CTR-2026-0376",
      "generator_unit_id": 376,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.62,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 377,
      "contract_no": "CTR-2026-0377",
      "generator_unit_id": 377,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.09,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 378,
      "contract_no": "CTR-2026-0378",
      "generator_unit_id": 378,
      "buyer_type": "Consumer",
      "buyer_id": 18,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 379,
      "contract_no": "CTR-2026-0379",
      "generator_unit_id": 379,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.77,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 380,
      "contract_no": "CTR-2026-0380",
      "generator_unit_id": 380,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.14,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 381,
      "contract_no": "CTR-2026-0381",
      "generator_unit_id": 381,
      "buyer_type": "Consumer",
      "buyer_id": 21,
      "contract_type": "Captive",
      "capacity_mw": 37.5,
      "rate_per_kwh": 2.85,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 382,
      "contract_no": "CTR-2026-0382",
      "generator_unit_id": 382,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.41,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 383,
      "contract_no": "CTR-2026-0383",
      "generator_unit_id": 383,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.47,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 384,
      "contract_no": "CTR-2026-0384",
      "generator_unit_id": 384,
      "buyer_type": "Consumer",
      "buyer_id": 24,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.37,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 385,
      "contract_no": "CTR-2026-0385",
      "generator_unit_id": 385,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.77,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 386,
      "contract_no": "CTR-2026-0386",
      "generator_unit_id": 386,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.1,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 387,
      "contract_no": "CTR-2026-0387",
      "generator_unit_id": 387,
      "buyer_type": "Consumer",
      "buyer_id": 27,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.66,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 388,
      "contract_no": "CTR-2026-0388",
      "generator_unit_id": 388,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "PPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.54,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 389,
      "contract_no": "CTR-2026-0389",
      "generator_unit_id": 389,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.24,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 390,
      "contract_no": "CTR-2026-0390",
      "generator_unit_id": 390,
      "buyer_type": "Consumer",
      "buyer_id": 30,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 391,
      "contract_no": "CTR-2026-0391",
      "generator_unit_id": 391,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "PPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.68,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 392,
      "contract_no": "CTR-2026-0392",
      "generator_unit_id": 392,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.06,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 393,
      "contract_no": "CTR-2026-0393",
      "generator_unit_id": 393,
      "buyer_type": "Consumer",
      "buyer_id": 33,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.19,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 394,
      "contract_no": "CTR-2026-0394",
      "generator_unit_id": 394,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.23,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 395,
      "contract_no": "CTR-2026-0395",
      "generator_unit_id": 395,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.96,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 396,
      "contract_no": "CTR-2026-0396",
      "generator_unit_id": 396,
      "buyer_type": "Consumer",
      "buyer_id": 36,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.94,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 397,
      "contract_no": "CTR-2026-0397",
      "generator_unit_id": 397,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 5.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 398,
      "contract_no": "CTR-2026-0398",
      "generator_unit_id": 398,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "Captive",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.32,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 399,
      "contract_no": "CTR-2026-0399",
      "generator_unit_id": 399,
      "buyer_type": "Consumer",
      "buyer_id": 39,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 400,
      "contract_no": "CTR-2026-0400",
      "generator_unit_id": 400,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 5.18,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 401,
      "contract_no": "CTR-2026-0401",
      "generator_unit_id": 401,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 5.04,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 402,
      "contract_no": "CTR-2026-0402",
      "generator_unit_id": 402,
      "buyer_type": "Consumer",
      "buyer_id": 2,
      "contract_type": "Captive",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.96,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 403,
      "contract_no": "CTR-2026-0403",
      "generator_unit_id": 403,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.75,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 404,
      "contract_no": "CTR-2026-0404",
      "generator_unit_id": 404,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.1,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 405,
      "contract_no": "CTR-2026-0405",
      "generator_unit_id": 405,
      "buyer_type": "Consumer",
      "buyer_id": 5,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.36,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 406,
      "contract_no": "CTR-2026-0406",
      "generator_unit_id": 406,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.62,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 407,
      "contract_no": "CTR-2026-0407",
      "generator_unit_id": 407,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.13,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 408,
      "contract_no": "CTR-2026-0408",
      "generator_unit_id": 408,
      "buyer_type": "Consumer",
      "buyer_id": 8,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 409,
      "contract_no": "CTR-2026-0409",
      "generator_unit_id": 409,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.54,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 410,
      "contract_no": "CTR-2026-0410",
      "generator_unit_id": 410,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.44,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 411,
      "contract_no": "CTR-2026-0411",
      "generator_unit_id": 411,
      "buyer_type": "Consumer",
      "buyer_id": 11,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.57,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 412,
      "contract_no": "CTR-2026-0412",
      "generator_unit_id": 412,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 2.96,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 413,
      "contract_no": "CTR-2026-0413",
      "generator_unit_id": 413,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 414,
      "contract_no": "CTR-2026-0414",
      "generator_unit_id": 414,
      "buyer_type": "Consumer",
      "buyer_id": 14,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.49,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 415,
      "contract_no": "CTR-2026-0415",
      "generator_unit_id": 415,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.84,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 416,
      "contract_no": "CTR-2026-0416",
      "generator_unit_id": 416,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 5.0,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 417,
      "contract_no": "CTR-2026-0417",
      "generator_unit_id": 417,
      "buyer_type": "Consumer",
      "buyer_id": 17,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.36,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 418,
      "contract_no": "CTR-2026-0418",
      "generator_unit_id": 418,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.85,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 419,
      "contract_no": "CTR-2026-0419",
      "generator_unit_id": 419,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.41,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 420,
      "contract_no": "CTR-2026-0420",
      "generator_unit_id": 420,
      "buyer_type": "Consumer",
      "buyer_id": 20,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.0,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 421,
      "contract_no": "CTR-2026-0421",
      "generator_unit_id": 421,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.84,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 422,
      "contract_no": "CTR-2026-0422",
      "generator_unit_id": 422,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.04,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 423,
      "contract_no": "CTR-2026-0423",
      "generator_unit_id": 423,
      "buyer_type": "Consumer",
      "buyer_id": 23,
      "contract_type": "PPA",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.47,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 424,
      "contract_no": "CTR-2026-0424",
      "generator_unit_id": 424,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "Open Access",
      "capacity_mw": 15.0,
      "rate_per_kwh": 3.22,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 425,
      "contract_no": "CTR-2026-0425",
      "generator_unit_id": 425,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 2.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 426,
      "contract_no": "CTR-2026-0426",
      "generator_unit_id": 426,
      "buyer_type": "Consumer",
      "buyer_id": 26,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.45,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 427,
      "contract_no": "CTR-2026-0427",
      "generator_unit_id": 427,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 5.37,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 428,
      "contract_no": "CTR-2026-0428",
      "generator_unit_id": 428,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.54,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 429,
      "contract_no": "CTR-2026-0429",
      "generator_unit_id": 429,
      "buyer_type": "Consumer",
      "buyer_id": 29,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.15,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 430,
      "contract_no": "CTR-2026-0430",
      "generator_unit_id": 430,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.29,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 431,
      "contract_no": "CTR-2026-0431",
      "generator_unit_id": 431,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.95,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 432,
      "contract_no": "CTR-2026-0432",
      "generator_unit_id": 432,
      "buyer_type": "Consumer",
      "buyer_id": 32,
      "contract_type": "PPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 5.13,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 433,
      "contract_no": "CTR-2026-0433",
      "generator_unit_id": 433,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.66,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 434,
      "contract_no": "CTR-2026-0434",
      "generator_unit_id": 434,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.49,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 435,
      "contract_no": "CTR-2026-0435",
      "generator_unit_id": 435,
      "buyer_type": "Consumer",
      "buyer_id": 35,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 436,
      "contract_no": "CTR-2026-0436",
      "generator_unit_id": 436,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 2.88,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 437,
      "contract_no": "CTR-2026-0437",
      "generator_unit_id": 437,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.48,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 438,
      "contract_no": "CTR-2026-0438",
      "generator_unit_id": 438,
      "buyer_type": "Consumer",
      "buyer_id": 38,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 2.84,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 439,
      "contract_no": "CTR-2026-0439",
      "generator_unit_id": 439,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "Open Access",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.47,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 440,
      "contract_no": "CTR-2026-0440",
      "generator_unit_id": 440,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.49,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 441,
      "contract_no": "CTR-2026-0441",
      "generator_unit_id": 441,
      "buyer_type": "Consumer",
      "buyer_id": 1,
      "contract_type": "EPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 5.31,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 442,
      "contract_no": "CTR-2026-0442",
      "generator_unit_id": 442,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.04,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 443,
      "contract_no": "CTR-2026-0443",
      "generator_unit_id": 443,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "Captive",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.23,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 444,
      "contract_no": "CTR-2026-0444",
      "generator_unit_id": 444,
      "buyer_type": "Consumer",
      "buyer_id": 4,
      "contract_type": "Open Access",
      "capacity_mw": 60.0,
      "rate_per_kwh": 4.65,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 445,
      "contract_no": "CTR-2026-0445",
      "generator_unit_id": 445,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.32,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 446,
      "contract_no": "CTR-2026-0446",
      "generator_unit_id": 446,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.8,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 447,
      "contract_no": "CTR-2026-0447",
      "generator_unit_id": 447,
      "buyer_type": "Consumer",
      "buyer_id": 7,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 2.98,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 448,
      "contract_no": "CTR-2026-0448",
      "generator_unit_id": 448,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.23,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 449,
      "contract_no": "CTR-2026-0449",
      "generator_unit_id": 449,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "PPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 5.49,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 450,
      "contract_no": "CTR-2026-0450",
      "generator_unit_id": 450,
      "buyer_type": "Consumer",
      "buyer_id": 10,
      "contract_type": "Captive",
      "capacity_mw": 37.5,
      "rate_per_kwh": 3.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 451,
      "contract_no": "CTR-2026-0451",
      "generator_unit_id": 451,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.5,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 452,
      "contract_no": "CTR-2026-0452",
      "generator_unit_id": 452,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "PPA",
      "capacity_mw": 60.0,
      "rate_per_kwh": 3.62,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 453,
      "contract_no": "CTR-2026-0453",
      "generator_unit_id": 453,
      "buyer_type": "Consumer",
      "buyer_id": 13,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.82,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 454,
      "contract_no": "CTR-2026-0454",
      "generator_unit_id": 454,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.28,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 455,
      "contract_no": "CTR-2026-0455",
      "generator_unit_id": 455,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "Open Access",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.63,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 456,
      "contract_no": "CTR-2026-0456",
      "generator_unit_id": 456,
      "buyer_type": "Consumer",
      "buyer_id": 16,
      "contract_type": "Captive",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.66,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 457,
      "contract_no": "CTR-2026-0457",
      "generator_unit_id": 457,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.49,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 458,
      "contract_no": "CTR-2026-0458",
      "generator_unit_id": 458,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 5.26,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 459,
      "contract_no": "CTR-2026-0459",
      "generator_unit_id": 459,
      "buyer_type": "Consumer",
      "buyer_id": 19,
      "contract_type": "PPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 5.27,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 460,
      "contract_no": "CTR-2026-0460",
      "generator_unit_id": 460,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Open Access",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.86,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 461,
      "contract_no": "CTR-2026-0461",
      "generator_unit_id": 461,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.66,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 462,
      "contract_no": "CTR-2026-0462",
      "generator_unit_id": 462,
      "buyer_type": "Consumer",
      "buyer_id": 22,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.27,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 463,
      "contract_no": "CTR-2026-0463",
      "generator_unit_id": 463,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 5.31,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 464,
      "contract_no": "CTR-2026-0464",
      "generator_unit_id": 464,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "Captive",
      "capacity_mw": 10.0,
      "rate_per_kwh": 5.18,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 465,
      "contract_no": "CTR-2026-0465",
      "generator_unit_id": 465,
      "buyer_type": "Consumer",
      "buyer_id": 25,
      "contract_type": "PPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 3.0,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 466,
      "contract_no": "CTR-2026-0466",
      "generator_unit_id": 466,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "EPA",
      "capacity_mw": 10.0,
      "rate_per_kwh": 4.89,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 467,
      "contract_no": "CTR-2026-0467",
      "generator_unit_id": 467,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 4.93,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 468,
      "contract_no": "CTR-2026-0468",
      "generator_unit_id": 468,
      "buyer_type": "Consumer",
      "buyer_id": 28,
      "contract_type": "EPA",
      "capacity_mw": 12.5,
      "rate_per_kwh": 3.0,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 469,
      "contract_no": "CTR-2026-0469",
      "generator_unit_id": 469,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "Captive",
      "capacity_mw": 37.5,
      "rate_per_kwh": 5.39,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 470,
      "contract_no": "CTR-2026-0470",
      "generator_unit_id": 470,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "EPA",
      "capacity_mw": 37.5,
      "rate_per_kwh": 4.67,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 471,
      "contract_no": "CTR-2026-0471",
      "generator_unit_id": 471,
      "buyer_type": "Consumer",
      "buyer_id": 31,
      "contract_type": "EPA",
      "capacity_mw": 75.0,
      "rate_per_kwh": 4.15,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 472,
      "contract_no": "CTR-2026-0472",
      "generator_unit_id": 472,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "Captive",
      "capacity_mw": 100.0,
      "rate_per_kwh": 5.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 473,
      "contract_no": "CTR-2026-0473",
      "generator_unit_id": 473,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "Open Access",
      "capacity_mw": 30.0,
      "rate_per_kwh": 3.48,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 474,
      "contract_no": "CTR-2026-0474",
      "generator_unit_id": 474,
      "buyer_type": "Consumer",
      "buyer_id": 34,
      "contract_type": "PPA",
      "capacity_mw": 30.0,
      "rate_per_kwh": 3.28,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 475,
      "contract_no": "CTR-2026-0475",
      "generator_unit_id": 475,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "Open Access",
      "capacity_mw": 120.0,
      "rate_per_kwh": 4.83,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 476,
      "contract_no": "CTR-2026-0476",
      "generator_unit_id": 476,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.65,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 477,
      "contract_no": "CTR-2026-0477",
      "generator_unit_id": 477,
      "buyer_type": "Consumer",
      "buyer_id": 37,
      "contract_type": "PPA",
      "capacity_mw": 30.0,
      "rate_per_kwh": 3.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 478,
      "contract_no": "CTR-2026-0478",
      "generator_unit_id": 478,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "Captive",
      "capacity_mw": 30.0,
      "rate_per_kwh": 4.13,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 479,
      "contract_no": "CTR-2026-0479",
      "generator_unit_id": 479,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.81,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 480,
      "contract_no": "CTR-2026-0480",
      "generator_unit_id": 480,
      "buyer_type": "Consumer",
      "buyer_id": 40,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.41,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 481,
      "contract_no": "CTR-2026-0481",
      "generator_unit_id": 481,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.38,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 482,
      "contract_no": "CTR-2026-0482",
      "generator_unit_id": 482,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "EPA",
      "capacity_mw": 120.0,
      "rate_per_kwh": 4.39,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 483,
      "contract_no": "CTR-2026-0483",
      "generator_unit_id": 483,
      "buyer_type": "Consumer",
      "buyer_id": 3,
      "contract_type": "Captive",
      "capacity_mw": 100.0,
      "rate_per_kwh": 5.03,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 484,
      "contract_no": "CTR-2026-0484",
      "generator_unit_id": 484,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "EPA",
      "capacity_mw": 120.0,
      "rate_per_kwh": 2.94,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 485,
      "contract_no": "CTR-2026-0485",
      "generator_unit_id": 485,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Open Access",
      "capacity_mw": 75.0,
      "rate_per_kwh": 4.67,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 486,
      "contract_no": "CTR-2026-0486",
      "generator_unit_id": 486,
      "buyer_type": "Consumer",
      "buyer_id": 6,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 2.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 487,
      "contract_no": "CTR-2026-0487",
      "generator_unit_id": 487,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "EPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.18,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 488,
      "contract_no": "CTR-2026-0488",
      "generator_unit_id": 488,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "Open Access",
      "capacity_mw": 75.0,
      "rate_per_kwh": 4.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 489,
      "contract_no": "CTR-2026-0489",
      "generator_unit_id": 489,
      "buyer_type": "Consumer",
      "buyer_id": 9,
      "contract_type": "EPA",
      "capacity_mw": 120.0,
      "rate_per_kwh": 4.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 490,
      "contract_no": "CTR-2026-0490",
      "generator_unit_id": 490,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "PPA",
      "capacity_mw": 40.0,
      "rate_per_kwh": 4.05,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 491,
      "contract_no": "CTR-2026-0491",
      "generator_unit_id": 491,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 2.89,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 492,
      "contract_no": "CTR-2026-0492",
      "generator_unit_id": 492,
      "buyer_type": "Consumer",
      "buyer_id": 12,
      "contract_type": "EPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.67,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 493,
      "contract_no": "CTR-2026-0493",
      "generator_unit_id": 493,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "PPA",
      "capacity_mw": 75.0,
      "rate_per_kwh": 3.68,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 494,
      "contract_no": "CTR-2026-0494",
      "generator_unit_id": 494,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "PPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.17,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 495,
      "contract_no": "CTR-2026-0495",
      "generator_unit_id": 495,
      "buyer_type": "Consumer",
      "buyer_id": 15,
      "contract_type": "Open Access",
      "capacity_mw": 120.0,
      "rate_per_kwh": 5.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 496,
      "contract_no": "CTR-2026-0496",
      "generator_unit_id": 496,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.73,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 497,
      "contract_no": "CTR-2026-0497",
      "generator_unit_id": 497,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "Captive",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.09,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 498,
      "contract_no": "CTR-2026-0498",
      "generator_unit_id": 498,
      "buyer_type": "Consumer",
      "buyer_id": 18,
      "contract_type": "Captive",
      "capacity_mw": 30.0,
      "rate_per_kwh": 2.97,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 499,
      "contract_no": "CTR-2026-0499",
      "generator_unit_id": 499,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "Captive",
      "capacity_mw": 30.0,
      "rate_per_kwh": 5.06,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 500,
      "contract_no": "CTR-2026-0500",
      "generator_unit_id": 500,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.69,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 501,
      "contract_no": "CTR-2026-0501",
      "generator_unit_id": 501,
      "buyer_type": "Consumer",
      "buyer_id": 21,
      "contract_type": "EPA",
      "capacity_mw": 40.0,
      "rate_per_kwh": 5.31,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 502,
      "contract_no": "CTR-2026-0502",
      "generator_unit_id": 502,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "EPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 4.45,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 503,
      "contract_no": "CTR-2026-0503",
      "generator_unit_id": 503,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "EPA",
      "capacity_mw": 40.0,
      "rate_per_kwh": 3.86,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 504,
      "contract_no": "CTR-2026-0504",
      "generator_unit_id": 504,
      "buyer_type": "Consumer",
      "buyer_id": 24,
      "contract_type": "Captive",
      "capacity_mw": 100.0,
      "rate_per_kwh": 5.14,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 505,
      "contract_no": "CTR-2026-0505",
      "generator_unit_id": 505,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "PPA",
      "capacity_mw": 40.0,
      "rate_per_kwh": 3.78,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 506,
      "contract_no": "CTR-2026-0506",
      "generator_unit_id": 506,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Open Access",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.1,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 507,
      "contract_no": "CTR-2026-0507",
      "generator_unit_id": 507,
      "buyer_type": "Consumer",
      "buyer_id": 27,
      "contract_type": "Open Access",
      "capacity_mw": 75.0,
      "rate_per_kwh": 4.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 508,
      "contract_no": "CTR-2026-0508",
      "generator_unit_id": 508,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "Captive",
      "capacity_mw": 75.0,
      "rate_per_kwh": 4.17,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 509,
      "contract_no": "CTR-2026-0509",
      "generator_unit_id": 509,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "Open Access",
      "capacity_mw": 120.0,
      "rate_per_kwh": 4.77,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 510,
      "contract_no": "CTR-2026-0510",
      "generator_unit_id": 510,
      "buyer_type": "Consumer",
      "buyer_id": 30,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.4,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 511,
      "contract_no": "CTR-2026-0511",
      "generator_unit_id": 511,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.45,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 512,
      "contract_no": "CTR-2026-0512",
      "generator_unit_id": 512,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "EPA",
      "capacity_mw": 30.0,
      "rate_per_kwh": 3.12,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 513,
      "contract_no": "CTR-2026-0513",
      "generator_unit_id": 513,
      "buyer_type": "Consumer",
      "buyer_id": 33,
      "contract_type": "EPA",
      "capacity_mw": 75.0,
      "rate_per_kwh": 4.51,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 514,
      "contract_no": "CTR-2026-0514",
      "generator_unit_id": 514,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "Open Access",
      "capacity_mw": 120.0,
      "rate_per_kwh": 3.79,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 515,
      "contract_no": "CTR-2026-0515",
      "generator_unit_id": 515,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 2.98,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 516,
      "contract_no": "CTR-2026-0516",
      "generator_unit_id": 516,
      "buyer_type": "Consumer",
      "buyer_id": 36,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.37,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 517,
      "contract_no": "CTR-2026-0517",
      "generator_unit_id": 517,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "Captive",
      "capacity_mw": 120.0,
      "rate_per_kwh": 4.73,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 518,
      "contract_no": "CTR-2026-0518",
      "generator_unit_id": 518,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.02,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 519,
      "contract_no": "CTR-2026-0519",
      "generator_unit_id": 519,
      "buyer_type": "Consumer",
      "buyer_id": 39,
      "contract_type": "Open Access",
      "capacity_mw": 40.0,
      "rate_per_kwh": 4.72,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 520,
      "contract_no": "CTR-2026-0520",
      "generator_unit_id": 520,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 521,
      "contract_no": "CTR-2026-0521",
      "generator_unit_id": 521,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.98,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 522,
      "contract_no": "CTR-2026-0522",
      "generator_unit_id": 522,
      "buyer_type": "Consumer",
      "buyer_id": 2,
      "contract_type": "PPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.21,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 523,
      "contract_no": "CTR-2026-0523",
      "generator_unit_id": 523,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.22,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 524,
      "contract_no": "CTR-2026-0524",
      "generator_unit_id": 524,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "EPA",
      "capacity_mw": 40.0,
      "rate_per_kwh": 3.35,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 525,
      "contract_no": "CTR-2026-0525",
      "generator_unit_id": 525,
      "buyer_type": "Consumer",
      "buyer_id": 5,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.06,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 526,
      "contract_no": "CTR-2026-0526",
      "generator_unit_id": 526,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "Captive",
      "capacity_mw": 40.0,
      "rate_per_kwh": 3.34,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 527,
      "contract_no": "CTR-2026-0527",
      "generator_unit_id": 527,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "Captive",
      "capacity_mw": 40.0,
      "rate_per_kwh": 4.84,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 528,
      "contract_no": "CTR-2026-0528",
      "generator_unit_id": 528,
      "buyer_type": "Consumer",
      "buyer_id": 8,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.15,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 529,
      "contract_no": "CTR-2026-0529",
      "generator_unit_id": 529,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "EPA",
      "capacity_mw": 30.0,
      "rate_per_kwh": 4.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 530,
      "contract_no": "CTR-2026-0530",
      "generator_unit_id": 530,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "Open Access",
      "capacity_mw": 40.0,
      "rate_per_kwh": 4.26,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 531,
      "contract_no": "CTR-2026-0531",
      "generator_unit_id": 531,
      "buyer_type": "Consumer",
      "buyer_id": 11,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.97,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 532,
      "contract_no": "CTR-2026-0532",
      "generator_unit_id": 532,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.76,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 533,
      "contract_no": "CTR-2026-0533",
      "generator_unit_id": 533,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "Captive",
      "capacity_mw": 100.0,
      "rate_per_kwh": 4.11,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 534,
      "contract_no": "CTR-2026-0534",
      "generator_unit_id": 534,
      "buyer_type": "Consumer",
      "buyer_id": 14,
      "contract_type": "PPA",
      "capacity_mw": 120.0,
      "rate_per_kwh": 3.86,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 535,
      "contract_no": "CTR-2026-0535",
      "generator_unit_id": 535,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Open Access",
      "capacity_mw": 40.0,
      "rate_per_kwh": 4.7,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 536,
      "contract_no": "CTR-2026-0536",
      "generator_unit_id": 536,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "Open Access",
      "capacity_mw": 30.0,
      "rate_per_kwh": 4.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 537,
      "contract_no": "CTR-2026-0537",
      "generator_unit_id": 537,
      "buyer_type": "Consumer",
      "buyer_id": 17,
      "contract_type": "PPA",
      "capacity_mw": 30.0,
      "rate_per_kwh": 3.03,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 538,
      "contract_no": "CTR-2026-0538",
      "generator_unit_id": 538,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.24,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 539,
      "contract_no": "CTR-2026-0539",
      "generator_unit_id": 539,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "Open Access",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.95,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 540,
      "contract_no": "CTR-2026-0540",
      "generator_unit_id": 540,
      "buyer_type": "Consumer",
      "buyer_id": 20,
      "contract_type": "PPA",
      "capacity_mw": 75.0,
      "rate_per_kwh": 3.75,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 541,
      "contract_no": "CTR-2026-0541",
      "generator_unit_id": 541,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "Captive",
      "capacity_mw": 120.0,
      "rate_per_kwh": 4.93,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 542,
      "contract_no": "CTR-2026-0542",
      "generator_unit_id": 542,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "Captive",
      "capacity_mw": 30.0,
      "rate_per_kwh": 5.36,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 543,
      "contract_no": "CTR-2026-0543",
      "generator_unit_id": 543,
      "buyer_type": "Consumer",
      "buyer_id": 23,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.36,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 544,
      "contract_no": "CTR-2026-0544",
      "generator_unit_id": 544,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.19,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 545,
      "contract_no": "CTR-2026-0545",
      "generator_unit_id": 545,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "EPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.1,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 546,
      "contract_no": "CTR-2026-0546",
      "generator_unit_id": 546,
      "buyer_type": "Consumer",
      "buyer_id": 26,
      "contract_type": "Captive",
      "capacity_mw": 100.0,
      "rate_per_kwh": 5.17,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 547,
      "contract_no": "CTR-2026-0547",
      "generator_unit_id": 547,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "PPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 5.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 548,
      "contract_no": "CTR-2026-0548",
      "generator_unit_id": 548,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "Captive",
      "capacity_mw": 40.0,
      "rate_per_kwh": 4.73,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 549,
      "contract_no": "CTR-2026-0549",
      "generator_unit_id": 549,
      "buyer_type": "Consumer",
      "buyer_id": 29,
      "contract_type": "Open Access",
      "capacity_mw": 100.0,
      "rate_per_kwh": 5.11,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 550,
      "contract_no": "CTR-2026-0550",
      "generator_unit_id": 550,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.19,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 551,
      "contract_no": "CTR-2026-0551",
      "generator_unit_id": 551,
      "buyer_type": "Utility",
      "buyer_id": 1,
      "contract_type": "Open Access",
      "capacity_mw": 100.0,
      "rate_per_kwh": 4.64,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 552,
      "contract_no": "CTR-2026-0552",
      "generator_unit_id": 552,
      "buyer_type": "Consumer",
      "buyer_id": 32,
      "contract_type": "Captive",
      "capacity_mw": 100.0,
      "rate_per_kwh": 4.21,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 553,
      "contract_no": "CTR-2026-0553",
      "generator_unit_id": 553,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "PPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.36,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 554,
      "contract_no": "CTR-2026-0554",
      "generator_unit_id": 554,
      "buyer_type": "Utility",
      "buyer_id": 4,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.09,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 555,
      "contract_no": "CTR-2026-0555",
      "generator_unit_id": 555,
      "buyer_type": "Consumer",
      "buyer_id": 35,
      "contract_type": "Captive",
      "capacity_mw": 20.0,
      "rate_per_kwh": 5.45,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 556,
      "contract_no": "CTR-2026-0556",
      "generator_unit_id": 556,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.11,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 557,
      "contract_no": "CTR-2026-0557",
      "generator_unit_id": 557,
      "buyer_type": "Utility",
      "buyer_id": 7,
      "contract_type": "EPA",
      "capacity_mw": 30.0,
      "rate_per_kwh": 5.15,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 558,
      "contract_no": "CTR-2026-0558",
      "generator_unit_id": 558,
      "buyer_type": "Consumer",
      "buyer_id": 38,
      "contract_type": "PPA",
      "capacity_mw": 120.0,
      "rate_per_kwh": 4.08,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 559,
      "contract_no": "CTR-2026-0559",
      "generator_unit_id": 559,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "EPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.68,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 560,
      "contract_no": "CTR-2026-0560",
      "generator_unit_id": 560,
      "buyer_type": "Utility",
      "buyer_id": 10,
      "contract_type": "Open Access",
      "capacity_mw": 40.0,
      "rate_per_kwh": 5.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 561,
      "contract_no": "CTR-2026-0561",
      "generator_unit_id": 561,
      "buyer_type": "Consumer",
      "buyer_id": 1,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.0,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 562,
      "contract_no": "CTR-2026-0562",
      "generator_unit_id": 562,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "Open Access",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.64,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 563,
      "contract_no": "CTR-2026-0563",
      "generator_unit_id": 563,
      "buyer_type": "Utility",
      "buyer_id": 13,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.33,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 564,
      "contract_no": "CTR-2026-0564",
      "generator_unit_id": 564,
      "buyer_type": "Consumer",
      "buyer_id": 4,
      "contract_type": "EPA",
      "capacity_mw": 120.0,
      "rate_per_kwh": 3.34,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 565,
      "contract_no": "CTR-2026-0565",
      "generator_unit_id": 565,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "Captive",
      "capacity_mw": 40.0,
      "rate_per_kwh": 5.08,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 566,
      "contract_no": "CTR-2026-0566",
      "generator_unit_id": 566,
      "buyer_type": "Utility",
      "buyer_id": 16,
      "contract_type": "Captive",
      "capacity_mw": 30.0,
      "rate_per_kwh": 3.78,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 567,
      "contract_no": "CTR-2026-0567",
      "generator_unit_id": 567,
      "buyer_type": "Consumer",
      "buyer_id": 7,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 5.5,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 568,
      "contract_no": "CTR-2026-0568",
      "generator_unit_id": 568,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "EPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 5.4,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 569,
      "contract_no": "CTR-2026-0569",
      "generator_unit_id": 569,
      "buyer_type": "Utility",
      "buyer_id": 19,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.37,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 570,
      "contract_no": "CTR-2026-0570",
      "generator_unit_id": 570,
      "buyer_type": "Consumer",
      "buyer_id": 10,
      "contract_type": "Captive",
      "capacity_mw": 120.0,
      "rate_per_kwh": 3.28,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 571,
      "contract_no": "CTR-2026-0571",
      "generator_unit_id": 571,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "EPA",
      "capacity_mw": 75.0,
      "rate_per_kwh": 3.24,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 572,
      "contract_no": "CTR-2026-0572",
      "generator_unit_id": 572,
      "buyer_type": "Utility",
      "buyer_id": 22,
      "contract_type": "EPA",
      "capacity_mw": 30.0,
      "rate_per_kwh": 5.25,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 573,
      "contract_no": "CTR-2026-0573",
      "generator_unit_id": 573,
      "buyer_type": "Consumer",
      "buyer_id": 13,
      "contract_type": "PPA",
      "capacity_mw": 120.0,
      "rate_per_kwh": 3.74,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 574,
      "contract_no": "CTR-2026-0574",
      "generator_unit_id": 574,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "PPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.3,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 575,
      "contract_no": "CTR-2026-0575",
      "generator_unit_id": 575,
      "buyer_type": "Utility",
      "buyer_id": 25,
      "contract_type": "Open Access",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.45,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 576,
      "contract_no": "CTR-2026-0576",
      "generator_unit_id": 576,
      "buyer_type": "Consumer",
      "buyer_id": 16,
      "contract_type": "EPA",
      "capacity_mw": 25.0,
      "rate_per_kwh": 4.88,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 577,
      "contract_no": "CTR-2026-0577",
      "generator_unit_id": 577,
      "buyer_type": "Utility",
      "buyer_id": 2,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.06,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 578,
      "contract_no": "CTR-2026-0578",
      "generator_unit_id": 578,
      "buyer_type": "Utility",
      "buyer_id": 3,
      "contract_type": "EPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.44,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 579,
      "contract_no": "CTR-2026-0579",
      "generator_unit_id": 579,
      "buyer_type": "Consumer",
      "buyer_id": 19,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 4.05,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 580,
      "contract_no": "CTR-2026-0580",
      "generator_unit_id": 580,
      "buyer_type": "Utility",
      "buyer_id": 5,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 2.93,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 581,
      "contract_no": "CTR-2026-0581",
      "generator_unit_id": 581,
      "buyer_type": "Utility",
      "buyer_id": 6,
      "contract_type": "Captive",
      "capacity_mw": 50.0,
      "rate_per_kwh": 3.92,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 582,
      "contract_no": "CTR-2026-0582",
      "generator_unit_id": 582,
      "buyer_type": "Consumer",
      "buyer_id": 22,
      "contract_type": "PPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 4.94,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 583,
      "contract_no": "CTR-2026-0583",
      "generator_unit_id": 583,
      "buyer_type": "Utility",
      "buyer_id": 8,
      "contract_type": "Open Access",
      "capacity_mw": 75.0,
      "rate_per_kwh": 3.11,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 584,
      "contract_no": "CTR-2026-0584",
      "generator_unit_id": 584,
      "buyer_type": "Utility",
      "buyer_id": 9,
      "contract_type": "Open Access",
      "capacity_mw": 25.0,
      "rate_per_kwh": 3.48,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 585,
      "contract_no": "CTR-2026-0585",
      "generator_unit_id": 585,
      "buyer_type": "Consumer",
      "buyer_id": 25,
      "contract_type": "Captive",
      "capacity_mw": 120.0,
      "rate_per_kwh": 4.66,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 586,
      "contract_no": "CTR-2026-0586",
      "generator_unit_id": 586,
      "buyer_type": "Utility",
      "buyer_id": 11,
      "contract_type": "Captive",
      "capacity_mw": 75.0,
      "rate_per_kwh": 4.13,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 587,
      "contract_no": "CTR-2026-0587",
      "generator_unit_id": 587,
      "buyer_type": "Utility",
      "buyer_id": 12,
      "contract_type": "Captive",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.94,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 588,
      "contract_no": "CTR-2026-0588",
      "generator_unit_id": 588,
      "buyer_type": "Consumer",
      "buyer_id": 28,
      "contract_type": "PPA",
      "capacity_mw": 40.0,
      "rate_per_kwh": 4.38,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 589,
      "contract_no": "CTR-2026-0589",
      "generator_unit_id": 589,
      "buyer_type": "Utility",
      "buyer_id": 14,
      "contract_type": "PPA",
      "capacity_mw": 40.0,
      "rate_per_kwh": 3.95,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 590,
      "contract_no": "CTR-2026-0590",
      "generator_unit_id": 590,
      "buyer_type": "Utility",
      "buyer_id": 15,
      "contract_type": "EPA",
      "capacity_mw": 75.0,
      "rate_per_kwh": 4.87,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 591,
      "contract_no": "CTR-2026-0591",
      "generator_unit_id": 591,
      "buyer_type": "Consumer",
      "buyer_id": 31,
      "contract_type": "EPA",
      "capacity_mw": 30.0,
      "rate_per_kwh": 3.2,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 592,
      "contract_no": "CTR-2026-0592",
      "generator_unit_id": 592,
      "buyer_type": "Utility",
      "buyer_id": 17,
      "contract_type": "PPA",
      "capacity_mw": 50.0,
      "rate_per_kwh": 4.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 593,
      "contract_no": "CTR-2026-0593",
      "generator_unit_id": 593,
      "buyer_type": "Utility",
      "buyer_id": 18,
      "contract_type": "Captive",
      "capacity_mw": 40.0,
      "rate_per_kwh": 4.65,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 594,
      "contract_no": "CTR-2026-0594",
      "generator_unit_id": 594,
      "buyer_type": "Consumer",
      "buyer_id": 34,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 5.27,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 595,
      "contract_no": "CTR-2026-0595",
      "generator_unit_id": 595,
      "buyer_type": "Utility",
      "buyer_id": 20,
      "contract_type": "EPA",
      "capacity_mw": 120.0,
      "rate_per_kwh": 4.58,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 596,
      "contract_no": "CTR-2026-0596",
      "generator_unit_id": 596,
      "buyer_type": "Utility",
      "buyer_id": 21,
      "contract_type": "Open Access",
      "capacity_mw": 75.0,
      "rate_per_kwh": 3.46,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 597,
      "contract_no": "CTR-2026-0597",
      "generator_unit_id": 597,
      "buyer_type": "Consumer",
      "buyer_id": 37,
      "contract_type": "Open Access",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.31,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 598,
      "contract_no": "CTR-2026-0598",
      "generator_unit_id": 598,
      "buyer_type": "Utility",
      "buyer_id": 23,
      "contract_type": "Open Access",
      "capacity_mw": 75.0,
      "rate_per_kwh": 3.19,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 599,
      "contract_no": "CTR-2026-0599",
      "generator_unit_id": 599,
      "buyer_type": "Utility",
      "buyer_id": 24,
      "contract_type": "PPA",
      "capacity_mw": 100.0,
      "rate_per_kwh": 3.52,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    },
    {
      "contract_id": 600,
      "contract_no": "CTR-2026-0600",
      "generator_unit_id": 600,
      "buyer_type": "Consumer",
      "buyer_id": 40,
      "contract_type": "PPA",
      "capacity_mw": 20.0,
      "rate_per_kwh": 3.7,
      "effective_from": "2026-04-01",
      "effective_to": "2031-03-31",
      "status": "Active"
    }
  ],
  "msldc_users": [
    {
      "user_id": 1,
      "name": "MSLDC User 1",
      "role": "Super Admin",
      "email": "user1@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 2,
      "name": "MSLDC User 2",
      "role": "Section Admin OP",
      "email": "user2@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 3,
      "name": "MSLDC User 3",
      "role": "Section Admin EA",
      "email": "user3@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 4,
      "name": "MSLDC User 4",
      "role": "Section Admin SCADA",
      "email": "user4@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 5,
      "name": "MSLDC User 5",
      "role": "User OP",
      "email": "user5@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 6,
      "name": "MSLDC User 6",
      "role": "User EA",
      "email": "user6@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 7,
      "name": "MSLDC User 7",
      "role": "User SCADA",
      "email": "user7@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 8,
      "name": "MSLDC User 8",
      "role": "Super Admin",
      "email": "user8@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 9,
      "name": "MSLDC User 9",
      "role": "Section Admin OP",
      "email": "user9@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 10,
      "name": "MSLDC User 10",
      "role": "Section Admin EA",
      "email": "user10@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 11,
      "name": "MSLDC User 11",
      "role": "Section Admin SCADA",
      "email": "user11@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 12,
      "name": "MSLDC User 12",
      "role": "User OP",
      "email": "user12@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 13,
      "name": "MSLDC User 13",
      "role": "User EA",
      "email": "user13@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 14,
      "name": "MSLDC User 14",
      "role": "User SCADA",
      "email": "user14@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 15,
      "name": "MSLDC User 15",
      "role": "Super Admin",
      "email": "user15@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 16,
      "name": "MSLDC User 16",
      "role": "Section Admin OP",
      "email": "user16@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 17,
      "name": "MSLDC User 17",
      "role": "Section Admin EA",
      "email": "user17@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 18,
      "name": "MSLDC User 18",
      "role": "Section Admin SCADA",
      "email": "user18@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 19,
      "name": "MSLDC User 19",
      "role": "User OP",
      "email": "user19@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 20,
      "name": "MSLDC User 20",
      "role": "User EA",
      "email": "user20@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 21,
      "name": "MSLDC User 21",
      "role": "User SCADA",
      "email": "user21@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 22,
      "name": "MSLDC User 22",
      "role": "Super Admin",
      "email": "user22@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 23,
      "name": "MSLDC User 23",
      "role": "Section Admin OP",
      "email": "user23@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 24,
      "name": "MSLDC User 24",
      "role": "Section Admin EA",
      "email": "user24@msldc.in",
      "status": "Active"
    },
    {
      "user_id": 25,
      "name": "MSLDC User 25",
      "role": "Section Admin SCADA",
      "email": "user25@msldc.in",
      "status": "Active"
    }
  ]
}
